/*
Copyright (C) Anheuser-Busch InBev SA/NV. ALL RIGHTS RESERVED.

This software product is a proprietary product of Anheuser-Busch Inbev SA/NV (the "Company") and all right, title, and interest in and to the software product, including all associated intellectual property rights, are and shall remain exclusively with the Company. All rights in or to the software product are licensed, not sold. All rights not licensed are reserved.

This software product is governed by the End User License Agreement provided with the software product.

*/
import * as e from "react";
import t, { useCallback as n, useContext as r, useEffect as i, useMemo as a, useReducer as o, useRef as s, useState as c } from "react";
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/utils/Constants.mjs
var l = "msal.js.common", u = "https://login.microsoftonline.com/common/", d = "login.microsoftonline.com", f = "common", p = "adfs", m = "dstsv2", h = `${u}discovery/instance?api-version=1.1&authorization_endpoint=`, ee = ".ciamlogin.com", g = ".onmicrosoft.com", te = "openid", ne = "profile", re = "offline_access", ie = "email", ae = "S256", oe = "application/x-www-form-urlencoded;charset=utf-8", se = "http://169.254.169.254/metadata/instance/compute/location", ce = "2020-06-01", le = 2e3, ue = "login.microsoft.com", de = [
	"login.microsoftonline.com",
	"login.windows.net",
	"login.microsoft.com",
	"sts.windows.net"
], fe = {
	GET: "GET",
	POST: "POST"
}, pe = [
	te,
	ne,
	re
], me = [...pe, ie], _ = {
	CONTENT_TYPE: "Content-Type",
	CONTENT_LENGTH: "Content-Length",
	RETRY_AFTER: "Retry-After",
	CCS_HEADER: "X-AnchorMailbox",
	WWWAuthenticate: "WWW-Authenticate",
	AuthenticationInfo: "Authentication-Info",
	X_MS_REQUEST_ID: "x-ms-request-id",
	X_MS_HTTP_VERSION: "x-ms-httpver"
}, he = { ACTIVE_ACCOUNT_FILTERS: "active-account-filters" }, ge = {
	COMMON: "common",
	ORGANIZATIONS: "organizations",
	CONSUMERS: "consumers"
}, _e = {
	ACCESS_TOKEN: "access_token",
	XMS_CC: "xms_cc"
}, v = {
	LOGIN: "login",
	SELECT_ACCOUNT: "select_account",
	CONSENT: "consent",
	NONE: "none",
	CREATE: "create",
	NO_SESSION: "no_session"
}, ve = {
	CODE: "code",
	IDTOKEN_TOKEN: "id_token token",
	IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
}, ye = {
	QUERY: "query",
	FRAGMENT: "fragment",
	FORM_POST: "form_post"
}, be = {
	IMPLICIT_GRANT: "implicit",
	AUTHORIZATION_CODE_GRANT: "authorization_code",
	CLIENT_CREDENTIALS_GRANT: "client_credentials",
	RESOURCE_OWNER_PASSWORD_GRANT: "password",
	REFRESH_TOKEN_GRANT: "refresh_token",
	DEVICE_CODE_GRANT: "device_code",
	JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
}, xe = "MSSTS", Se = "ADFS", Ce = "Generic", y = {
	ID_TOKEN: "IdToken",
	ACCESS_TOKEN: "AccessToken",
	ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
	REFRESH_TOKEN: "RefreshToken"
}, we = "appmetadata", Te = "client_info", Ee = "authority-metadata", De = 3600 * 24, b = {
	CONFIG: "config",
	CACHE: "cache",
	NETWORK: "network",
	HARDCODED_VALUES: "hardcoded_values"
}, Oe = "server-telemetry", ke = "unknown_error", x = {
	BEARER: "Bearer",
	POP: "pop",
	SSH: "ssh-cert"
}, Ae = 3600, je = "throttling", Me = "retry-after, h429", Ne = {
	FAILED_AUTO_DETECTION: "1",
	INTERNAL_CACHE: "2",
	ENVIRONMENT_VARIABLE: "3",
	IMDS: "4"
}, Pe = {
	CONFIGURED_MATCHES_DETECTED: "1",
	CONFIGURED_NO_AUTO_DETECTION: "2",
	CONFIGURED_NOT_DETECTED: "3",
	AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
	AUTO_DETECTION_REQUESTED_FAILED: "5"
}, Fe = {
	NOT_APPLICABLE: "0",
	FORCE_REFRESH_OR_CLAIMS: "1",
	NO_CACHED_ACCESS_TOKEN: "2",
	CACHED_ACCESS_TOKEN_EXPIRED: "3",
	PROACTIVELY_REFRESHED: "4"
}, Ie = {
	Jwt: "JWT",
	Jwk: "JWK",
	Pop: "pop"
}, Le = "client_id", Re = "redirect_uri", ze = "response_type", Be = "response_mode", Ve = "grant_type", He = "claims", Ue = "scope", We = "refresh_token", Ge = "state", Ke = "nonce", qe = "prompt", Je = "code", Ye = "code_challenge", Xe = "code_challenge_method", Ze = "code_verifier", Qe = "client-request-id", $e = "x-client-SKU", et = "x-client-VER", tt = "x-client-OS", nt = "x-client-CPU", rt = "x-client-current-telemetry", it = "x-client-last-telemetry", at = "x-ms-lib-capability", ot = "x-app-name", st = "x-app-ver", ct = "post_logout_redirect_uri", lt = "id_token_hint", ut = "client_secret", dt = "client_assertion", ft = "client_assertion_type", pt = "token_type", mt = "req_cnf", ht = "return_spa_code", gt = "nativebroker", _t = "logout_hint", vt = "login_hint", yt = "domain_hint", bt = "x-client-xtra-sku", xt = "brk_client_id", St = "brk_redirect_uri", Ct = "instance_aware", wt = "ear_jwk", Tt = "ear_jwe_crypto", Et = "resource", Dt = "clidata";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/AuthError.mjs
function Ot(e) {
	return `See https://aka.ms/msal.js.errors#${e} for details`;
}
var S = class e extends Error {
	constructor(t, n, r) {
		let i = n || (t ? Ot(t) : ""), a = i ? `${t}: ${i}` : t;
		super(a), Object.setPrototypeOf(this, e.prototype), this.errorCode = t || "", this.errorMessage = i || "", this.subError = r || "", this.name = "AuthError";
	}
	setCorrelationId(e) {
		this.correlationId = e;
	}
};
function kt(e, t) {
	return new S(e, t || Ot(e));
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/ClientConfigurationError.mjs
var At = class e extends S {
	constructor(t) {
		super(t), this.name = "ClientConfigurationError", Object.setPrototypeOf(this, e.prototype);
	}
};
function C(e) {
	return new At(e);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/utils/StringUtils.mjs
var w = class {
	static isEmptyObj(e) {
		if (e) try {
			let t = JSON.parse(e);
			return Object.keys(t).length === 0;
		} catch {}
		return !0;
	}
	static startsWith(e, t) {
		return e.indexOf(t) === 0;
	}
	static endsWith(e, t) {
		return e.length >= t.length && e.lastIndexOf(t) === e.length - t.length;
	}
	static queryStringToObject(e) {
		let t = {}, n = e.split("&"), r = (e) => decodeURIComponent(e.replace(/\+/g, " "));
		return n.forEach((e) => {
			if (e.trim()) {
				let [n, i] = e.split(/=(.+)/g, 2);
				n && i && (t[r(n)] = r(i));
			}
		}), t;
	}
	static trimArrayEntries(e) {
		return e.map((e) => e.trim());
	}
	static removeEmptyStringsFromArray(e) {
		return e.filter((e) => !!e);
	}
	static jsonParseHelper(e) {
		try {
			return JSON.parse(e);
		} catch {
			return null;
		}
	}
}, jt = class e extends S {
	constructor(t, n) {
		super(t, n), this.name = "ClientAuthError", Object.setPrototypeOf(this, e.prototype);
	}
};
function T(e, t) {
	return new jt(e, t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/ClientConfigurationErrorCodes.mjs
var Mt = "redirect_uri_empty", Nt = "authority_uri_insecure", Pt = "url_parse_error", Ft = "empty_url_error", It = "empty_input_scopes_error", Lt = "invalid_claims", Rt = "token_request_empty", zt = "logout_request_empty", Bt = "pkce_params_missing", Vt = "invalid_cloud_discovery_metadata", Ht = "invalid_authority_metadata", Ut = "untrusted_authority", Wt = "missing_ssh_jwk", Gt = "missing_ssh_kid", Kt = "cannot_set_OIDCOptions", qt = "cannot_allow_platform_broker", Jt = "authority_mismatch", Yt = "invalid_request_method_for_EAR", Xt = "invalid_platform_broker_configuration", Zt = "issuer_validation_failed", Qt = "client_info_decoding_error", $t = "client_info_empty_error", en = "token_parsing_error", tn = "null_or_empty_token", nn = "endpoints_resolution_error", rn = "network_error", an = "openid_config_error", on = "hash_not_deserialized", sn = "invalid_state", cn = "state_mismatch", ln = "state_not_found", un = "nonce_mismatch", dn = "auth_time_not_found", fn = "max_age_transpired", pn = "multiple_matching_appMetadata", mn = "request_cannot_be_made", hn = "cannot_remove_empty_scope", gn = "cannot_append_scopeset", _n = "empty_input_scopeset", vn = "no_account_in_silent_request", yn = "invalid_cache_record", bn = "invalid_cache_environment", xn = "no_account_found", Sn = "no_crypto_object", Cn = "token_refresh_required", wn = "token_claims_cnf_required_for_signedjwt", Tn = "authorization_code_missing_from_server_response", En = "binding_key_not_removed", Dn = "end_session_endpoint_not_supported", On = "key_id_missing", E = "method_not_implemented", kn = "resource_parameter_required", An = "misplaced_resource_parameter", D = class e {
	constructor(e) {
		let t = e ? w.trimArrayEntries([...e]) : [], n = t ? w.removeEmptyStringsFromArray(t) : [];
		if (!n || !n.length) throw C(It);
		this.scopes = /* @__PURE__ */ new Set(), n.forEach((e) => this.scopes.add(e));
	}
	static fromString(t) {
		let n = (t || "").split(" ");
		return new e(n);
	}
	static createSearchScopes(t) {
		let n = t && t.length > 0 ? t : [...pe], r = new e(n);
		return r.containsOnlyOIDCScopes() ? r.removeScope(re) : r.removeOIDCScopes(), r;
	}
	containsScope(t) {
		let n = this.printScopesLowerCase().split(" "), r = new e(n);
		return t ? r.scopes.has(t.toLowerCase()) : !1;
	}
	containsScopeSet(e) {
		return !e || e.scopes.size <= 0 ? !1 : this.scopes.size >= e.scopes.size && e.asArray().every((e) => this.containsScope(e));
	}
	containsOnlyOIDCScopes() {
		let e = 0;
		return me.forEach((t) => {
			this.containsScope(t) && (e += 1);
		}), this.scopes.size === e;
	}
	appendScope(e) {
		e && this.scopes.add(e.trim());
	}
	appendScopes(e) {
		try {
			e.forEach((e) => this.appendScope(e));
		} catch {
			throw T(gn);
		}
	}
	removeScope(e) {
		if (!e) throw T(hn);
		this.scopes.delete(e.trim());
	}
	removeOIDCScopes() {
		me.forEach((e) => {
			this.scopes.delete(e);
		});
	}
	unionScopeSets(e) {
		if (!e) throw T(_n);
		let t = /* @__PURE__ */ new Set();
		return e.scopes.forEach((e) => t.add(e.toLowerCase())), this.scopes.forEach((e) => t.add(e.toLowerCase())), t;
	}
	intersectingScopeSets(e) {
		if (!e) throw T(_n);
		e.containsOnlyOIDCScopes() || e.removeOIDCScopes();
		let t = this.unionScopeSets(e), n = e.getScopeCount(), r = this.getScopeCount();
		return t.size < r + n;
	}
	getScopeCount() {
		return this.scopes.size;
	}
	asArray() {
		let e = [];
		return this.scopes.forEach((t) => e.push(t)), e;
	}
	printScopes() {
		return this.scopes ? this.asArray().join(" ") : "";
	}
	printScopesLowerCase() {
		return this.printScopes().toLowerCase();
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/request/RequestParameterBuilder.mjs
function jn(e, t, n) {
	if (!t) return;
	let r = e.get(Le);
	r && e.has("brk_client_id") && n?.addFields({
		embeddedClientId: r,
		embeddedRedirectUri: e.get(Re)
	}, t);
}
function Mn(e, t) {
	e.set(ze, t);
}
function Nn(e, t) {
	e.set(Be, t || ye.QUERY);
}
function Pn(e) {
	e.set(gt, "1");
}
function Fn(e, t, n = !0, r = pe) {
	n && !r.includes("openid") && !t.includes("openid") && r.push("openid");
	let i = new D(n ? [...t || [], ...r] : t || []);
	e.set(Ue, i.printScopes());
}
function In(e, t) {
	e.set(Le, t);
}
function Ln(e, t) {
	e.set(Re, t);
}
function Rn(e, t) {
	e.set(ct, t);
}
function zn(e, t) {
	e.set(lt, t);
}
function Bn(e, t) {
	e.set(yt, t);
}
function Vn(e, t) {
	e.set(vt, t);
}
function Hn(e, t) {
	e.set(_.CCS_HEADER, `UPN:${t}`);
}
function Un(e, t) {
	e.set(_.CCS_HEADER, `Oid:${t.uid}@${t.utid}`);
}
function Wn(e, t) {
	e.set("sid", t);
}
function Gn(e, t, n, r) {
	let i = r && e.has("brk_client_id") ? void 0 : n;
	if (!w.isEmptyObj(t) || i && i.length > 0) {
		let n = lr(t, i);
		try {
			JSON.parse(n);
		} catch {
			throw C(Lt);
		}
		e.set(He, n);
	}
}
function Kn(e, t) {
	e.set(Qe, t);
}
function qn(e, t) {
	e.set($e, t.sku), e.set(et, t.version), t.os && e.set(tt, t.os), t.cpu && e.set(nt, t.cpu);
}
function Jn(e, t) {
	t?.appName && e.set(ot, t.appName), t?.appVersion && e.set(st, t.appVersion);
}
function Yn(e, t) {
	e.set(qe, t);
}
function Xn(e, t) {
	t && e.set(Ge, t);
}
function Zn(e, t) {
	e.set(Ke, t);
}
function Qn(e, t, n) {
	if (t && n) e.set(Ye, t), e.set(Xe, n);
	else throw C(Bt);
}
function $n(e, t) {
	e.set(Je, t);
}
function er(e, t) {
	e.set(We, t);
}
function tr(e, t) {
	e.set(Ze, t);
}
function nr(e, t) {
	e.set(ut, t);
}
function rr(e, t) {
	t && e.set(dt, t);
}
function ir(e, t) {
	t && e.set(ft, t);
}
function ar(e, t) {
	e.set(Ve, t);
}
function or(e) {
	e.set(Te, "1");
}
function sr(e) {
	e.set(Dt, "1");
}
function cr(e) {
	e.has("instance_aware") || e.set(Ct, "true");
}
function O(e, t) {
	Object.entries(t).forEach(([t, n]) => {
		!e.has(t) && n && e.set(t, n);
	});
}
function lr(e, t) {
	let n;
	if (!e) n = {};
	else try {
		n = JSON.parse(e);
	} catch {
		throw C(Lt);
	}
	return t && t.length > 0 && (n.hasOwnProperty(_e.ACCESS_TOKEN) || (n[_e.ACCESS_TOKEN] = {}), n[_e.ACCESS_TOKEN][_e.XMS_CC] = { values: t }), JSON.stringify(n);
}
function ur(e, t) {
	t && (e.set(pt, x.POP), e.set(mt, t));
}
function dr(e, t) {
	t && (e.set(pt, x.SSH), e.set(mt, t));
}
function fr(e, t) {
	e.set(rt, t.generateCurrentRequestHeaderValue()), e.set(it, t.generateLastRequestHeaderValue());
}
function pr(e) {
	e.set(at, Me);
}
function mr(e, t) {
	e.set(_t, t);
}
function hr(e, t, n) {
	e.has("brk_client_id") || e.set(xt, t), e.has("brk_redirect_uri") || e.set(St, n);
}
function gr(e, t) {
	e.set(wt, encodeURIComponent(t)), e.set(Tt, "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0");
}
function _r(e, t) {
	t && e.set(Et, t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/utils/UrlUtils.mjs
function vr(e) {
	if (!e) return e;
	let t = e.toLowerCase();
	return w.endsWith(t, "?") ? t = t.slice(0, -1) : w.endsWith(t, "?/") && (t = t.slice(0, -2)), w.endsWith(t, "/") || (t += "/"), t;
}
function yr(e) {
	return e.startsWith("#/") ? e.substring(2) : e.startsWith("#") || e.startsWith("?") ? e.substring(1) : e;
}
function br(e) {
	if (!e || e.indexOf("=") < 0) return null;
	try {
		let t = yr(e), n = Object.fromEntries(new URLSearchParams(t));
		if (n.code || n.ear_jwe || n.error || n.error_description || n.state) return n;
	} catch {
		throw T(on);
	}
	return null;
}
function xr(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(`${n}=${encodeURIComponent(e)}`);
	}), t.join("&");
}
function Sr(e) {
	if (!e) return e;
	let t = e.split("#")[0];
	try {
		let e = new URL(t);
		return vr(e.origin + e.pathname + e.search);
	} catch {
		return vr(t);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/crypto/ICrypto.mjs
var Cr = {
	createNewGuid: () => {
		throw T(E);
	},
	base64Decode: () => {
		throw T(E);
	},
	base64Encode: () => {
		throw T(E);
	},
	base64UrlEncode: () => {
		throw T(E);
	},
	encodeKid: () => {
		throw T(E);
	},
	async getPublicKeyThumbprint() {
		throw T(E);
	},
	async removeTokenBindingKey() {
		throw T(E);
	},
	async clearKeystore() {
		throw T(E);
	},
	async signJwt() {
		throw T(E);
	},
	async hashString() {
		throw T(E);
	}
}, k;
(function(e) {
	e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Info = 2] = "Info", e[e.Verbose = 3] = "Verbose", e[e.Trace = 4] = "Trace";
})(k ||= {});
var wr = 50, Tr = 500, Er = /* @__PURE__ */ new Map();
function Dr(e, t) {
	Er.delete(e), Er.set(e, t);
}
function Or(e, t) {
	let n = Date.now(), r = Er.get(e);
	if (r) Dr(e, r);
	else if (r = {
		logs: [],
		firstEventTime: n
	}, Er.set(e, r), Er.size > wr) {
		let e = Er.keys().next().value;
		e && Er.delete(e);
	}
	r.logs.push({
		...t,
		milliseconds: n - r.firstEventTime
	}), r.logs.length > Tr && r.logs.shift();
}
function kr(e) {
	if (e.length !== 6) return !1;
	for (let t = 0; t < e.length; t++) {
		let n = e[t];
		if (!(n >= "a" && n <= "z" || n >= "A" && n <= "Z" || n >= "0" && n <= "9")) return !1;
	}
	return !0;
}
var Ar = class e {
	constructor(t, n, r) {
		this.level = k.Info;
		let i = () => {}, a = t || e.createDefaultLoggerOptions();
		this.localCallback = a.loggerCallback || i, this.piiLoggingEnabled = a.piiLoggingEnabled || !1, this.level = typeof a.logLevel == "number" ? a.logLevel : k.Info, this.packageName = n || "", this.packageVersion = r || "";
	}
	static createDefaultLoggerOptions() {
		return {
			loggerCallback: () => {},
			piiLoggingEnabled: !1,
			logLevel: k.Info
		};
	}
	clone(t, n) {
		return new e({
			loggerCallback: this.localCallback,
			piiLoggingEnabled: this.piiLoggingEnabled,
			logLevel: this.level
		}, t, n);
	}
	logMessage(e, t) {
		let n = t.correlationId;
		if (kr(e) && Or(n, {
			hash: e,
			level: t.logLevel,
			containsPii: t.containsPii || !1,
			milliseconds: 0
		}), t.logLevel > this.level || !this.piiLoggingEnabled && t.containsPii) return;
		let r = `${`[${(/* @__PURE__ */ new Date()).toUTCString()}] : [${n}]`} : ${this.packageName}@${this.packageVersion} : ${k[t.logLevel]} - ${e}`;
		this.executeCallback(t.logLevel, r, t.containsPii || !1);
	}
	executeCallback(e, t, n) {
		this.localCallback && this.localCallback(e, t, n);
	}
	error(e, t) {
		this.logMessage(e, {
			logLevel: k.Error,
			containsPii: !1,
			correlationId: t
		});
	}
	errorPii(e, t) {
		this.logMessage(e, {
			logLevel: k.Error,
			containsPii: !0,
			correlationId: t
		});
	}
	warning(e, t) {
		this.logMessage(e, {
			logLevel: k.Warning,
			containsPii: !1,
			correlationId: t
		});
	}
	warningPii(e, t) {
		this.logMessage(e, {
			logLevel: k.Warning,
			containsPii: !0,
			correlationId: t
		});
	}
	info(e, t) {
		this.logMessage(e, {
			logLevel: k.Info,
			containsPii: !1,
			correlationId: t
		});
	}
	infoPii(e, t) {
		this.logMessage(e, {
			logLevel: k.Info,
			containsPii: !0,
			correlationId: t
		});
	}
	verbose(e, t) {
		this.logMessage(e, {
			logLevel: k.Verbose,
			containsPii: !1,
			correlationId: t
		});
	}
	verbosePii(e, t) {
		this.logMessage(e, {
			logLevel: k.Verbose,
			containsPii: !0,
			correlationId: t
		});
	}
	trace(e, t) {
		this.logMessage(e, {
			logLevel: k.Trace,
			containsPii: !1,
			correlationId: t
		});
	}
	tracePii(e, t) {
		this.logMessage(e, {
			logLevel: k.Trace,
			containsPii: !0,
			correlationId: t
		});
	}
	isPiiLoggingEnabled() {
		return this.piiLoggingEnabled || !1;
	}
}, jr = "@azure/msal-common", Mr = "16.6.2", Nr = {
	None: "none",
	AzurePublic: "https://login.microsoftonline.com",
	AzurePpe: "https://login.windows-ppe.net",
	AzureChina: "https://login.chinacloudapi.cn",
	AzureGermany: "https://login.microsoftonline.de",
	AzureUsGovernment: "https://login.microsoftonline.us"
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/account/AccountInfo.mjs
function Pr(e, t) {
	return !!e && !!t && e === t.split(".")[1];
}
function Fr(e, t, n, r) {
	if (r) {
		let { oid: t, sub: n, tid: i, name: a, tfp: o, acr: s, preferred_username: c, upn: l, login_hint: u } = r, d = i || o || s || "";
		return {
			tenantId: d,
			localAccountId: t || n || "",
			name: a,
			username: c || l || "",
			loginHint: u,
			isHomeTenant: Pr(d, e),
			upn: l
		};
	} else return {
		tenantId: n,
		localAccountId: t,
		username: "",
		isHomeTenant: Pr(n, e)
	};
}
function Ir(e, t, n, r) {
	let i = e;
	if (t) {
		let { isHomeTenant: n, ...r } = t;
		i = {
			...e,
			...r
		};
	}
	if (n) {
		let { isHomeTenant: t, ...a } = Fr(e.homeAccountId, e.localAccountId, e.tenantId, n);
		return i = {
			...i,
			...a,
			idTokenClaims: n,
			idToken: r
		}, i;
	}
	return i;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/account/AuthToken.mjs
function Lr(e, t) {
	let n = zr(e);
	try {
		let e = t(n);
		return JSON.parse(e);
	} catch {
		throw T(en);
	}
}
function Rr(e) {
	if (!e.signin_state) return !1;
	let t = ["kmsi", "dvc_dmjd"];
	return e.signin_state.some((e) => t.includes(e.trim().toLowerCase()));
}
function zr(e) {
	if (!e) throw T(tn);
	let t = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/.exec(e);
	if (!t || t.length < 4) throw T(en);
	return t[2];
}
function Br(e, t) {
	if (t === 0 || Date.now() - 3e5 > e + t) throw T(fn);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/url/UrlString.mjs
var A = class e {
	get urlString() {
		return this._urlString;
	}
	constructor(t) {
		if (this._urlString = t, !this._urlString) throw C(Ft);
		t.includes("#") || (this._urlString = e.canonicalizeUri(t));
	}
	static canonicalizeUri(e) {
		if (e) {
			let t = e.toLowerCase();
			return w.endsWith(t, "?") ? t = t.slice(0, -1) : w.endsWith(t, "?/") && (t = t.slice(0, -2)), w.endsWith(t, "/") || (t += "/"), t;
		}
		return e;
	}
	validateAsUri() {
		let e;
		try {
			e = this.getUrlComponents();
		} catch {
			throw C(Pt);
		}
		if (!e.HostNameAndPort || !e.PathSegments) throw C(Pt);
		if (!e.Protocol || e.Protocol.toLowerCase() !== "https:") throw C(Nt);
	}
	static appendQueryString(e, t) {
		return t ? e.indexOf("?") < 0 ? `${e}?${t}` : `${e}&${t}` : e;
	}
	static removeHashFromUrl(t) {
		return e.canonicalizeUri(t.split("#")[0]);
	}
	replaceTenantPath(t) {
		let n = this.getUrlComponents(), r = n.PathSegments;
		return t && r.length !== 0 && (r[0] === ge.COMMON || r[0] === ge.ORGANIZATIONS) && (r[0] = t), e.constructAuthorityUriFromObject(n);
	}
	getUrlComponents() {
		let e = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?"), t = this.urlString.match(e);
		if (!t) throw C(Pt);
		let n = {
			Protocol: t[1],
			HostNameAndPort: t[4],
			AbsolutePath: t[5],
			QueryString: t[7]
		}, r = n.AbsolutePath.split("/");
		return r = r.filter((e) => e && e.length > 0), n.PathSegments = r, n.QueryString && n.QueryString.endsWith("/") && (n.QueryString = n.QueryString.substring(0, n.QueryString.length - 1)), n;
	}
	static getDomainFromUrl(e) {
		let t = RegExp("^([^:/?#]+://)?([^/?#]*)"), n = e.match(t);
		if (!n) throw C(Pt);
		return n[2];
	}
	static getAbsoluteUrl(t, n) {
		if (t[0] === "/") {
			let r = new e(n).getUrlComponents();
			return r.Protocol + "//" + r.HostNameAndPort + t;
		}
		return t;
	}
	static constructAuthorityUriFromObject(t) {
		return new e(t.Protocol + "//" + t.HostNameAndPort + "/" + t.PathSegments.join("/"));
	}
}, Vr = [
	{ host: "login.microsoftonline.com" },
	{
		host: "login.chinacloudapi.cn",
		issuerHost: "login.partner.microsoftonline.cn"
	},
	{ host: "login.microsoftonline.us" },
	{ host: "login.sovcloud-identity.fr" },
	{ host: "login.sovcloud-identity.de" },
	{ host: "login.sovcloud-identity.sg" }
];
function Hr(e, t) {
	return {
		token_endpoint: `https://${e}/{tenantid}/oauth2/v2.0/token`,
		jwks_uri: `https://${e}/{tenantid}/discovery/v2.0/keys`,
		issuer: `https://${t}/{tenantid}/v2.0`,
		authorization_endpoint: `https://${e}/{tenantid}/oauth2/v2.0/authorize`,
		end_session_endpoint: `https://${e}/{tenantid}/oauth2/v2.0/logout`
	};
}
var Ur = {
	endpointMetadata: Vr.reduce((e, { host: t, issuerHost: n }) => (e[t] = Hr(t, n || t), e), {}),
	instanceDiscoveryMetadata: { metadata: [
		{
			preferred_network: "login.microsoftonline.com",
			preferred_cache: "login.windows.net",
			aliases: [
				"login.microsoftonline.com",
				"login.windows.net",
				"login.microsoft.com",
				"sts.windows.net"
			]
		},
		{
			preferred_network: "login.partner.microsoftonline.cn",
			preferred_cache: "login.partner.microsoftonline.cn",
			aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"]
		},
		{
			preferred_network: "login.microsoftonline.de",
			preferred_cache: "login.microsoftonline.de",
			aliases: ["login.microsoftonline.de"]
		},
		{
			preferred_network: "login.microsoftonline.us",
			preferred_cache: "login.microsoftonline.us",
			aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"]
		},
		{
			preferred_network: "login-us.microsoftonline.com",
			preferred_cache: "login-us.microsoftonline.com",
			aliases: ["login-us.microsoftonline.com"]
		},
		{
			preferred_network: "login.sovcloud-identity.fr",
			preferred_cache: "login.sovcloud-identity.fr",
			aliases: ["login.sovcloud-identity.fr"]
		},
		{
			preferred_network: "login.sovcloud-identity.de",
			preferred_cache: "login.sovcloud-identity.de",
			aliases: ["login.sovcloud-identity.de"]
		},
		{
			preferred_network: "login.sovcloud-identity.sg",
			preferred_cache: "login.sovcloud-identity.sg",
			aliases: ["login.sovcloud-identity.sg"]
		},
		{
			preferred_network: "login.windows-ppe.net",
			preferred_cache: "login.windows-ppe.net",
			aliases: [
				"login.windows-ppe.net",
				"sts.windows-ppe.net",
				"login.microsoft-ppe.com"
			]
		}
	] }
}, Wr = Ur.endpointMetadata, Gr = Ur.instanceDiscoveryMetadata, Kr = /* @__PURE__ */ new Set();
Gr.metadata.forEach((e) => {
	e.aliases.forEach((e) => {
		Kr.add(e);
	});
});
function qr(e, t, n) {
	let r, i = e.canonicalAuthority;
	if (i) {
		let a = new A(i).getUrlComponents().HostNameAndPort;
		r = Jr(t, n, a, e.cloudDiscoveryMetadata?.metadata) || Jr(t, n, a, Gr.metadata) || e.knownAuthorities;
	}
	return r || [];
}
function Jr(e, t, n, r, i) {
	if (e.trace("1bmquz", t), n && r) {
		let i = Xr(r, n);
		if (i) return e.trace("1fotbt", t), i.aliases;
		e.trace("14avvj", t);
	}
	return null;
}
function Yr(e) {
	return Xr(Gr.metadata, e);
}
function Xr(e, t) {
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r.aliases.includes(t)) return r;
	}
	return null;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/CacheErrorCodes.mjs
var Zr = "cache_quota_exceeded", Qr = "cache_error_unknown", $r = class e extends Error {
	constructor(t, n) {
		let r = n || Ot(t);
		super(r), Object.setPrototypeOf(this, e.prototype), this.name = "CacheError", this.errorCode = t, this.errorMessage = r;
	}
};
function ei(e) {
	return e instanceof Error ? e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota") ? new $r(Zr) : new $r(e.name, e.message) : new $r(Qr);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/account/ClientInfo.mjs
function ti(e, t) {
	if (!e) throw T($t);
	try {
		let n = t(e);
		return JSON.parse(n);
	} catch {
		throw T(Qt);
	}
}
function ni(e) {
	if (!e) throw T(Qt);
	let t = e.split(".", 2);
	return {
		uid: t[0],
		utid: t.length < 2 ? "" : t[1]
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/AuthorityType.mjs
var j = {
	Default: 0,
	Adfs: 1,
	Dsts: 2,
	Ciam: 3
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/account/TokenClaims.mjs
function ri(e) {
	return e && (e.tid || e.tfp || e.acr) || null;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/ProtocolMode.mjs
var M = {
	AAD: "AAD",
	OIDC: "OIDC",
	EAR: "EAR"
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/cache/utils/AccountEntityUtils.mjs
function ii(e) {
	let t = e.tenantProfiles || [];
	return t.length === 0 && e.realm && e.localAccountId && t.push(Fr(e.homeAccountId, e.localAccountId, e.realm)), {
		homeAccountId: e.homeAccountId,
		environment: e.environment,
		tenantId: e.realm,
		username: e.username,
		localAccountId: e.localAccountId,
		loginHint: e.loginHint,
		name: e.name,
		nativeAccountId: e.nativeAccountId,
		authorityType: e.authorityType,
		tenantProfiles: new Map(t.map((e) => [e.tenantId, e])),
		dataBoundary: e.dataBoundary
	};
}
function ai(e, t, n) {
	let r;
	r = t.authorityType === j.Adfs ? Se : t.protocolMode === M.OIDC ? Ce : xe;
	let i, a;
	e.clientInfo && n && (i = ti(e.clientInfo, n), i.xms_tdbr && (a = i.xms_tdbr === "EU" ? "EU" : "None"));
	let o = e.environment || t && t.getPreferredCache();
	if (!o) throw T(bn);
	let s = e.idTokenClaims?.preferred_username || e.idTokenClaims?.upn, c = e.idTokenClaims?.emails ? e.idTokenClaims.emails[0] : null, l = s || c || "", u = e.idTokenClaims?.login_hint, d = i?.utid || ri(e.idTokenClaims) || "", f = i?.uid || e.idTokenClaims?.oid || e.idTokenClaims?.sub || "", p;
	return p = e.tenantProfiles ? e.tenantProfiles : [Fr(e.homeAccountId, f, d, e.idTokenClaims)], {
		homeAccountId: e.homeAccountId,
		environment: o,
		realm: d,
		localAccountId: f,
		username: l,
		authorityType: r,
		loginHint: u,
		clientInfo: e.clientInfo,
		name: e.idTokenClaims?.name || "",
		lastModificationTime: void 0,
		lastModificationApp: void 0,
		cloudGraphHostName: e.cloudGraphHostName,
		msGraphHost: e.msGraphHost,
		nativeAccountId: e.nativeAccountId,
		tenantProfiles: p,
		dataBoundary: a
	};
}
function oi(e, t, n) {
	let r = Array.from(e.tenantProfiles?.values() || []);
	return r.length === 0 && e.tenantId && e.localAccountId && r.push(Fr(e.homeAccountId, e.localAccountId, e.tenantId, e.idTokenClaims)), {
		authorityType: e.authorityType || "Generic",
		homeAccountId: e.homeAccountId,
		localAccountId: e.localAccountId,
		nativeAccountId: e.nativeAccountId,
		realm: e.tenantId,
		environment: e.environment,
		username: e.username,
		loginHint: e.loginHint,
		name: e.name,
		cloudGraphHostName: t,
		msGraphHost: n,
		tenantProfiles: r,
		dataBoundary: e.dataBoundary
	};
}
function si(e, t, n, r, i, a) {
	if (!(t === j.Adfs || t === j.Dsts)) {
		if (e) try {
			let t = ti(e, r.base64Decode);
			if (t.uid && t.utid) return `${t.uid}.${t.utid}`;
		} catch {}
		n.warning("1ub6wv", i);
	}
	return a?.sub || "";
}
function ci(e) {
	return e ? e.hasOwnProperty("homeAccountId") && e.hasOwnProperty("environment") && e.hasOwnProperty("realm") && e.hasOwnProperty("localAccountId") && e.hasOwnProperty("username") && e.hasOwnProperty("authorityType") : !1;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/cache/CacheManager.mjs
var li = class {
	constructor(e, t, n, r, i) {
		this.clientId = e, this.cryptoImpl = t, this.commonLogger = n.clone(jr, Mr), this.staticAuthorityOptions = i, this.performanceClient = r;
	}
	getAllAccounts(e = {}, t) {
		return this.buildTenantProfiles(this.getAccountsFilteredBy(e, t), t, e);
	}
	getAccountInfoFilteredBy(e, t) {
		if (Object.keys(e).length === 0 || Object.values(e).every((e) => e == null || e === "")) return this.commonLogger.warning("1skb02", t), null;
		let n = this.getAllAccounts(e, t);
		return n.length > 1 ? n.sort((e, t) => {
			let n = +!!e.idTokenClaims;
			return +!!t.idTokenClaims - n;
		})[0] : n.length === 1 ? n[0] : null;
	}
	getBaseAccountInfo(e, t) {
		let n = this.getAccountsFilteredBy(e, t);
		return n.length > 0 ? ii(n[0]) : null;
	}
	buildTenantProfiles(e, t, n) {
		return e.flatMap((e) => this.getTenantProfilesFromAccountEntity(e, t, n?.tenantId, n));
	}
	getTenantedAccountInfoByFilter(e, t, n, r, i) {
		let a = null, o;
		if (i && !this.tenantProfileMatchesFilter(n, i)) return null;
		let s = this.getIdToken(e, r, t, n.tenantId);
		return s && (o = Lr(s.secret, this.cryptoImpl.base64Decode), !this.idTokenClaimsMatchTenantProfileFilter(o, i)) ? null : (a = Ir(e, n, o, s?.secret), a);
	}
	getTenantProfilesFromAccountEntity(e, t, n, r) {
		let i = ii(e), a = i.tenantProfiles || /* @__PURE__ */ new Map(), o = this.getTokenKeys();
		if (n) {
			let e = a.get(n);
			if (e) a = /* @__PURE__ */ new Map([[n, e]]);
			else return [];
		}
		let s = [];
		return a.forEach((e) => {
			let n = this.getTenantedAccountInfoByFilter(i, o, e, t, r);
			n && s.push(n);
		}), s;
	}
	tenantProfileMatchesFilter(e, t) {
		return !(t.localAccountId && !this.matchLocalAccountIdFromTenantProfile(e, t.localAccountId) || t.name && e.name !== t.name || t.isHomeTenant !== void 0 && e.isHomeTenant !== t.isHomeTenant || t.username && !(this.matchUsername(e.username, t.username) || !this.matchUsername(e.upn, t.username)) || t.loginHint && !this.matchLoginHintWithTenantProfile(e, t.loginHint) || t.upn && e.upn !== t.upn);
	}
	idTokenClaimsMatchTenantProfileFilter(e, t) {
		return !(t && (t.localAccountId && !this.matchLocalAccountIdFromTokenClaims(e, t.localAccountId) || t.loginHint && !this.matchLoginHintFromTokenClaims(e, t.loginHint) || t.username && !this.matchUsername(e.preferred_username, t.username) && !this.matchUsername(e.upn, t.username) || t.name && !this.matchName(e, t.name) || t.sid && !this.matchSid(e, t.sid)));
	}
	async saveCacheRecord(e, t, n, r, i) {
		if (!e) throw T(yn);
		try {
			e.account && await this.setAccount(e.account, t, n, r), e.idToken && i?.idToken !== !1 && await this.setIdTokenCredential(e.idToken, t, n), e.accessToken && i?.accessToken !== !1 && await this.saveAccessToken(e.accessToken, t, n), e.refreshToken && i?.refreshToken !== !1 && await this.setRefreshTokenCredential(e.refreshToken, t, n), e.appMetadata && this.setAppMetadata(e.appMetadata, t);
		} catch (e) {
			throw this.commonLogger?.error("0j476p", t), e instanceof S ? e : ei(e);
		}
	}
	async saveAccessToken(e, t, n) {
		let r = {
			clientId: e.clientId,
			credentialType: e.credentialType,
			environment: e.environment,
			homeAccountId: e.homeAccountId,
			realm: e.realm,
			tokenType: e.tokenType
		}, i = this.getTokenKeys(), a = D.fromString(e.target);
		i.accessToken.forEach((e) => {
			if (!this.accessTokenKeyMatchesFilter(e, r, !1)) return;
			let n = this.getAccessTokenCredential(e, t);
			n && this.credentialMatchesFilter(n, r, t) && D.fromString(n.target).intersectingScopeSets(a) && this.removeAccessToken(e, t);
		}), await this.setAccessTokenCredential(e, t, n);
	}
	getAccountsFilteredBy(e, t) {
		let n = this.getAccountKeys(), r = [];
		return n.forEach((n) => {
			let i = this.getAccount(n, t);
			if (!i || e.homeAccountId && !this.matchHomeAccountId(i, e.homeAccountId) || e.environment && !this.matchEnvironment(i, e.environment, t) || e.realm && !this.matchRealm(i, e.realm) || e.nativeAccountId && !this.matchNativeAccountId(i, e.nativeAccountId) || e.authorityType && !this.matchAuthorityType(i, e.authorityType)) return;
			let a = {
				localAccountId: e?.localAccountId,
				name: e?.name,
				username: e?.username,
				loginHint: e?.loginHint,
				upn: e?.upn
			}, o = i.tenantProfiles?.filter((e) => this.tenantProfileMatchesFilter(e, a));
			o && o.length === 0 || r.push(i);
		}), r;
	}
	credentialMatchesFilter(e, t, n) {
		return !(t.clientId && !this.matchClientId(e, t.clientId) || t.userAssertionHash && !this.matchUserAssertionHash(e, t.userAssertionHash) || typeof t.homeAccountId == "string" && !this.matchHomeAccountId(e, t.homeAccountId) || t.environment && !this.matchEnvironment(e, t.environment, n) || t.realm && !this.matchRealm(e, t.realm) || t.credentialType && !this.matchCredentialType(e, t.credentialType) || t.familyId && !this.matchFamilyId(e, t.familyId) || t.target && !this.matchTarget(e, t.target) || e.credentialType === y.ACCESS_TOKEN_WITH_AUTH_SCHEME && (t.tokenType && !this.matchTokenType(e, t.tokenType) || t.tokenType === x.SSH && t.keyId && !this.matchKeyId(e, t.keyId)));
	}
	getAppMetadataFilteredBy(e, t) {
		let n = this.getKeys(), r = {};
		return n.forEach((n) => {
			if (!this.isAppMetadata(n)) return;
			let i = this.getAppMetadata(n, t);
			i && (e.environment && !this.matchEnvironment(i, e.environment, t) || e.clientId && !this.matchClientId(i, e.clientId) || (r[n] = i));
		}), r;
	}
	getAuthorityMetadataByAlias(e, t) {
		let n = this.getAuthorityMetadataKeys(), r = null;
		return n.forEach((n) => {
			if (!this.isAuthorityMetadata(n) || n.indexOf(this.clientId) === -1) return;
			let i = this.getAuthorityMetadata(n, t);
			i && i.aliases.indexOf(e) !== -1 && (r = i);
		}), r;
	}
	removeAllAccounts(e) {
		this.getAllAccounts({}, e).forEach((t) => {
			this.removeAccount(t, e);
		});
	}
	removeAccount(e, t) {
		this.removeAccountContext(e, t), this.getAccountKeys().filter((t) => t.includes(e.homeAccountId) && t.includes(e.environment)).forEach((e) => {
			this.removeItem(e, t), this.performanceClient.incrementFields({ accountsRemoved: 1 }, t);
		});
	}
	removeAccountContext(e, t) {
		let n = this.getTokenKeys(), r = (t) => t.includes(e.homeAccountId) && t.includes(e.environment);
		n.idToken.filter(r).forEach((e) => {
			this.removeIdToken(e, t);
		}), n.accessToken.filter(r).forEach((e) => {
			this.removeAccessToken(e, t);
		}), n.refreshToken.filter(r).forEach((e) => {
			this.removeRefreshToken(e, t);
		});
	}
	removeAccessToken(e, t) {
		let n = this.getAccessTokenCredential(e, t);
		if (n && (this.removeItem(e, t), this.performanceClient.incrementFields({ accessTokensRemoved: 1 }, t), n.credentialType.toLowerCase() === y.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase() && n.tokenType === x.POP)) {
			let e = n.keyId;
			e && this.cryptoImpl.removeTokenBindingKey(e, t).catch(() => {
				this.commonLogger.error("0cx291", t), this.performanceClient?.incrementFields({ removeTokenBindingKeyFailure: 1 }, t);
			});
		}
	}
	removeAppMetadata(e) {
		return this.getKeys().forEach((t) => {
			this.isAppMetadata(t) && this.removeItem(t, e);
		}), !0;
	}
	getIdToken(e, t, n, r) {
		this.commonLogger.trace("1drz22", t);
		let i = {
			homeAccountId: e.homeAccountId,
			environment: e.environment,
			credentialType: y.ID_TOKEN,
			clientId: this.clientId,
			realm: r
		}, a = this.getIdTokensByFilter(i, t, n), o = a.size;
		if (o < 1) return this.commonLogger.info("1atvtd", t), null;
		if (o > 1) {
			let n = a;
			if (!r) {
				let r = /* @__PURE__ */ new Map();
				a.forEach((t, n) => {
					t.realm === e.tenantId && r.set(n, t);
				});
				let i = r.size;
				if (i < 1) return this.commonLogger.info("0ooalx", t), a.values().next().value ?? null;
				if (i === 1) return this.commonLogger.info("1eq2vc", t), r.values().next().value ?? null;
				n = r;
			}
			return this.commonLogger.info("1ws328", t), n.forEach((e, n) => {
				this.removeIdToken(n, t);
			}), this.performanceClient.addFields({ multiMatchedID: a.size }, t), null;
		}
		return this.commonLogger.info("1sm769", t), a.values().next().value ?? null;
	}
	getIdTokensByFilter(e, t, n) {
		let r = n && n.idToken || this.getTokenKeys().idToken, i = /* @__PURE__ */ new Map();
		return r.forEach((n) => {
			if (!this.idTokenKeyMatchesFilter(n, {
				clientId: this.clientId,
				...e
			})) return;
			let r = this.getIdTokenCredential(n, t);
			r && this.credentialMatchesFilter(r, e, t) && i.set(n, r);
		}), i;
	}
	idTokenKeyMatchesFilter(e, t) {
		let n = e.toLowerCase();
		return !(t.clientId && n.indexOf(t.clientId.toLowerCase()) === -1 || t.homeAccountId && n.indexOf(t.homeAccountId.toLowerCase()) === -1);
	}
	removeIdToken(e, t) {
		this.removeItem(e, t);
	}
	removeRefreshToken(e, t) {
		this.removeItem(e, t);
	}
	getAccessToken(e, t, n, r) {
		let i = t.correlationId;
		this.commonLogger.trace("1t7hz1", i);
		let a = D.createSearchScopes(t.scopes), o = t.authenticationScheme || x.BEARER, s = o && o.toLowerCase() !== x.BEARER.toLowerCase() ? y.ACCESS_TOKEN_WITH_AUTH_SCHEME : y.ACCESS_TOKEN, c = {
			homeAccountId: e.homeAccountId,
			environment: e.environment,
			credentialType: s,
			clientId: this.clientId,
			realm: r || e.tenantId,
			target: a,
			tokenType: o,
			keyId: t.sshKid
		}, l = n && n.accessToken || this.getTokenKeys().accessToken, u = [];
		l.forEach((e) => {
			if (this.accessTokenKeyMatchesFilter(e, c, !0)) {
				let t = this.getAccessTokenCredential(e, i);
				t && this.credentialMatchesFilter(t, c, i) && u.push(t);
			}
		});
		let d = u.length;
		return d < 1 ? (this.commonLogger.info("1nckna", i), null) : d > 1 ? (this.commonLogger.info("1wkfwp", i), u.forEach((e) => {
			this.removeAccessToken(this.generateCredentialKey(e), i);
		}), this.performanceClient.addFields({ multiMatchedAT: u.length }, i), null) : (this.commonLogger.info("06yt98", i), u[0]);
	}
	accessTokenKeyMatchesFilter(e, t, n) {
		let r = e.toLowerCase();
		if (t.clientId && r.indexOf(t.clientId.toLowerCase()) === -1 || t.homeAccountId && r.indexOf(t.homeAccountId.toLowerCase()) === -1 || t.realm && r.indexOf(t.realm.toLowerCase()) === -1) return !1;
		if (t.target) {
			let e = t.target.asArray();
			for (let t = 0; t < e.length; t++) if (n && !r.includes(e[t].toLowerCase())) return !1;
			else if (!n && r.includes(e[t].toLowerCase())) return !0;
		}
		return !0;
	}
	getAccessTokensByFilter(e, t) {
		let n = this.getTokenKeys(), r = [];
		return n.accessToken.forEach((n) => {
			if (!this.accessTokenKeyMatchesFilter(n, e, !0)) return;
			let i = this.getAccessTokenCredential(n, t);
			i && this.credentialMatchesFilter(i, e, t) && r.push(i);
		}), r;
	}
	getRefreshToken(e, t, n, r) {
		this.commonLogger.trace("0x53vi", n);
		let i = t ? "1" : void 0, a = {
			homeAccountId: e.homeAccountId,
			environment: e.environment,
			credentialType: y.REFRESH_TOKEN,
			clientId: this.clientId,
			familyId: i
		}, o = r && r.refreshToken || this.getTokenKeys().refreshToken, s = [];
		o.forEach((e) => {
			if (this.refreshTokenKeyMatchesFilter(e, a)) {
				let t = this.getRefreshTokenCredential(e, n);
				t && this.credentialMatchesFilter(t, a, n) && s.push(t);
			}
		});
		let c = s.length;
		return c < 1 ? (this.commonLogger.info("0dlw11", n), null) : (c > 1 && this.performanceClient.addFields({ multiMatchedRT: c }, n), this.commonLogger.info("0wcnep", n), s[0]);
	}
	refreshTokenKeyMatchesFilter(e, t) {
		let n = e.toLowerCase();
		return !(t.familyId && n.indexOf(t.familyId.toLowerCase()) === -1 || !t.familyId && t.clientId && n.indexOf(t.clientId.toLowerCase()) === -1 || t.homeAccountId && n.indexOf(t.homeAccountId.toLowerCase()) === -1);
	}
	readAppMetadataFromCache(e, t) {
		let n = {
			environment: e,
			clientId: this.clientId
		}, r = this.getAppMetadataFilteredBy(n, t), i = Object.keys(r).map((e) => r[e]), a = i.length;
		if (a < 1) return null;
		if (a > 1) throw T(pn);
		return i[0];
	}
	isAppMetadataFOCI(e, t) {
		let n = this.readAppMetadataFromCache(e, t);
		return !!(n && n.familyId === "1");
	}
	matchHomeAccountId(e, t) {
		return typeof e.homeAccountId == "string" && t === e.homeAccountId;
	}
	matchLocalAccountIdFromTokenClaims(e, t) {
		return t === (e.oid || e.sub);
	}
	matchLocalAccountIdFromTenantProfile(e, t) {
		return e.localAccountId === t;
	}
	matchName(e, t) {
		return t.toLowerCase() === e.name?.toLowerCase();
	}
	matchUsername(e, t) {
		return !!(e && typeof e == "string" && t?.toLowerCase() === e.toLowerCase());
	}
	matchLoginHintWithTenantProfile(e, t) {
		return e.loginHint === t || e.username === t || e.upn === t;
	}
	matchUserAssertionHash(e, t) {
		return !!(e.userAssertionHash && t === e.userAssertionHash);
	}
	matchEnvironment(e, t, n) {
		if (this.staticAuthorityOptions) {
			let r = qr(this.staticAuthorityOptions, this.commonLogger, n);
			if (r.includes(t) && r.includes(e.environment)) return !0;
		}
		let r = this.getAuthorityMetadataByAlias(t, n);
		return !!(r && r.aliases.indexOf(e.environment) > -1);
	}
	matchCredentialType(e, t) {
		return e.credentialType && t.toLowerCase() === e.credentialType.toLowerCase();
	}
	matchClientId(e, t) {
		return !!(e.clientId && t === e.clientId);
	}
	matchFamilyId(e, t) {
		return !!(e.familyId && t === e.familyId);
	}
	matchRealm(e, t) {
		return e.realm?.toLowerCase() === t.toLowerCase();
	}
	matchNativeAccountId(e, t) {
		return !!(e.nativeAccountId && t === e.nativeAccountId);
	}
	matchLoginHintFromTokenClaims(e, t) {
		return !!(e.login_hint === t || e.preferred_username === t || e.upn === t || e.emails && e.emails.includes(t));
	}
	matchSid(e, t) {
		return e.sid === t;
	}
	matchAuthorityType(e, t) {
		return !!(e.authorityType && t.toLowerCase() === e.authorityType.toLowerCase());
	}
	matchTarget(e, t) {
		return e.credentialType !== y.ACCESS_TOKEN && e.credentialType !== y.ACCESS_TOKEN_WITH_AUTH_SCHEME || !e.target ? !1 : D.fromString(e.target).containsScopeSet(t);
	}
	matchTokenType(e, t) {
		return !!(e.tokenType && e.tokenType === t);
	}
	matchKeyId(e, t) {
		return !!(e.keyId && e.keyId === t);
	}
	isAppMetadata(e) {
		return e.indexOf(we) !== -1;
	}
	isAuthorityMetadata(e) {
		return e.indexOf(Ee) !== -1;
	}
	generateAuthorityMetadataCacheKey(e) {
		return `${Ee}-${this.clientId}-${e}`;
	}
	static toObject(e, t) {
		for (let n in t) e[n] = t[n];
		return e;
	}
}, ui = class extends li {
	async setAccount() {
		throw T(E);
	}
	getAccount() {
		throw T(E);
	}
	async setIdTokenCredential() {
		throw T(E);
	}
	getIdTokenCredential() {
		throw T(E);
	}
	async setAccessTokenCredential() {
		throw T(E);
	}
	getAccessTokenCredential() {
		throw T(E);
	}
	async setRefreshTokenCredential() {
		throw T(E);
	}
	getRefreshTokenCredential() {
		throw T(E);
	}
	setAppMetadata() {
		throw T(E);
	}
	getAppMetadata() {
		throw T(E);
	}
	setServerTelemetry() {
		throw T(E);
	}
	getServerTelemetry() {
		throw T(E);
	}
	setAuthorityMetadata() {
		throw T(E);
	}
	getAuthorityMetadata() {
		throw T(E);
	}
	getAuthorityMetadataKeys() {
		throw T(E);
	}
	setThrottlingCache() {
		throw T(E);
	}
	getThrottlingCache() {
		throw T(E);
	}
	removeItem() {
		throw T(E);
	}
	getKeys() {
		throw T(E);
	}
	getAccountKeys() {
		throw T(E);
	}
	getTokenKeys() {
		throw T(E);
	}
	generateCredentialKey() {
		throw T(E);
	}
	generateAccountKey() {
		throw T(E);
	}
}, di = {
	NotStarted: 0,
	InProgress: 1,
	Completed: 2
}, fi = class {
	generateId() {
		return "callback-id";
	}
	startMeasurement(e, t) {
		return {
			end: () => null,
			discard: () => {},
			add: () => {},
			increment: () => {},
			event: {
				eventId: this.generateId(),
				status: di.InProgress,
				authority: "",
				libraryName: "",
				libraryVersion: "",
				clientId: "",
				name: e,
				startTimeMs: Date.now(),
				correlationId: t || ""
			}
		};
	}
	endMeasurement() {
		return null;
	}
	discardMeasurements() {}
	removePerformanceCallback() {
		return !0;
	}
	addPerformanceCallback() {
		return "";
	}
	emitEvents() {}
	addFields() {}
	incrementFields() {}
	cacheEventByCorrelationId() {}
}, pi = {
	tokenRenewalOffsetSeconds: 300,
	preventCorsPreflight: !1
}, mi = {
	loggerCallback: () => {},
	piiLoggingEnabled: !1,
	logLevel: k.Info,
	correlationId: ""
}, hi = {
	async sendGetRequestAsync() {
		throw T(E);
	},
	async sendPostRequestAsync() {
		throw T(E);
	}
}, gi = {
	sku: l,
	version: Mr,
	cpu: "",
	os: ""
}, _i = {
	clientSecret: "",
	clientAssertion: void 0
}, vi = {
	azureCloudInstance: Nr.None,
	tenant: `${f}`
}, yi = { application: {
	appName: "",
	appVersion: ""
} };
function bi({ authOptions: e, systemOptions: t, loggerOptions: n, storageInterface: r, networkInterface: i, cryptoInterface: a, clientCredentials: o, libraryInfo: s, telemetry: c, serverTelemetryManager: l, persistencePlugin: u, serializableCache: d }) {
	let f = {
		...mi,
		...n
	};
	return {
		authOptions: xi(e),
		systemOptions: {
			...pi,
			...t
		},
		loggerOptions: f,
		storageInterface: r || new ui(e.clientId, Cr, new Ar(f), new fi()),
		networkInterface: i || hi,
		cryptoInterface: a || Cr,
		clientCredentials: o || _i,
		libraryInfo: {
			...gi,
			...s
		},
		telemetry: {
			...yi,
			...c
		},
		serverTelemetryManager: l || null,
		persistencePlugin: u || null,
		serializableCache: d || null
	};
}
function xi(e) {
	return {
		clientCapabilities: [],
		azureCloudOptions: vi,
		instanceAware: !1,
		isMcp: !1,
		...e
	};
}
function Si(e) {
	return e.authOptions.authority.options.protocolMode === M.OIDC;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/cache/persistence/TokenCacheContext.mjs
var Ci = class {
	constructor(e, t) {
		this.cache = e, this.hasChanged = t;
	}
	get cacheHasChanged() {
		return this.hasChanged;
	}
	get tokenCache() {
		return this.cache;
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/utils/TimeUtils.mjs
function N() {
	return Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
}
function wi(e) {
	return e.getTime() / 1e3;
}
function Ti(e) {
	return e ? /* @__PURE__ */ new Date(Number(e) * 1e3) : /* @__PURE__ */ new Date();
}
function Ei(e, t) {
	let n = Number(e) || 0;
	return N() + t > n;
}
function Di(e, t) {
	let n = Number(e) + t * 24 * 60 * 60 * 1e3;
	return Date.now() > n;
}
function Oi(e) {
	return Number(e) > N();
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/cache/utils/CacheHelpers.mjs
function ki(e, t, n, r, i) {
	return {
		credentialType: y.ID_TOKEN,
		homeAccountId: e,
		environment: t,
		clientId: r,
		secret: n,
		realm: i,
		lastUpdatedAt: Date.now().toString()
	};
}
function Ai(e, t, n, r, i, a, o, s, c, l, u, d, f) {
	let p = {
		homeAccountId: e,
		credentialType: y.ACCESS_TOKEN,
		secret: n,
		cachedAt: N().toString(),
		expiresOn: o.toString(),
		extendedExpiresOn: s.toString(),
		environment: t,
		clientId: r,
		realm: i,
		target: a,
		tokenType: u || x.BEARER,
		lastUpdatedAt: Date.now().toString()
	};
	if (d && (p.userAssertionHash = d), l && (p.refreshOn = l.toString()), p.tokenType?.toLowerCase() !== x.BEARER.toLowerCase()) switch (p.credentialType = y.ACCESS_TOKEN_WITH_AUTH_SCHEME, p.tokenType) {
		case x.POP:
			let e = Lr(n, c);
			if (!e?.cnf?.kid) throw T(wn);
			p.keyId = e.cnf.kid;
			break;
		case x.SSH: p.keyId = f;
	}
	return p;
}
function ji(e, t, n, r, i, a, o) {
	let s = {
		credentialType: y.REFRESH_TOKEN,
		homeAccountId: e,
		environment: t,
		clientId: r,
		secret: n,
		lastUpdatedAt: Date.now().toString()
	};
	return a && (s.userAssertionHash = a), i && (s.familyId = i), o && (s.expiresOn = o.toString()), s;
}
function Mi(e) {
	return e.hasOwnProperty("homeAccountId") && e.hasOwnProperty("environment") && e.hasOwnProperty("credentialType") && e.hasOwnProperty("clientId") && e.hasOwnProperty("secret");
}
function Ni(e) {
	return e ? Mi(e) && e.hasOwnProperty("realm") && e.hasOwnProperty("target") && (e.credentialType === y.ACCESS_TOKEN || e.credentialType === y.ACCESS_TOKEN_WITH_AUTH_SCHEME) : !1;
}
function Pi(e) {
	return e ? Mi(e) && e.hasOwnProperty("realm") && e.credentialType === y.ID_TOKEN : !1;
}
function Fi(e) {
	return e ? Mi(e) && e.credentialType === y.REFRESH_TOKEN : !1;
}
function Ii(e, t) {
	let n = e.indexOf(Oe) === 0, r = !0;
	return t && (r = t.hasOwnProperty("failedRequests") && t.hasOwnProperty("errors") && t.hasOwnProperty("cacheHits")), n && r;
}
function Li(e, t) {
	let n = !1;
	e && (n = e.indexOf(je) === 0);
	let r = !0;
	return t && (r = t.hasOwnProperty("throttleTime")), n && r;
}
function Ri({ environment: e, clientId: t }) {
	return [
		we,
		e,
		t
	].join("-").toLowerCase();
}
function zi(e, t) {
	return t ? e.indexOf("appmetadata") === 0 && t.hasOwnProperty("clientId") && t.hasOwnProperty("environment") : !1;
}
function Bi(e, t) {
	return t ? e.indexOf("authority-metadata") === 0 && t.hasOwnProperty("aliases") && t.hasOwnProperty("preferred_cache") && t.hasOwnProperty("preferred_network") && t.hasOwnProperty("canonical_authority") && t.hasOwnProperty("authorization_endpoint") && t.hasOwnProperty("token_endpoint") && t.hasOwnProperty("issuer") && t.hasOwnProperty("aliasesFromNetwork") && t.hasOwnProperty("endpointsFromNetwork") && t.hasOwnProperty("expiresAt") && t.hasOwnProperty("jwks_uri") : !1;
}
function Vi() {
	return N() + De;
}
function Hi(e, t, n) {
	e.authorization_endpoint = t.authorization_endpoint, e.token_endpoint = t.token_endpoint, e.end_session_endpoint = t.end_session_endpoint, e.issuer = t.issuer, e.endpointsFromNetwork = n, e.jwks_uri = t.jwks_uri;
}
function Ui(e, t, n) {
	e.aliases = t.aliases, e.preferred_cache = t.preferred_cache, e.preferred_network = t.preferred_network, e.aliasesFromNetwork = n;
}
function Wi(e) {
	return e.expiresAt <= N();
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/telemetry/performance/PerformanceEvents.mjs
var Gi = "networkClientSendPostRequestAsync", Ki = "refreshTokenClientExecutePostToTokenEndpoint", qi = "authorizationCodeClientExecutePostToTokenEndpoint", Ji = "refreshTokenClientExecuteTokenRequest", Yi = "refreshTokenClientAcquireToken", Xi = "refreshTokenClientAcquireTokenWithCachedRefreshToken", Zi = "refreshTokenClientCreateTokenRequestBody", Qi = "silentFlowClientGenerateResultFromCacheRecord", $i = "getAuthCodeUrl", ea = "handleCodeResponseFromServer", ta = "authClientExecuteTokenRequest", na = "authClientCreateTokenRequestBody", ra = "updateTokenEndpointAuthority", ia = "popTokenGenerateCnf", aa = "handleServerTokenResponse", oa = "authorityResolveEndpointsAsync", sa = "authorityGetCloudDiscoveryMetadataFromNetwork", ca = "authorityUpdateCloudDiscoveryMetadata", la = "authorityGetEndpointMetadataFromNetwork", ua = "authorityUpdateEndpointMetadata", da = "authorityUpdateMetadataWithRegionalInformation", fa = "regionDiscoveryDetectRegion", pa = "regionDiscoveryGetRegionFromIMDS", ma = "regionDiscoveryGetCurrentVersion", ha = "cacheManagerGetRefreshToken", ga = "setUserData", P = (e, t, n, r, i) => (...a) => {
	n.trace("1plfzx", i);
	let o = r.startMeasurement(t, i);
	i && r.incrementFields({ [`ext.${t}CallCount`]: 1 }, i);
	try {
		let t = e(...a);
		return o.end({ success: !0 }), n.trace("1g8n6a", i), t;
	} catch (e) {
		n.trace("0cfd8i", i);
		try {
			n.trace(JSON.stringify(e), i);
		} catch {
			n.trace("00dty7", i);
		}
		throw o.end({ success: !1 }, e), e;
	}
}, F = (e, t, n, r, i) => (...a) => {
	n.trace("1plfzx", i);
	let o = r.startMeasurement(t, i);
	return i && r.incrementFields({ [`ext.${t}CallCount`]: 1 }, i), e(...a).then((e) => (n.trace("1g8n6a", i), o.end({ success: !0 }), e)).catch((e) => {
		n.trace("0cfd8i", i);
		try {
			n.trace(JSON.stringify(e), i);
		} catch {
			n.trace("00dty7", i);
		}
		throw o.end({ success: !1 }, e), e;
	});
}, _a = { SW: "sw" }, va = class {
	constructor(e, t) {
		this.cryptoUtils = e, this.performanceClient = t;
	}
	async generateCnf(e, t) {
		let n = await F(this.generateKid.bind(this), ia, t, this.performanceClient, e.correlationId)(e), r = this.cryptoUtils.base64UrlEncode(JSON.stringify(n));
		return {
			kid: n.kid,
			reqCnfString: r
		};
	}
	async generateKid(e) {
		return {
			kid: await this.cryptoUtils.getPublicKeyThumbprint(e),
			xms_ksl: _a.SW
		};
	}
	async signPopToken(e, t, n) {
		return this.signPayload(e, t, n);
	}
	async signPayload(e, t, n, r) {
		let { resourceRequestMethod: i, resourceRequestUri: a, shrClaims: o, shrNonce: s, shrOptions: c } = n, l = (a ? new A(a) : void 0)?.getUrlComponents();
		return this.cryptoUtils.signJwt({
			at: e,
			ts: N(),
			m: i?.toUpperCase(),
			u: l?.HostNameAndPort,
			nonce: s || this.cryptoUtils.createNewGuid(),
			p: l?.AbsolutePath,
			q: l?.QueryString ? [[], l.QueryString] : void 0,
			client_claims: o || void 0,
			...r
		}, t, c, n.correlationId);
	}
}, ya = "no_tokens_found", ba = "native_account_unavailable", xa = "refresh_token_expired", Sa = "ux_not_allowed", Ca = [
	"interaction_required",
	"consent_required",
	"login_required",
	"bad_token",
	Sa,
	"interrupted_user"
], wa = [
	"message_only",
	"additional_action",
	"basic_action",
	"user_password_expired",
	"consent_required",
	"bad_token",
	"ux_not_allowed",
	"interrupted_user"
], I = class e extends S {
	constructor(t, n, r, i, a, o, s, c) {
		super(t, n, r), Object.setPrototypeOf(this, e.prototype), this.timestamp = i || "", this.traceId = a || "", this.correlationId = o || "", this.claims = s || "", this.name = "InteractionRequiredAuthError", this.errorNo = c;
	}
};
function Ta(e, t, n) {
	let r = !!e && Ca.indexOf(e) > -1, i = !!n && wa.indexOf(n) > -1, a = !!t && Ca.some((e) => t.indexOf(e) > -1);
	return r || a || i;
}
function Ea(e, t) {
	return new I(e, t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/ServerError.mjs
var Da = class e extends S {
	constructor(t, n, r, i, a) {
		super(t, n, r), this.name = "ServerError", this.errorNo = i, this.status = a, Object.setPrototypeOf(this, e.prototype);
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/utils/ProtocolUtils.mjs
function Oa(e, t, n) {
	let r = ka(e, n);
	return t ? `${r}|${t}` : r;
}
function ka(e, t) {
	if (!e) throw T(Sn);
	let n = { id: e.createNewGuid() };
	t && (n.meta = t);
	let r = JSON.stringify(n);
	return e.base64Encode(r);
}
function Aa(e, t) {
	if (!e) throw T(Sn);
	if (!t) throw T(sn);
	try {
		let n = t.split("|"), r = n[0], i = n.length > 1 ? n.slice(1).join("|") : "", a = e(r), o = JSON.parse(a);
		return {
			userRequestState: i || "",
			libraryState: o
		};
	} catch {
		throw T(sn);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/response/ResponseHandler.mjs
var ja = class e {
	constructor(e, t, n, r, i, a, o) {
		this.clientId = e, this.cacheStorage = t, this.cryptoObj = n, this.logger = r, this.performanceClient = i, this.serializableCache = a, this.persistencePlugin = o;
	}
	validateTokenResponse(e, t, n) {
		if (e.error || e.error_description || e.suberror) {
			let r = `Error(s): ${e.error_codes || "Not Available"} - Timestamp: ${e.timestamp || "Not Available"} - Description: ${e.error_description || "Not Available"} - Correlation ID: ${e.correlation_id || "Not Available"} - Trace ID: ${e.trace_id || "Not Available"}`, i = e.error_codes?.length ? e.error_codes[0] : void 0, a = new Da(e.error, r, e.suberror, i, e.status);
			if (n && e.status && e.status >= 500 && e.status <= 599) {
				this.logger.warning("16ks7j", t);
				return;
			} else if (n && e.status && e.status >= 400 && e.status <= 499) {
				this.logger.warning("0g61x3", t);
				return;
			}
			throw Ta(e.error, e.error_description, e.suberror) ? new I(e.error, e.error_description, e.suberror, e.timestamp || "", e.trace_id || "", e.correlation_id || "", e.claims || "", i) : a;
		}
	}
	async handleServerTokenResponse(t, n, r, i, a, o, s, c, l, u) {
		let d;
		if (t.id_token) {
			if (d = Lr(t.id_token || "", this.cryptoObj.base64Decode), o && o.nonce && d.nonce !== o.nonce) throw T(un);
			if (i.maxAge || i.maxAge === 0) {
				let e = d.auth_time;
				if (!e) throw T(dn);
				Br(e, i.maxAge);
			}
		}
		this.homeAccountIdentifier = si(t.client_info || "", n.authorityType, this.logger, this.cryptoObj, i.correlationId, d);
		let f;
		o && o.state && (f = Aa(this.cryptoObj.base64Decode, o.state)), t.key_id = t.key_id || i.sshKid || void 0;
		let p = this.generateCacheRecord(t, n, r, i, d, s, o), m;
		try {
			if (this.persistencePlugin && this.serializableCache && (this.logger.verbose("0jbz5k", i.correlationId), m = new Ci(this.serializableCache, !0), await this.persistencePlugin.beforeCacheAccess(m)), c && !l && p.account && this.cacheStorage.getAllAccounts({
				homeAccountId: p.account.homeAccountId,
				environment: p.account.environment
			}, i.correlationId).length < 1) return this.logger.warning("1gmt66", i.correlationId), this.performanceClient?.addFields({ acntLoggedOut: !0 }, i.correlationId), await e.generateAuthenticationResult(this.cryptoObj, n, p, !1, i, this.performanceClient, d, f, void 0, u);
			await this.cacheStorage.saveCacheRecord(p, i.correlationId, Rr(d || {}), a, i.storeInCache);
		} finally {
			this.persistencePlugin && this.serializableCache && m && (this.logger.verbose("1bh17u", i.correlationId), await this.persistencePlugin.afterCacheAccess(m));
		}
		return e.generateAuthenticationResult(this.cryptoObj, n, p, !1, i, this.performanceClient, d, f, t, u);
	}
	generateCacheRecord(e, t, n, r, i, a, o) {
		let s = t.getPreferredCache();
		if (!s) throw T(bn);
		let c = ri(i), l, u;
		e.id_token && i && (l = ki(this.homeAccountIdentifier, s, e.id_token, this.clientId, c || ""), u = Ma(this.cacheStorage, t, this.homeAccountIdentifier, this.cryptoObj.base64Decode, r.correlationId, i, e.client_info, s, c, o, void 0, this.logger, this.performanceClient));
		let d = null;
		if (e.access_token) {
			let i = e.scope ? D.fromString(e.scope) : new D(r.scopes || []), o = (typeof e.expires_in == "string" ? parseInt(e.expires_in, 10) : e.expires_in) || 0, l = (typeof e.ext_expires_in == "string" ? parseInt(e.ext_expires_in, 10) : e.ext_expires_in) || 0, u = (typeof e.refresh_in == "string" ? parseInt(e.refresh_in, 10) : e.refresh_in) || void 0, f = n + o, p = f + l, m = u && u > 0 ? n + u : void 0;
			d = Ai(this.homeAccountIdentifier, s, e.access_token, this.clientId, c || t.tenant || "", i.printScopes(), f, p, this.cryptoObj.base64Decode, m, e.token_type, a, e.key_id);
			let h = r.resource || null;
			h && (d.resource = h);
		}
		let f = null;
		if (e.refresh_token) {
			let t;
			e.refresh_token_expires_in && (t = n + (typeof e.refresh_token_expires_in == "string" ? parseInt(e.refresh_token_expires_in, 10) : e.refresh_token_expires_in), this.performanceClient?.addFields({ ntwkRtExpiresOnSeconds: t }, r.correlationId)), f = ji(this.homeAccountIdentifier, s, e.refresh_token, this.clientId, e.foci, a, t);
		}
		let p = null;
		return e.foci && (p = {
			clientId: this.clientId,
			environment: s,
			familyId: e.foci
		}), {
			account: u,
			idToken: l,
			accessToken: d,
			refreshToken: f,
			appMetadata: p
		};
	}
	static async generateAuthenticationResult(e, t, n, r, i, a, o, s, c, l) {
		let u = "", d = [], f = null, p, m, h = "";
		if (n.accessToken) {
			if (n.accessToken.tokenType === x.POP && !i.popKid) {
				let t = new va(e, a), { secret: r, keyId: o } = n.accessToken;
				if (!o) throw T(On);
				u = await t.signPopToken(r, o, i);
			} else u = n.accessToken.secret;
			d = D.fromString(n.accessToken.target).asArray(), f = Ti(n.accessToken.expiresOn), p = Ti(n.accessToken.extendedExpiresOn), n.accessToken.refreshOn && (m = Ti(n.accessToken.refreshOn));
		}
		n.appMetadata && (h = n.appMetadata.familyId === "1" ? "1" : "");
		let ee = o?.oid || o?.sub || "", g = o?.tid || "";
		c?.spa_accountid && n.account && (n.account.nativeAccountId = c?.spa_accountid);
		let te = n.account ? Ir(ii(n.account), void 0, o, n.idToken?.secret) : null;
		return {
			authority: t.canonicalAuthority,
			uniqueId: ee,
			tenantId: g,
			scopes: d,
			account: te,
			idToken: n?.idToken?.secret || "",
			idTokenClaims: o || {},
			accessToken: u,
			fromCache: r,
			expiresOn: f,
			extExpiresOn: p,
			refreshOn: m,
			correlationId: i.correlationId,
			requestId: l || "",
			familyId: h,
			tokenType: n.accessToken?.tokenType || "",
			state: s ? s.userRequestState : "",
			cloudGraphHostName: n.account?.cloudGraphHostName || "",
			msGraphHost: n.account?.msGraphHost || "",
			code: c?.spa_code,
			fromPlatformBroker: !1
		};
	}
};
function Ma(e, t, n, r, i, a, o, s, c, l, u, d, f) {
	d?.verbose("09jz0t", i);
	let p = s || t.getPreferredCache(), m = e.getAccountsFilteredBy({
		homeAccountId: n,
		environment: p
	}, i);
	f?.addFields({ cacheMatchedAccounts: m.length }, i), m.length > 1 && d?.warning("0x7ad1", i);
	let h = (m.length === 1 ? m[0] : null) || ai({
		homeAccountId: n,
		idTokenClaims: a,
		clientInfo: o,
		environment: s,
		cloudGraphHostName: l?.cloud_graph_host_name,
		msGraphHost: l?.msgraph_host,
		nativeAccountId: u
	}, t, r), ee = h.tenantProfiles || [], g = c || h.realm;
	if (g && !ee.find((e) => e.tenantId === g)) {
		let e = Fr(n, h.localAccountId, g, a);
		ee.push(e);
	}
	return h.tenantProfiles = ee, h;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/account/CcsCredential.mjs
var L = {
	HOME_ACCOUNT_ID: "home_account_id",
	UPN: "UPN"
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/utils/ClientAssertionUtils.mjs
async function Na(e, t, n) {
	return typeof e == "string" ? e : e({
		clientId: t,
		tokenEndpoint: n
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/network/RequestThumbprint.mjs
function Pa(e, t, n) {
	return {
		clientId: e,
		authority: t.authority,
		scopes: t.scopes,
		homeAccountIdentifier: n,
		claims: t.claims,
		authenticationScheme: t.authenticationScheme,
		resourceRequestMethod: t.resourceRequestMethod,
		resourceRequestUri: t.resourceRequestUri,
		shrClaims: t.shrClaims,
		sshKid: t.sshKid,
		embeddedClientId: t.embeddedClientId || t.extraParameters?.clientId
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/network/ThrottlingUtils.mjs
var Fa = class e {
	static generateThrottlingStorageKey(e) {
		return `${je}.${JSON.stringify(e)}`;
	}
	static preProcess(t, n, r) {
		let i = e.generateThrottlingStorageKey(n), a = t.getThrottlingCache(i, r);
		if (a) {
			if (a.throttleTime < Date.now()) {
				t.removeItem(i, r);
				return;
			}
			throw new Da(a.errorCodes?.join(" ") || "", a.errorMessage, a.subError);
		}
	}
	static postProcess(t, n, r, i) {
		if (e.checkResponseStatus(r) || e.checkResponseForRetryAfter(r)) {
			let a = {
				throttleTime: e.calculateThrottleTime(parseInt(r.headers[_.RETRY_AFTER])),
				error: r.body.error,
				errorCodes: r.body.error_codes,
				errorMessage: r.body.error_description,
				subError: r.body.suberror
			};
			t.setThrottlingCache(e.generateThrottlingStorageKey(n), a, i);
		}
	}
	static checkResponseStatus(e) {
		return e.status === 429 || e.status >= 500 && e.status < 600;
	}
	static checkResponseForRetryAfter(e) {
		return e.headers ? e.headers.hasOwnProperty(_.RETRY_AFTER) && (e.status < 200 || e.status >= 300) : !1;
	}
	static calculateThrottleTime(e) {
		let t = e <= 0 ? 0 : e, n = Date.now() / 1e3;
		return Math.floor(Math.min(n + (t || 60), n + Ae) * 1e3);
	}
	static removeThrottle(e, t, n, r) {
		let i = Pa(t, n, r), a = this.generateThrottlingStorageKey(i);
		e.removeItem(a, n.correlationId);
	}
}, Ia = class e extends S {
	constructor(t, n, r) {
		super(t.errorCode, t.errorMessage, t.subError), Object.setPrototypeOf(this, e.prototype), this.name = "NetworkError", this.error = t, this.httpStatus = n, this.responseHeaders = r;
	}
};
function La(e, t, n, r) {
	return e.errorMessage = `${e.errorMessage}, additionalErrorInfo: error.name:${r?.name}, error.message:${r?.message}`, new Ia(e, t, n);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/protocol/Token.mjs
function Ra(e, t, n) {
	let r = {};
	if (r[_.CONTENT_TYPE] = oe, !t && n) switch (n.type) {
		case L.HOME_ACCOUNT_ID:
			try {
				let e = ni(n.credential);
				r[_.CCS_HEADER] = `Oid:${e.uid}@${e.utid}`;
			} catch {
				e.verbose("1qhtee", "");
			}
			break;
		case L.UPN:
			r[_.CCS_HEADER] = `UPN: ${n.credential}`;
			break;
	}
	return r;
}
function za(e, t, n, r) {
	let i = /* @__PURE__ */ new Map();
	return e.embeddedClientId && hr(i, t, n), e.extraQueryParameters && O(i, e.extraQueryParameters), Kn(i, e.correlationId), jn(i, e.correlationId, r), xr(i);
}
async function Ba(e, t, n, r, i, a, o, s, c, l) {
	let u = await Va(r, e, {
		body: t,
		headers: n
	}, i, a, o, s, c);
	return l && u.status < 500 && u.status !== 429 && l.clearTelemetryCache(), u;
}
async function Va(e, t, n, r, i, a, o, s) {
	Fa.preProcess(i, e, r);
	let c;
	try {
		c = await F(a.sendPostRequestAsync.bind(a), Gi, o, s, r)(t, n);
		let e = c.headers || {};
		s?.addFields({
			refreshTokenSize: c.body.refresh_token?.length || 0,
			httpVerToken: e[_.X_MS_HTTP_VERSION] || "",
			requestId: e[_.X_MS_REQUEST_ID] || ""
		}, r);
	} catch (e) {
		if (e instanceof Ia) {
			let t = e.responseHeaders;
			throw t && s?.addFields({
				httpVerToken: t[_.X_MS_HTTP_VERSION] || "",
				requestId: t[_.X_MS_REQUEST_ID] || "",
				contentTypeHeader: t[_.CONTENT_TYPE] || void 0,
				contentLengthHeader: t[_.CONTENT_LENGTH] || void 0,
				httpStatus: e.httpStatus
			}, r), e.error;
		}
		throw e instanceof S ? e : T(rn);
	}
	return Fa.postProcess(i, e, c, r), c;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/OpenIdConfigResponse.mjs
function Ha(e) {
	return e.hasOwnProperty("authorization_endpoint") && e.hasOwnProperty("token_endpoint") && e.hasOwnProperty("issuer") && e.hasOwnProperty("jwks_uri");
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/CloudInstanceDiscoveryResponse.mjs
function Ua(e) {
	return e.hasOwnProperty("tenant_discovery_endpoint") && e.hasOwnProperty("metadata");
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/CloudInstanceDiscoveryErrorResponse.mjs
function Wa(e) {
	return e.hasOwnProperty("error") && e.hasOwnProperty("error_description");
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/RegionDiscovery.mjs
var Ga = class e {
	constructor(e, t, n, r) {
		this.networkInterface = e, this.logger = t, this.performanceClient = n, this.correlationId = r;
	}
	async detectRegion(t, n) {
		let r = t;
		if (r) n.region_source = Ne.ENVIRONMENT_VARIABLE;
		else {
			let t = e.IMDS_OPTIONS;
			try {
				let e = await F(this.getRegionFromIMDS.bind(this), pa, this.logger, this.performanceClient, this.correlationId)(ce, t);
				if (e.status === 200 && (r = e.body, n.region_source = Ne.IMDS), e.status === 400) {
					let e = await F(this.getCurrentVersion.bind(this), ma, this.logger, this.performanceClient, this.correlationId)(t);
					if (!e) return n.region_source = Ne.FAILED_AUTO_DETECTION, null;
					let i = await F(this.getRegionFromIMDS.bind(this), pa, this.logger, this.performanceClient, this.correlationId)(e, t);
					i.status === 200 && (r = i.body, n.region_source = Ne.IMDS);
				}
			} catch {
				return n.region_source = Ne.FAILED_AUTO_DETECTION, null;
			}
		}
		return r || (n.region_source = Ne.FAILED_AUTO_DETECTION), r || null;
	}
	async getRegionFromIMDS(e, t) {
		return this.networkInterface.sendGetRequestAsync(`${se}?api-version=${e}&format=text`, t, le);
	}
	async getCurrentVersion(e) {
		try {
			let t = await this.networkInterface.sendGetRequestAsync(`${se}?format=json`, e);
			return t.status === 400 && t.body && t.body["newest-versions"] && t.body["newest-versions"].length > 0 ? t.body["newest-versions"][0] : null;
		} catch {
			return null;
		}
	}
};
Ga.IMDS_OPTIONS = { headers: { Metadata: "true" } };
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/Authority.mjs
var Ka = class e {
	constructor(e, t, n, r, i, a, o, s) {
		this.canonicalAuthority = e, this._canonicalAuthority.validateAsUri(), this.networkInterface = t, this.cacheManager = n, this.authorityOptions = r, this.regionDiscoveryMetadata = {
			region_used: void 0,
			region_source: void 0,
			region_outcome: void 0
		}, this.logger = i, this.performanceClient = o, this.correlationId = a, this.managedIdentity = s || !1, this.regionDiscovery = new Ga(t, this.logger, this.performanceClient, this.correlationId);
	}
	getAuthorityType(e) {
		if (e.HostNameAndPort.endsWith(".ciamlogin.com")) return j.Ciam;
		let t = e.PathSegments;
		if (t.length) switch (t[0].toLowerCase()) {
			case p: return j.Adfs;
			case m: return j.Dsts;
		}
		return j.Default;
	}
	get authorityType() {
		return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
	}
	get protocolMode() {
		return this.authorityOptions.protocolMode;
	}
	get options() {
		return this.authorityOptions;
	}
	get canonicalAuthority() {
		return this._canonicalAuthority.urlString;
	}
	set canonicalAuthority(e) {
		this._canonicalAuthority = new A(e), this._canonicalAuthority.validateAsUri(), this._canonicalAuthorityUrlComponents = null;
	}
	get canonicalAuthorityUrlComponents() {
		return this._canonicalAuthorityUrlComponents ||= this._canonicalAuthority.getUrlComponents(), this._canonicalAuthorityUrlComponents;
	}
	get hostnameAndPort() {
		return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
	}
	get tenant() {
		return this.canonicalAuthorityUrlComponents.PathSegments[0];
	}
	get authorizationEndpoint() {
		if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
		throw T(nn);
	}
	get tokenEndpoint() {
		if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
		throw T(nn);
	}
	get deviceCodeEndpoint() {
		if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
		throw T(nn);
	}
	get endSessionEndpoint() {
		if (this.discoveryComplete()) {
			if (!this.metadata.end_session_endpoint) throw T(Dn);
			return this.replacePath(this.metadata.end_session_endpoint);
		} else throw T(nn);
	}
	get selfSignedJwtAudience() {
		if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
		throw T(nn);
	}
	get jwksUri() {
		if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
		throw T(nn);
	}
	canReplaceTenant(t) {
		return t.PathSegments.length === 1 && !e.reservedTenantDomains.has(t.PathSegments[0]) && this.getAuthorityType(t) === j.Default && this.protocolMode !== M.OIDC;
	}
	replaceTenant(e) {
		return e.replace(/{tenant}|{tenantid}/g, this.tenant);
	}
	replacePath(e) {
		let t = e, n = new A(this.metadata.canonical_authority).getUrlComponents(), r = n.PathSegments;
		return this.canonicalAuthorityUrlComponents.PathSegments.forEach((e, i) => {
			let a = r[i];
			if (i === 0 && this.canReplaceTenant(n)) {
				let e = new A(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
				a !== e && (this.logger.verbose("1q3g2x", this.correlationId), a = e);
			}
			e !== a && (t = t.replace(`/${a}/`, `/${e}/`));
		}), this.replaceTenant(t);
	}
	get defaultOpenIdConfigurationEndpoint() {
		let e = this.hostnameAndPort;
		return this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === j.Adfs || this.protocolMode === M.OIDC && !this.isAliasOfKnownMicrosoftAuthority(e) ? `${this.canonicalAuthority}.well-known/openid-configuration` : `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
	}
	discoveryComplete() {
		return !!this.metadata;
	}
	async resolveEndpointsAsync() {
		let e = this.getCurrentMetadataEntity(), t = await F(this.updateCloudDiscoveryMetadata.bind(this), ca, this.logger, this.performanceClient, this.correlationId)(e);
		this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, e.preferred_network);
		let n = await F(this.updateEndpointMetadata.bind(this), ua, this.logger, this.performanceClient, this.correlationId)(e);
		this.updateCachedMetadata(e, t, { source: n }), this.performanceClient?.addFields({
			cloudDiscoverySource: t,
			authorityEndpointSource: n
		}, this.correlationId);
	}
	getCurrentMetadataEntity() {
		let e = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort, this.correlationId);
		return e ||= {
			aliases: [],
			preferred_cache: this.hostnameAndPort,
			preferred_network: this.hostnameAndPort,
			canonical_authority: this.canonicalAuthority,
			authorization_endpoint: "",
			token_endpoint: "",
			end_session_endpoint: "",
			issuer: "",
			aliasesFromNetwork: !1,
			endpointsFromNetwork: !1,
			expiresAt: Vi(),
			jwks_uri: ""
		}, e;
	}
	updateCachedMetadata(e, t, n) {
		t !== b.CACHE && n?.source !== b.CACHE && (e.expiresAt = Vi(), e.canonical_authority = this.canonicalAuthority);
		let r = this.cacheManager.generateAuthorityMetadataCacheKey(e.preferred_cache, this.correlationId);
		this.cacheManager.setAuthorityMetadata(r, e, this.correlationId), this.metadata = e;
	}
	async updateEndpointMetadata(e) {
		let t = this.updateEndpointMetadataFromLocalSources(e);
		if (t) return t.source === b.HARDCODED_VALUES && this.authorityOptions.azureRegionConfiguration?.azureRegion && t.metadata && (Hi(e, await F(this.updateMetadataWithRegionalInformation.bind(this), da, this.logger, this.performanceClient, this.correlationId)(t.metadata), !1), e.canonical_authority = this.canonicalAuthority), t.source;
		let n = await F(this.getEndpointMetadataFromNetwork.bind(this), la, this.logger, this.performanceClient, this.correlationId)();
		if (n) return this.validateIssuer(n.issuer), this.authorityOptions.azureRegionConfiguration?.azureRegion && (n = await F(this.updateMetadataWithRegionalInformation.bind(this), da, this.logger, this.performanceClient, this.correlationId)(n)), Hi(e, n, !0), b.NETWORK;
		throw T(an, this.defaultOpenIdConfigurationEndpoint);
	}
	updateEndpointMetadataFromLocalSources(e) {
		this.logger.verbose("1fi0kc", this.correlationId);
		let t = this.getEndpointMetadataFromConfig();
		if (t) return this.logger.verbose("06t0uj", this.correlationId), Hi(e, t, !1), { source: b.CONFIG };
		this.logger.verbose("151k0p", this.correlationId);
		let n = this.getEndpointMetadataFromHardcodedValues();
		if (n) return Hi(e, n, !1), {
			source: b.HARDCODED_VALUES,
			metadata: n
		};
		this.logger.verbose("1imop5", this.correlationId);
		let r = Wi(e);
		return this.isAuthoritySameType(e) && e.endpointsFromNetwork && !r ? (this.logger.verbose("16uq31", ""), { source: b.CACHE }) : (r && this.logger.verbose("0uoibc", ""), null);
	}
	isAuthoritySameType(e) {
		return new A(e.canonical_authority).getUrlComponents().PathSegments.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
	}
	getEndpointMetadataFromConfig() {
		if (this.authorityOptions.authorityMetadata) try {
			return JSON.parse(this.authorityOptions.authorityMetadata);
		} catch {
			throw C(Ht);
		}
		return null;
	}
	async getEndpointMetadataFromNetwork() {
		let e = {}, t = this.defaultOpenIdConfigurationEndpoint;
		this.logger.verbose("1y65x6", this.correlationId);
		try {
			let n = await this.networkInterface.sendGetRequestAsync(t, e);
			return Ha(n.body) ? n.body : (this.logger.verbose("1koyv8", this.correlationId), null);
		} catch {
			return this.logger.verbose("0a9wik", this.correlationId), null;
		}
	}
	getEndpointMetadataFromHardcodedValues() {
		return this.hostnameAndPort in Wr ? Wr[this.hostnameAndPort] : null;
	}
	async updateMetadataWithRegionalInformation(t) {
		let n = this.authorityOptions.azureRegionConfiguration?.azureRegion;
		if (n) {
			if (n !== "TryAutoDetect") return this.regionDiscoveryMetadata.region_outcome = Pe.CONFIGURED_NO_AUTO_DETECTION, this.regionDiscoveryMetadata.region_used = n, e.replaceWithRegionalInformation(t, n);
			let r = await F(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), fa, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
			if (r) return this.regionDiscoveryMetadata.region_outcome = Pe.AUTO_DETECTION_REQUESTED_SUCCESSFUL, this.regionDiscoveryMetadata.region_used = r, e.replaceWithRegionalInformation(t, r);
			this.regionDiscoveryMetadata.region_outcome = Pe.AUTO_DETECTION_REQUESTED_FAILED;
		}
		return t;
	}
	async updateCloudDiscoveryMetadata(e) {
		let t = this.updateCloudDiscoveryMetadataFromLocalSources(e);
		if (t) return t;
		let n = await F(this.getCloudDiscoveryMetadataFromNetwork.bind(this), sa, this.logger, this.performanceClient, this.correlationId)();
		if (n) return Ui(e, n, !0), b.NETWORK;
		throw C(Ut);
	}
	updateCloudDiscoveryMetadataFromLocalSources(e) {
		this.logger.verbose("1tpqlr", this.correlationId), this.logger.verbosePii("1fy7uz", this.correlationId), this.logger.verbosePii("08zabj", this.correlationId), this.logger.verbosePii("1o1kv3", this.correlationId);
		let t = this.getCloudDiscoveryMetadataFromConfig();
		if (t) return this.logger.verbose("1nakio", this.correlationId), Ui(e, t, !1), b.CONFIG;
		this.logger.verbose("1x74aj", this.correlationId);
		let n = Yr(this.hostnameAndPort);
		if (n) return this.logger.verbose("0by47c", this.correlationId), Ui(e, n, !1), b.HARDCODED_VALUES;
		this.logger.verbose("0r2fzy", this.correlationId);
		let r = Wi(e);
		return this.isAuthoritySameType(e) && e.aliasesFromNetwork && !r ? (this.logger.verbose("1uffgh", ""), b.CACHE) : (r && this.logger.verbose("0uoibc", ""), null);
	}
	getCloudDiscoveryMetadataFromConfig() {
		if (this.authorityType === j.Ciam) return this.logger.verbose("04y84h", this.correlationId), e.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
		if (this.authorityOptions.cloudDiscoveryMetadata) {
			this.logger.verbose("0gszr3", this.correlationId);
			try {
				this.logger.verbose("1iifkx", this.correlationId);
				let e = Xr(JSON.parse(this.authorityOptions.cloudDiscoveryMetadata).metadata, this.hostnameAndPort);
				if (this.logger.verbose("0q67e3", ""), e) return this.logger.verbose("0hzfao", this.correlationId), e;
				this.logger.verbose("1ajz3u", this.correlationId);
			} catch {
				throw this.logger.verbose("1wq5tu", this.correlationId), C(Vt);
			}
		}
		return this.isInKnownAuthorities() ? (this.logger.verbose("0mt9al", this.correlationId), e.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort)) : null;
	}
	async getCloudDiscoveryMetadataFromNetwork() {
		let t = `${h}${this.canonicalAuthority}oauth2/v2.0/authorize`, n = {}, r = null;
		try {
			let e = await this.networkInterface.sendGetRequestAsync(t, n), i, a;
			if (Ua(e.body)) i = e.body, a = i.metadata, this.logger.verbosePii("1vglyt", this.correlationId);
			else if (Wa(e.body)) {
				if (this.logger.warning("062uto", this.correlationId), i = e.body, i.error === "invalid_instance") return this.logger.error("1x90tm", this.correlationId), null;
				this.logger.warning("0wchdm", this.correlationId), this.logger.warning("1s5mpv", this.correlationId), this.logger.warning("1yhqpw", this.correlationId), a = [];
			} else return this.logger.error("0768g0", this.correlationId), null;
			this.logger.verbose("1lrobr", this.correlationId), r = Xr(a, this.hostnameAndPort);
		} catch (e) {
			return e instanceof S ? this.logger.error("0vwhc7", this.correlationId) : this.logger.error("0s2z41", this.correlationId), null;
		}
		return r ||= (this.logger.warning("0jp28q", this.correlationId), this.logger.verbose("130sd8", this.correlationId), e.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort)), r;
	}
	isInKnownAuthorities() {
		return this.authorityOptions.knownAuthorities.filter((e) => e && A.getDomainFromUrl(e).toLowerCase() === this.hostnameAndPort).length > 0;
	}
	static generateAuthority(e, t) {
		let n;
		if (t && t.azureCloudInstance !== Nr.None) {
			let e = t.tenant ? t.tenant : f;
			n = `${t.azureCloudInstance}/${e}/`;
		}
		return n || e;
	}
	static createCloudDiscoveryMetadataFromHost(e) {
		return {
			preferred_network: e,
			preferred_cache: e,
			aliases: [e]
		};
	}
	getPreferredCache() {
		if (this.managedIdentity) return d;
		if (this.discoveryComplete()) return this.metadata.preferred_cache;
		throw T(nn);
	}
	isAlias(e) {
		return this.metadata.aliases.indexOf(e) > -1;
	}
	isAliasOfKnownMicrosoftAuthority(e) {
		return Kr.has(e);
	}
	validateIssuer(e) {
		if (!e) throw C(Zt);
		let t;
		try {
			t = new URL(e);
		} catch {
			throw C(Zt);
		}
		let n = t.protocol, r = t.host, i = (this.canonicalAuthorityUrlComponents.Protocol || "").toLowerCase(), a = (this.canonicalAuthorityUrlComponents.HostNameAndPort || "").toLowerCase(), o = this.matchesAuthorityOrigin(n, r, i, a), s = n === "https:" && this.isAliasOfKnownMicrosoftAuthority(r), c = n === "https:" && this.matchesRegionalMicrosoftHost(r), l = this.matchesCiamTenantPattern(t, a, this.canonicalAuthorityUrlComponents.PathSegments);
		if (!(o || s || c || l)) throw C(Zt);
	}
	matchesAuthorityOrigin(e, t, n, r) {
		return e === n && t === r;
	}
	matchesRegionalMicrosoftHost(e) {
		let t = e.indexOf(".");
		if (t > 0 && t < e.length - 1) {
			let n = e.substring(t + 1);
			return this.isAliasOfKnownMicrosoftAuthority(n);
		}
		return !1;
	}
	matchesCiamTenantPattern(e, t, n) {
		let r = n[0], i = r ? r.endsWith(".onmicrosoft.com") ? r.slice(0, -g.length) : r : t.split(".")[0];
		if (!i) return !1;
		let a = `https://${i}${ee}`, o = [
			a,
			`${a}/${i}`,
			`${a}/${i}/v2.0`,
			`${a}/${i}${g}`,
			`${a}/${i}${g}/v2.0`
		], s = e.pathname.replace(/\/+$/, ""), c = `${e.protocol}//${e.host}${s}`;
		return o.some((e) => e === c);
	}
	static isPublicCloudAuthority(e) {
		return de.indexOf(e) >= 0;
	}
	static buildRegionalAuthorityString(e, t, n) {
		let r = new A(e);
		r.validateAsUri();
		let i = r.getUrlComponents(), a = `${t}.${i.HostNameAndPort}`;
		this.isPublicCloudAuthority(i.HostNameAndPort) && (a = `${t}.${ue}`);
		let o = A.constructAuthorityUriFromObject({
			...r.getUrlComponents(),
			HostNameAndPort: a
		}).urlString;
		return n ? `${o}?${n}` : o;
	}
	static replaceWithRegionalInformation(t, n) {
		let r = { ...t };
		return r.authorization_endpoint = e.buildRegionalAuthorityString(r.authorization_endpoint, n), r.token_endpoint = e.buildRegionalAuthorityString(r.token_endpoint, n), r.end_session_endpoint &&= e.buildRegionalAuthorityString(r.end_session_endpoint, n), r;
	}
	static transformCIAMAuthority(e) {
		let t = e, n = new A(e).getUrlComponents();
		if (n.PathSegments.length === 0 && n.HostNameAndPort.endsWith(".ciamlogin.com")) {
			let e = n.HostNameAndPort.split(".")[0];
			t = `${t}${e}${g}`;
		}
		return t;
	}
};
Ka.reservedTenantDomains = /* @__PURE__ */ new Set([
	"{tenant}",
	"{tenantid}",
	ge.COMMON,
	ge.CONSUMERS,
	ge.ORGANIZATIONS
]);
function qa(e) {
	let t = new A(e).getUrlComponents().PathSegments.slice(-1)[0]?.toLowerCase();
	switch (t) {
		case ge.COMMON:
		case ge.ORGANIZATIONS:
		case ge.CONSUMERS: return;
		default: return t;
	}
}
function Ja(e) {
	return e.endsWith("/") ? e : `${e}/`;
}
function Ya(e) {
	let t = e.cloudDiscoveryMetadata, n;
	if (t) try {
		n = JSON.parse(t);
	} catch {
		throw C(Vt);
	}
	return {
		canonicalAuthority: e.authority ? Ja(e.authority) : void 0,
		knownAuthorities: e.knownAuthorities,
		cloudDiscoveryMetadata: n
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/authority/AuthorityFactory.mjs
async function Xa(e, t, n, r, i, a, o) {
	let s = new Ka(Ka.transformCIAMAuthority(Ja(e)), t, n, r, i, a, o);
	try {
		return await F(s.resolveEndpointsAsync.bind(s), oa, i, o, a)(), s;
	} catch {
		throw T(nn);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/client/AuthorizationCodeClient.mjs
var Za = class {
	constructor(e, t) {
		this.includeRedirectUri = !0, this.config = bi(e), this.logger = new Ar(this.config.loggerOptions, jr, Mr), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = t, this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
	}
	async acquireToken(e, t, n) {
		if (!e.code) throw T(mn);
		n && n.cloud_instance_host_name && await F(this.updateTokenEndpointAuthority.bind(this), ra, this.logger, this.performanceClient, e.correlationId)(n.cloud_instance_host_name, e.correlationId);
		let r = N(), i = await F(this.executeTokenRequest.bind(this), ta, this.logger, this.performanceClient, e.correlationId)(this.authority, e, this.serverTelemetryManager), a = i.headers?.[_.X_MS_REQUEST_ID], o = new ja(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin);
		return o.validateTokenResponse(i.body, e.correlationId), F(o.handleServerTokenResponse.bind(o), aa, this.logger, this.performanceClient, e.correlationId)(i.body, this.authority, r, e, t, n, void 0, void 0, void 0, a);
	}
	getLogoutUri(e) {
		if (!e) throw C(zt);
		let t = this.createLogoutUrlQueryString(e);
		return A.appendQueryString(this.authority.endSessionEndpoint, t);
	}
	async executeTokenRequest(e, t, n) {
		let r = za(t, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient), i = A.appendQueryString(e.tokenEndpoint, r), a = await F(this.createTokenRequestBody.bind(this), na, this.logger, this.performanceClient, t.correlationId)(t), o;
		if (t.clientInfo) try {
			let e = ti(t.clientInfo, this.cryptoUtils.base64Decode);
			o = {
				credential: `${e.uid}.${e.utid}`,
				type: L.HOME_ACCOUNT_ID
			};
		} catch {
			this.logger.verbose("0wznt3", t.correlationId);
		}
		let s = Ra(this.logger, this.config.systemOptions.preventCorsPreflight, o || t.ccsCredential), c = Pa(this.config.authOptions.clientId, t);
		return F(Ba, qi, this.logger, this.performanceClient, t.correlationId)(i, a, s, c, t.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, n);
	}
	async createTokenRequestBody(e) {
		let t = /* @__PURE__ */ new Map();
		if (In(t, e.embeddedClientId || e.extraParameters?.client_id || this.config.authOptions.clientId), this.includeRedirectUri) Ln(t, e.redirectUri);
		else if (!e.redirectUri) throw C(Mt);
		if (Fn(t, e.scopes, !0, this.oidcDefaultScopes), _r(t, e.resource), $n(t, e.code), qn(t, this.config.libraryInfo), Jn(t, this.config.telemetry.application), pr(t), this.serverTelemetryManager && !Si(this.config) && fr(t, this.serverTelemetryManager), e.codeVerifier && tr(t, e.codeVerifier), this.config.clientCredentials.clientSecret && nr(t, this.config.clientCredentials.clientSecret), this.config.clientCredentials.clientAssertion) {
			let n = this.config.clientCredentials.clientAssertion;
			rr(t, await Na(n.assertion, this.config.authOptions.clientId, e.resourceRequestUri)), ir(t, n.assertionType);
		}
		if (ar(t, be.AUTHORIZATION_CODE_GRANT), or(t), e.authenticationScheme === x.POP) {
			let n = new va(this.cryptoUtils, this.performanceClient), r;
			r = e.popKid ? this.cryptoUtils.encodeKid(e.popKid) : (await F(n.generateCnf.bind(n), ia, this.logger, this.performanceClient, e.correlationId)(e, this.logger)).reqCnfString, ur(t, r);
		} else if (e.authenticationScheme === x.SSH) if (e.sshJwk) dr(t, e.sshJwk);
		else throw C(Wt);
		let n;
		if (e.clientInfo) try {
			let t = ti(e.clientInfo, this.cryptoUtils.base64Decode);
			n = {
				credential: `${t.uid}.${t.utid}`,
				type: L.HOME_ACCOUNT_ID
			};
		} catch {
			this.logger.verbose("0wznt3", e.correlationId);
		}
		else n = e.ccsCredential;
		if (this.config.systemOptions.preventCorsPreflight && n) switch (n.type) {
			case L.HOME_ACCOUNT_ID:
				try {
					Un(t, ni(n.credential));
				} catch {
					this.logger.verbose("1qhtee", e.correlationId);
				}
				break;
			case L.UPN:
				Hn(t, n.credential);
				break;
		}
		return e.embeddedClientId && hr(t, this.config.authOptions.clientId, this.config.authOptions.redirectUri), e.extraParameters && O(t, e.extraParameters), e.enableSpaAuthorizationCode && (!e.extraParameters || !e.extraParameters.return_spa_code) && O(t, { [ht]: "1" }), jn(t, e.correlationId, this.performanceClient), Gn(t, e.claims, this.config.authOptions.clientCapabilities, e.skipBrokerClaims), xr(t);
	}
	createLogoutUrlQueryString(e) {
		let t = /* @__PURE__ */ new Map();
		return e.postLogoutRedirectUri && Rn(t, e.postLogoutRedirectUri), e.correlationId && Kn(t, e.correlationId), e.idTokenHint && zn(t, e.idTokenHint), e.state && Xn(t, e.state), e.logoutHint && mr(t, e.logoutHint), e.extraQueryParameters && O(t, e.extraQueryParameters), this.config.authOptions.instanceAware && cr(t), xr(t);
	}
	async updateTokenEndpointAuthority(e, t) {
		let n = await Xa(`https://${e}/${this.authority.tenant}/`, this.networkClient, this.cacheManager, this.authority.options, this.logger, t, this.performanceClient);
		this.authority = n;
	}
}, Qa = 300, $a = class {
	constructor(e, t) {
		this.config = bi(e), this.logger = new Ar(this.config.loggerOptions, jr, Mr), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = t;
	}
	async acquireToken(e, t) {
		let n = N(), r = await F(this.executeTokenRequest.bind(this), Ji, this.logger, this.performanceClient, e.correlationId)(e, this.authority), i = r.headers?.[_.X_MS_REQUEST_ID], a = new ja(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin);
		return a.validateTokenResponse(r.body, e.correlationId), F(a.handleServerTokenResponse.bind(a), aa, this.logger, this.performanceClient, e.correlationId)(r.body, this.authority, n, e, t, void 0, void 0, !0, e.forceCache, i);
	}
	async acquireTokenByRefreshToken(e, t) {
		if (!e) throw C(Rt);
		if (!e.account) throw T(vn);
		if (this.cacheManager.isAppMetadataFOCI(e.account.environment, e.correlationId)) try {
			return await F(this.acquireTokenWithCachedRefreshToken.bind(this), Xi, this.logger, this.performanceClient, e.correlationId)(e, !0, t);
		} catch (n) {
			let r = n instanceof I && n.errorCode === "no_tokens_found", i = n instanceof Da && n.errorCode === "invalid_grant" && n.subError === "client_mismatch";
			if (r || i) return F(this.acquireTokenWithCachedRefreshToken.bind(this), Xi, this.logger, this.performanceClient, e.correlationId)(e, !1, t);
			throw n;
		}
		return F(this.acquireTokenWithCachedRefreshToken.bind(this), Xi, this.logger, this.performanceClient, e.correlationId)(e, !1, t);
	}
	async acquireTokenWithCachedRefreshToken(e, t, n) {
		let r = P(this.cacheManager.getRefreshToken.bind(this.cacheManager), ha, this.logger, this.performanceClient, e.correlationId)(e.account, t, e.correlationId, void 0);
		if (!r) throw Ea(ya);
		if (r.expiresOn) {
			let t = e.refreshTokenExpirationOffsetSeconds || Qa;
			if (this.performanceClient?.addFields({
				cacheRtExpiresOnSeconds: Number(r.expiresOn),
				rtOffsetSeconds: t
			}, e.correlationId), Ei(r.expiresOn, t)) throw Ea(xa);
		}
		let i = {
			...e,
			refreshToken: r.secret,
			authenticationScheme: e.authenticationScheme || x.BEARER,
			ccsCredential: {
				credential: e.account.homeAccountId,
				type: L.HOME_ACCOUNT_ID
			}
		};
		try {
			return await F(this.acquireToken.bind(this), Yi, this.logger, this.performanceClient, e.correlationId)(i, n);
		} catch (t) {
			if (t instanceof I && t.subError === "bad_token") {
				this.logger.verbose("1pg3ap", e.correlationId);
				let t = this.cacheManager.generateCredentialKey(r);
				this.cacheManager.removeRefreshToken(t, e.correlationId);
			}
			throw t;
		}
	}
	async executeTokenRequest(e, t) {
		let n = za(e, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient), r = A.appendQueryString(t.tokenEndpoint, n), i = await F(this.createTokenRequestBody.bind(this), Zi, this.logger, this.performanceClient, e.correlationId)(e), a = Ra(this.logger, this.config.systemOptions.preventCorsPreflight, e.ccsCredential), o = Pa(this.config.authOptions.clientId, e);
		return F(Ba, Ki, this.logger, this.performanceClient, e.correlationId)(r, i, a, o, e.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, this.serverTelemetryManager);
	}
	async createTokenRequestBody(e) {
		let t = /* @__PURE__ */ new Map();
		if (In(t, e.embeddedClientId || e.extraParameters?.client_id || this.config.authOptions.clientId), e.redirectUri && Ln(t, e.redirectUri), Fn(t, e.scopes, !0, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes), ar(t, be.REFRESH_TOKEN_GRANT), or(t), qn(t, this.config.libraryInfo), Jn(t, this.config.telemetry.application), pr(t), this.serverTelemetryManager && !Si(this.config) && fr(t, this.serverTelemetryManager), er(t, e.refreshToken), this.config.clientCredentials.clientSecret && nr(t, this.config.clientCredentials.clientSecret), this.config.clientCredentials.clientAssertion) {
			let n = this.config.clientCredentials.clientAssertion;
			rr(t, await Na(n.assertion, this.config.authOptions.clientId, e.resourceRequestUri)), ir(t, n.assertionType);
		}
		if (e.authenticationScheme === x.POP) {
			let n = new va(this.cryptoUtils, this.performanceClient), r;
			r = e.popKid ? this.cryptoUtils.encodeKid(e.popKid) : (await F(n.generateCnf.bind(n), ia, this.logger, this.performanceClient, e.correlationId)(e, this.logger)).reqCnfString, ur(t, r);
		} else if (e.authenticationScheme === x.SSH) if (e.sshJwk) dr(t, e.sshJwk);
		else throw C(Wt);
		if (this.config.systemOptions.preventCorsPreflight && e.ccsCredential) switch (e.ccsCredential.type) {
			case L.HOME_ACCOUNT_ID:
				try {
					Un(t, ni(e.ccsCredential.credential));
				} catch {
					this.logger.verbose("1qhtee", e.correlationId);
				}
				break;
			case L.UPN:
				Hn(t, e.ccsCredential.credential);
				break;
		}
		return e.embeddedClientId && hr(t, this.config.authOptions.clientId, this.config.authOptions.redirectUri), e.extraParameters && O(t, { ...e.extraParameters }), jn(t, e.correlationId, this.performanceClient), Gn(t, e.claims, this.config.authOptions.clientCapabilities, e.skipBrokerClaims), xr(t);
	}
}, eo = class {
	constructor(e, t) {
		this.config = bi(e), this.logger = new Ar(this.config.loggerOptions, jr, Mr), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = t;
	}
	async acquireCachedToken(e) {
		let t = Fe.NOT_APPLICABLE;
		if (e.forceRefresh || !w.isEmptyObj(e.claims)) throw this.setCacheOutcome(Fe.FORCE_REFRESH_OR_CLAIMS, e.correlationId), T(Cn);
		if (!e.account) throw T(vn);
		let n = e.account.tenantId || qa(e.authority), r = this.cacheManager.getTokenKeys(), i = this.cacheManager.getAccessToken(e.account, e, r, n);
		if (!i) throw this.setCacheOutcome(Fe.NO_CACHED_ACCESS_TOKEN, e.correlationId), T(Cn);
		if (Oi(i.cachedAt) || Ei(i.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) throw this.setCacheOutcome(Fe.CACHED_ACCESS_TOKEN_EXPIRED, e.correlationId), T(Cn);
		if (e.resource) {
			if (i.resource !== e.resource) throw this.setCacheOutcome(Fe.NO_CACHED_ACCESS_TOKEN, e.correlationId), T(Cn);
		} else i.refreshOn && Ei(i.refreshOn, 0) && (t = Fe.PROACTIVELY_REFRESHED);
		let a = e.authority || this.authority.getPreferredCache(), o = {
			account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(e.account), e.correlationId),
			accessToken: i,
			idToken: this.cacheManager.getIdToken(e.account, e.correlationId, r, n),
			refreshToken: null,
			appMetadata: this.cacheManager.readAppMetadataFromCache(a, e.correlationId)
		};
		return this.setCacheOutcome(t, e.correlationId), this.config.serverTelemetryManager && this.config.serverTelemetryManager.incrementCacheHits(), [await F(this.generateResultFromCacheRecord.bind(this), Qi, this.logger, this.performanceClient, e.correlationId)(o, e), t];
	}
	setCacheOutcome(e, t) {
		this.serverTelemetryManager?.setCacheOutcome(e), this.performanceClient?.addFields({ cacheOutcome: e }, t), e !== Fe.NOT_APPLICABLE && this.logger.info("09ingz", t);
	}
	async generateResultFromCacheRecord(e, t) {
		let n;
		if (e.idToken && (n = Lr(e.idToken.secret, this.config.cryptoInterface.base64Decode)), t.maxAge || t.maxAge === 0) {
			let e = n?.auth_time;
			if (!e) throw T(dn);
			Br(e, t.maxAge);
		}
		return ja.generateAuthenticationResult(this.cryptoUtils, this.authority, e, !0, t, this.performanceClient, n);
	}
}, to = {
	sendGetRequestAsync: () => Promise.reject(T(E)),
	sendPostRequestAsync: () => Promise.reject(T(E))
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/protocol/Authorize.mjs
function no(e, t, n, r) {
	let i = t.correlationId, a = /* @__PURE__ */ new Map();
	if (In(a, t.embeddedClientId || t.extraQueryParameters?.client_id || e.clientId), Fn(a, [...t.scopes || [], ...t.extraScopesToConsent || []], !0, e.authority.options.OIDCOptions?.defaultScopes), _r(a, t.resource), Ln(a, t.redirectUri), Kn(a, i), Nn(a, t.responseMode), or(a), sr(a), t.prompt && (Yn(a, t.prompt), r?.addFields({ prompt: t.prompt }, i)), t.domainHint && (Bn(a, t.domainHint), r?.addFields({ domainHintFromRequest: !0 }, i)), t.prompt !== v.SELECT_ACCOUNT) if (t.sid && t.prompt === v.NONE) n.verbose("1tvqyx", t.correlationId), Wn(a, t.sid), r?.addFields({ sidFromRequest: !0 }, i);
	else if (t.account) {
		let e = so(t.account), o = co(t.account);
		if (o && t.domainHint && (n.warning("0wkg3v", t.correlationId), o = null), o) {
			n.verbose("1eyfsw", t.correlationId), Vn(a, o), r?.addFields({ loginHintFromClaim: !0 }, i);
			try {
				Un(a, ni(t.account.homeAccountId));
			} catch {
				n.verbose("12ugck", t.correlationId);
			}
		} else if (e && t.prompt === v.NONE) {
			n.verbose("1rmd8s", t.correlationId), Wn(a, e), r?.addFields({ sidFromClaim: !0 }, i);
			try {
				Un(a, ni(t.account.homeAccountId));
			} catch {
				n.verbose("12ugck", t.correlationId);
			}
		} else if (t.loginHint) n.verbose("0y3007", t.correlationId), Vn(a, t.loginHint), Hn(a, t.loginHint), r?.addFields({ loginHintFromRequest: !0 }, i);
		else if (t.account.username) {
			n.verbose("02f507", t.correlationId), Vn(a, t.account.username), r?.addFields({ loginHintFromUpn: !0 }, i);
			try {
				Un(a, ni(t.account.homeAccountId));
			} catch {
				n.verbose("12ugck", t.correlationId);
			}
		}
	} else t.loginHint && (n.verbose("0g01ey", t.correlationId), Vn(a, t.loginHint), Hn(a, t.loginHint), r?.addFields({ loginHintFromRequest: !0 }, i));
	else n.verbose("169k9v", t.correlationId);
	return t.nonce && Zn(a, t.nonce), t.state && Xn(a, t.state), t.embeddedClientId && hr(a, e.clientId, e.redirectUri), Gn(a, t.claims, e.clientCapabilities, t.skipBrokerClaims), e.instanceAware && (!t.extraQueryParameters || !Object.keys(t.extraQueryParameters).includes("instance_aware")) && cr(a), a;
}
function ro(e, t) {
	let n = xr(t);
	return A.appendQueryString(e.authorizationEndpoint, n);
}
function io(e, t) {
	if (ao(e, t), !e.code) throw T(Tn);
	return e;
}
function ao(e, t) {
	if (!e.state || !t) throw e.state ? T(ln, "Cached State") : T(ln, "Server State");
	let n, r;
	try {
		n = decodeURIComponent(e.state);
	} catch {
		throw T(sn, e.state);
	}
	try {
		r = decodeURIComponent(t);
	} catch {
		throw T(sn, e.state);
	}
	if (n !== r) throw T(cn);
	if (e.error || e.error_description || e.suberror) {
		let t = oo(e);
		throw Ta(e.error, e.error_description, e.suberror) ? new I(e.error || "", e.error_description, e.suberror, e.timestamp || "", e.trace_id || "", e.correlation_id || "", e.claims || "", t) : new Da(e.error || "", e.error_description, e.suberror, t);
	}
}
function oo(e) {
	let t = e.error_uri?.lastIndexOf("code=");
	return t && t >= 0 ? e.error_uri?.substring(t + 5) : void 0;
}
function so(e) {
	return e.idTokenClaims?.sid || null;
}
function co(e) {
	return e.loginHint || e.idTokenClaims?.login_hint || null;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/request/BaseAuthRequest.mjs
function lo(e, t) {
	if (e) {
		if (t.resource && (uo(t.extraParameters) || uo(t.extraQueryParameters))) throw T(An);
		if (!t.resource) throw T(kn);
	}
}
function uo(e) {
	return e ? Object.prototype.hasOwnProperty.call(e, "resource") : !1;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/AuthErrorCodes.mjs
var fo = "unexpected_error", po = ",", mo = "|";
function ho(e) {
	let { skus: t, libraryName: n, libraryVersion: r, extensionName: i, extensionVersion: a } = e, o = /* @__PURE__ */ new Map([[0, [n, r]], [2, [i, a]]]), s = [];
	if (t?.length) {
		if (s = t.split(po), s.length < 4) return t;
	} else s = Array.from({ length: 4 }, () => mo);
	return o.forEach((e, t) => {
		e.length === 2 && e[0]?.length && e[1]?.length && go({
			skuArr: s,
			index: t,
			skuName: e[0],
			skuVersion: e[1]
		});
	}), s.join(po);
}
function go(e) {
	let { skuArr: t, index: n, skuName: r, skuVersion: i } = e;
	n >= t.length || (t[n] = [r, i].join(mo));
}
var _o = class e {
	constructor(e, t) {
		this.cacheOutcome = Fe.NOT_APPLICABLE, this.cacheManager = t, this.apiId = e.apiId, this.correlationId = e.correlationId, this.wrapperSKU = e.wrapperSKU || "", this.wrapperVer = e.wrapperVer || "", this.telemetryCacheKey = Oe + "-" + e.clientId;
	}
	generateCurrentRequestHeaderValue() {
		let e = `${this.apiId},${this.cacheOutcome}`, t = [this.wrapperSKU, this.wrapperVer], n = this.getNativeBrokerErrorCode();
		n?.length && t.push(`broker_error=${n}`);
		let r = t.join(",");
		return [
			5,
			[e, this.getRegionDiscoveryFields()].join(","),
			r
		].join("|");
	}
	generateLastRequestHeaderValue() {
		let t = this.getLastRequests(), n = e.maxErrorsToSend(t), r = t.failedRequests.slice(0, 2 * n).join(","), i = t.errors.slice(0, n).join(","), a = t.errors.length, o = [a, n < a ? "1" : "0"].join(",");
		return [
			5,
			t.cacheHits,
			r,
			i,
			o
		].join("|");
	}
	cacheFailedRequest(e) {
		let t = this.getLastRequests();
		t.errors.length >= 50 && (t.failedRequests.shift(), t.failedRequests.shift(), t.errors.shift()), t.failedRequests.push(this.apiId, this.correlationId), e instanceof Error && e && e.toString() ? e instanceof S ? e.subError ? t.errors.push(e.subError) : e.errorCode ? t.errors.push(e.errorCode) : t.errors.push(e.toString()) : t.errors.push(e.toString()) : t.errors.push(ke), this.cacheManager.setServerTelemetry(this.telemetryCacheKey, t, this.correlationId);
	}
	incrementCacheHits() {
		let e = this.getLastRequests();
		return e.cacheHits += 1, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e, this.correlationId), e.cacheHits;
	}
	getLastRequests() {
		return this.cacheManager.getServerTelemetry(this.telemetryCacheKey, this.correlationId) || {
			failedRequests: [],
			errors: [],
			cacheHits: 0
		};
	}
	clearTelemetryCache() {
		let t = this.getLastRequests(), n = e.maxErrorsToSend(t);
		if (n === t.errors.length) this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
		else {
			let e = {
				failedRequests: t.failedRequests.slice(n * 2),
				errors: t.errors.slice(n),
				cacheHits: 0
			};
			this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e, this.correlationId);
		}
	}
	static maxErrorsToSend(e) {
		let t, n = 0, r = 0, i = e.errors.length;
		for (t = 0; t < i; t++) {
			let i = e.failedRequests[2 * t] || "", a = e.failedRequests[2 * t + 1] || "", o = e.errors[t] || "";
			if (r += i.toString().length + a.toString().length + o.length + 3, r < 330) n += 1;
			else break;
		}
		return n;
	}
	getRegionDiscoveryFields() {
		let e = [];
		return e.push(this.regionUsed || ""), e.push(this.regionSource || ""), e.push(this.regionOutcome || ""), e.join(",");
	}
	updateRegionDiscoveryMetadata(e) {
		this.regionUsed = e.region_used, this.regionSource = e.region_source, this.regionOutcome = e.region_outcome;
	}
	setCacheOutcome(e) {
		this.cacheOutcome = e;
	}
	setNativeBrokerErrorCode(e) {
		let t = this.getLastRequests();
		t.nativeBrokerErrorCode = e, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, t, this.correlationId);
	}
	getNativeBrokerErrorCode() {
		return this.getLastRequests().nativeBrokerErrorCode;
	}
	clearNativeBrokerErrorCode() {
		let e = this.getLastRequests();
		delete e.nativeBrokerErrorCode, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e, this.correlationId);
	}
	static makeExtraSkuString(e) {
		return ho(e);
	}
}, vo = class e extends S {
	constructor(t, n) {
		super(t, n), this.name = "JoseHeaderError", Object.setPrototypeOf(this, e.prototype);
	}
};
function yo(e) {
	return new vo(e);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-common@16.6.2/node_modules/@azure/msal-common/dist-browser/error/JoseHeaderErrorCodes.mjs
var bo = "missing_kid_error", xo = "missing_alg_error", So = class e {
	constructor(e) {
		this.typ = e.typ, this.alg = e.alg, this.kid = e.kid;
	}
	static getShrHeaderString(t) {
		if (!t.kid) throw yo(bo);
		if (!t.alg) throw yo(xo);
		let n = new e({
			typ: t.typ || Ie.Pop,
			kid: t.kid,
			alg: t.alg
		});
		return JSON.stringify(n);
	}
}, Co = "acquireTokenFromCache", wo = "acquireTokenByRefreshToken", To = "acquireTokenSilentAsync", Eo = "cryptoOptsGetPublicKeyThumbprint", Do = "cryptoOptsSignJwt", Oo = "silentCacheClientAcquireToken", ko = "silentIframeClientAcquireToken", Ao = "awaitConcurrentIframe", jo = "silentRefreshClientAcquireToken", Mo = "standardInteractionClientGetDiscoveredAuthority", No = "nativeInteractionClientAcquireToken", Po = "nativeInteractionClientAcquireToken", Fo = "refreshTokenClientAcquireTokenByRefreshToken", Io = "acquireTokenBySilentIframe", Lo = "initializeBaseRequest", Ro = "initializeSilentRequest", zo = "initializeCache", Bo = "silentIframeClientTokenHelper", Vo = "silentHandlerInitiateAuthRequest", Ho = "silentHandlerMonitorIframeForHash", Uo = "silentHandlerLoadFrameSync", Wo = "standardInteractionClientCreateAuthCodeClient", Go = "standardInteractionClientGetClientConfiguration", Ko = "standardInteractionClientInitializeAuthorizationRequest", qo = "silentFlowClientAcquireCachedToken", Jo = "getStandardParams", Yo = "handleCodeResponse", Xo = "handleResponseEar", Zo = "handleResponsePlatformBroker", Qo = "handleResponseCode", $o = "authClientAcquireToken", es = "deserializeResponse", ts = "authorityFactoryCreateDiscoveredInstance", ns = "acquireTokenByCodeAsync", rs = "handleRedirectPromise", is = "handleNativeRedirectPromise", as = "nativeMessageHandlerHandshake", os = "removeHiddenIframe", ss = "importExistingCache", cs = "generatePkceCodes", ls = "generateCodeVerifier", us = "generateCodeChallengeFromVerifier", ds = "sha256Digest", fs = "getRandomValues", ps = "generateHKDF", ms = "generateBaseKey", hs = "base64Decode", gs = "urlEncodeArr", _s = "encrypt", vs = "decrypt", ys = "generateEarKey", bs = "decryptEarResponse", xs = "waitForBridgeLateResponse";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/error/BrowserAuthError.mjs
function Ss(e) {
	return `See https://aka.ms/msal.js.errors#${e} for details`;
}
var Cs = class e extends S {
	constructor(t, n) {
		super(t, Ss(t), n), Object.setPrototypeOf(this, e.prototype), this.name = "BrowserAuthError";
	}
};
function R(e, t) {
	return new Cs(e, t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/utils/BrowserConstants.mjs
var z = {
	INVALID_GRANT_ERROR: "invalid_grant",
	POPUP_WIDTH: 483,
	POPUP_HEIGHT: 600,
	POPUP_NAME_PREFIX: "msal",
	MSAL_SKU: "msal.js.browser"
}, B = {
	CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
	PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
	MATS_TELEMETRY: "MATS",
	MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
	DOM_API_NAME: "DOM API",
	PLATFORM_DOM_APIS: "get-token-and-sign-out",
	PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
	PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
}, ws = {
	HandshakeRequest: "Handshake",
	HandshakeResponse: "HandshakeResponse",
	GetToken: "GetToken",
	Response: "Response"
}, V = {
	LocalStorage: "localStorage",
	SessionStorage: "sessionStorage",
	MemoryStorage: "memoryStorage"
}, Ts = {
	GET: "GET",
	POST: "POST"
}, Es = {
	SIGNIN: "signin",
	SIGNOUT: "signout"
}, H = {
	ORIGIN_URI: "request.origin",
	URL_HASH: "urlHash",
	REQUEST_PARAMS: "request.params",
	VERIFIER: "code.verifier",
	INTERACTION_STATUS_KEY: "interaction.status",
	NATIVE_REQUEST: "request.native"
}, Ds = {
	WRAPPER_SKU: "wrapper.sku",
	WRAPPER_VER: "wrapper.version"
}, U = {
	acquireTokenRedirect: 861,
	acquireTokenPopup: 862,
	ssoSilent: 863,
	acquireTokenSilent_authCode: 864,
	handleRedirectPromise: 865,
	acquireTokenByCode: 866,
	acquireTokenSilent_silentFlow: 61,
	logout: 961,
	logoutPopup: 962,
	hydrateCache: 963,
	loadExternalTokens: 964
}, Os = {
	861: "acquireTokenRedirect",
	862: "acquireTokenPopup",
	863: "ssoSilent",
	864: "acquireTokenSilent_authCode",
	865: "handleRedirectPromise",
	866: "acquireTokenByCode",
	61: "acquireTokenSilent_silentFlow",
	961: "logout",
	962: "logoutPopup",
	963: "hydrateCache",
	964: "loadExternalTokens"
}, ks = (e) => typeof e == "number" && e in Os ? Os[e] : "unknown", W;
(function(e) {
	e.Redirect = "redirect", e.Popup = "popup", e.Silent = "silent", e.None = "none";
})(W ||= {});
var G = {
	Startup: "startup",
	Logout: "logout",
	AcquireToken: "acquireToken",
	HandleRedirect: "handleRedirect",
	None: "none"
}, As = { scopes: pe }, js = {
	React: "@azure/msal-react",
	Angular: "@azure/msal-angular"
}, Ms = "msal.db", Ns = `${Ms}.keys`, K = {
	Default: 0,
	AccessToken: 1,
	AccessTokenAndRefreshToken: 2,
	RefreshToken: 3,
	RefreshTokenAndNetwork: 4,
	Skip: 5
}, Ps = [
	K.Default,
	K.Skip,
	K.RefreshTokenAndNetwork
];
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/encode/Base64Encode.mjs
function Fs(e) {
	return encodeURIComponent(Ls(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
function Is(e) {
	return Rs(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function Ls(e) {
	return Rs(new TextEncoder().encode(e));
}
function Rs(e) {
	let t = Array.from(e, (e) => String.fromCodePoint(e)).join("");
	return btoa(t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/error/BrowserAuthErrorCodes.mjs
var zs = "pkce_not_created", Bs = "ear_jwk_empty", Vs = "ear_jwe_empty", Hs = "crypto_nonexistent", Us = "empty_navigate_uri", Ws = "hash_empty_error", Gs = "no_state_in_hash", Ks = "hash_does_not_contain_known_properties", qs = "unable_to_parse_state", Js = "state_interaction_type_mismatch", Ys = "interaction_in_progress", Xs = "interaction_in_progress_cancelled", Zs = "popup_window_error", Qs = "empty_window_error", $s = "user_cancelled", ec = "redirect_bridge_empty_response", tc = "redirect_in_iframe", nc = "block_iframe_reload", rc = "block_nested_popups", ic = "silent_logout_unsupported", ac = "no_account_error", oc = "no_token_request_cache_error", sc = "unable_to_parse_token_request_cache_error", cc = "non_browser_environment", lc = "database_not_open", uc = "no_network_connectivity", dc = "post_request_failed", fc = "get_request_failed", pc = "failed_to_parse_response", mc = "crypto_key_not_found", hc = "auth_code_required", gc = "auth_code_or_nativeAccountId_required", _c = "spa_code_and_nativeAccountId_present", vc = "database_unavailable", yc = "unable_to_acquire_token_from_native_platform", bc = "native_handshake_timeout", xc = "native_extension_not_installed", Sc = "native_connection_not_established", Cc = "uninitialized_public_client_application", wc = "native_prompt_not_supported", Tc = "invalid_base64_string", Ec = "invalid_pop_token_request", Dc = "failed_to_build_headers", Oc = "failed_to_parse_headers", kc = "failed_to_decrypt_ear_response", Ac = "timed_out", jc = "empty_response";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/encode/Base64Decode.mjs
function q(e) {
	return new TextDecoder().decode(Mc(e));
}
function Mc(e) {
	let t = e.replace(/-/g, "+").replace(/_/g, "/");
	switch (t.length % 4) {
		case 0: break;
		case 2:
			t += "==";
			break;
		case 3:
			t += "=";
			break;
		default: throw R(Tc);
	}
	let n = atob(t);
	return Uint8Array.from(n, (e) => e.codePointAt(0) || 0);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/crypto/BrowserCrypto.mjs
var Nc = "RSASSA-PKCS1-v1_5", Pc = "AES-GCM", Fc = "HKDF", Ic = "SHA-256", Lc = 2048, Rc = new Uint8Array([
	1,
	0,
	1
]), zc = "0123456789abcdef", Bc = /* @__PURE__ */ new Uint32Array(1), Vc = "raw", Hc = "encrypt", Uc = "decrypt", Wc = "deriveKey", Gc = "crypto_subtle_undefined", Kc = {
	name: Nc,
	hash: Ic,
	modulusLength: Lc,
	publicExponent: Rc
};
function qc(e) {
	if (!window) throw R(cc);
	if (!window.crypto) throw R(Hs);
	if (!e && !window.crypto.subtle) throw R(Hs, Gc);
}
async function Jc(e) {
	let t = new TextEncoder().encode(e);
	return window.crypto.subtle.digest(Ic, t);
}
function Yc(e) {
	return window.crypto.getRandomValues(e);
}
function Xc() {
	return window.crypto.getRandomValues(Bc), Bc[0];
}
function Zc() {
	let e = Date.now(), t = Xc() * 1024 + (Xc() & 1023), n = /* @__PURE__ */ new Uint8Array(16), r = Math.trunc(t / 2 ** 30), i = t & 2 ** 30 - 1, a = Xc();
	n[0] = e / 2 ** 40, n[1] = e / 2 ** 32, n[2] = e / 2 ** 24, n[3] = e / 2 ** 16, n[4] = e / 2 ** 8, n[5] = e, n[6] = 112 | r >>> 8, n[7] = r, n[8] = 128 | i >>> 24, n[9] = i >>> 16, n[10] = i >>> 8, n[11] = i, n[12] = a >>> 24, n[13] = a >>> 16, n[14] = a >>> 8, n[15] = a;
	let o = "";
	for (let e = 0; e < n.length; e++) o += zc.charAt(n[e] >>> 4), o += zc.charAt(n[e] & 15), (e === 3 || e === 5 || e === 7 || e === 9) && (o += "-");
	return o;
}
async function Qc(e, t) {
	return window.crypto.subtle.generateKey(Kc, e, t);
}
async function $c(e) {
	return window.crypto.subtle.exportKey("jwk", e);
}
async function el(e, t, n) {
	return window.crypto.subtle.importKey("jwk", e, Kc, t, n);
}
async function tl(e, t) {
	return window.crypto.subtle.sign(Kc, e, t);
}
async function nl() {
	let e = await al(), t = {
		alg: "dir",
		kty: "oct",
		k: Is(new Uint8Array(e))
	};
	return Ls(JSON.stringify(t));
}
async function rl(e) {
	let t = q(e), n = JSON.parse(t).k, r = Mc(n);
	return window.crypto.subtle.importKey(Vc, r, Pc, !1, [Uc]);
}
async function il(e, t) {
	let n = t.split(".");
	if (n.length !== 5) throw R(kc, "jwe_length");
	let r = await rl(e).catch(() => {
		throw R(kc, "import_key");
	});
	try {
		let e = new TextEncoder().encode(n[0]), t = Mc(n[2]), i = Mc(n[3]), a = Mc(n[4]), o = a.byteLength * 8, s = new Uint8Array(i.length + a.length);
		s.set(i), s.set(a, i.length);
		let c = await window.crypto.subtle.decrypt({
			name: Pc,
			iv: t,
			tagLength: o,
			additionalData: e
		}, r, s);
		return new TextDecoder().decode(c);
	} catch {
		throw R(kc, "decrypt");
	}
}
async function al() {
	let e = await window.crypto.subtle.generateKey({
		name: Pc,
		length: 256
	}, !0, [Hc, Uc]);
	return window.crypto.subtle.exportKey(Vc, e);
}
async function ol(e) {
	return window.crypto.subtle.importKey(Vc, e, Fc, !1, [Wc]);
}
async function sl(e, t, n) {
	return window.crypto.subtle.deriveKey({
		name: Fc,
		salt: t,
		hash: Ic,
		info: new TextEncoder().encode(n)
	}, e, {
		name: Pc,
		length: 256
	}, !1, [Hc, Uc]);
}
async function cl(e, t, n) {
	let r = new TextEncoder().encode(t), i = window.crypto.getRandomValues(/* @__PURE__ */ new Uint8Array(16)), a = await sl(e, i, n), o = await window.crypto.subtle.encrypt({
		name: Pc,
		iv: /* @__PURE__ */ new Uint8Array(12)
	}, a, r);
	return {
		data: Is(new Uint8Array(o)),
		nonce: Is(i)
	};
}
async function ll(e, t, n, r) {
	let i = Mc(r), a = await sl(e, Mc(t), n), o = await window.crypto.subtle.decrypt({
		name: Pc,
		iv: /* @__PURE__ */ new Uint8Array(12)
	}, a, i);
	return new TextDecoder().decode(o);
}
async function ul(e) {
	let t = await Jc(e);
	return Is(new Uint8Array(t));
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/error/BrowserConfigurationAuthError.mjs
var dl = class e extends S {
	constructor(t, n) {
		super(t, n), this.name = "BrowserConfigurationAuthError", Object.setPrototypeOf(this, e.prototype);
	}
};
function J(e) {
	return new dl(e, Ss(e));
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/error/BrowserConfigurationAuthErrorCodes.mjs
var fl = "storage_not_supported", Y = "stubbed_public_client_application_called", pl = "in_mem_redirect_unavailable";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/utils/BrowserUtils.mjs
function ml() {
	let e = window.location.hash, t = window.location.search, n = !1, r = !1, i = "", a;
	if (e && e.length > 1) {
		let t = e.charAt(0) === "#" ? e.substring(1) : e, r = new URLSearchParams(t);
		r.has("state") && (n = !0, i = t, a = r);
	}
	if (t && t.length > 1) {
		let e = t.charAt(0) === "?" ? t.substring(1) : t, n = new URLSearchParams(e);
		n.has("state") && (r = !0, i = e, a = n);
	}
	if (n && r && (i = `${t.charAt(0) === "?" ? t.substring(1) : t}${e.charAt(0) === "#" ? e.substring(1) : e}`, a = new URLSearchParams(i)), !i || !a) throw R(jc);
	let o = a.get("state");
	if (!o) throw R(Gs);
	let { libraryState: s } = Aa(q, o), { id: c, meta: l } = s;
	if (!c || !l) throw R(qs, "missing_library_state");
	return {
		params: a,
		payload: i,
		urlHash: e,
		urlQuery: t,
		hasResponseInHash: n,
		hasResponseInQuery: r,
		libraryState: {
			id: c,
			meta: l
		}
	};
}
function hl(e) {
	e.location.hash = "", typeof e.history.replaceState == "function" && e.history.replaceState(null, "", `${e.location.origin}${e.location.pathname}${e.location.search}`);
}
function gl(e) {
	let t = e.split("#");
	t.shift(), window.location.hash = t.length > 0 ? t.join("#") : "";
}
function _l() {
	return window.parent !== window;
}
function vl() {
	if (_l()) return !1;
	try {
		let { libraryState: e } = ml(), { meta: t } = e;
		return t.interactionType === W.Popup;
	} catch {
		return !1;
	}
}
var yl = null;
function bl(e, t) {
	yl &&= (e.verbose("18y01k", t), clearTimeout(yl.timeoutId), yl.channel.close(), yl.reject(R(Xs)), null);
}
async function xl(e, t, n, r, i, a) {
	return new Promise((o, s) => {
		t.verbose("1rf6em", r.correlationId);
		let c = r.correlationId;
		i.addFields({
			redirectBridgeTimeoutMs: e,
			lateResponseExperimentEnabled: a?.iframeTimeoutTelemetry || !1
		}, c);
		let { libraryState: l } = Aa(n.base64Decode, r.state || ""), u = new BroadcastChannel(l.id), d, f = !1, p, m, h = window.setTimeout(() => {
			yl = null, a?.iframeTimeoutTelemetry ? (m = i.startMeasurement(xs, c), f = !0, p = window.setTimeout(() => {
				m?.end({ success: !1 }), clearTimeout(p), u.close();
			}, 6e4)) : u.close(), s(R(Ac, "redirect_bridge_timeout"));
		}, e);
		yl = {
			timeoutId: h,
			channel: u,
			reject: s
		}, u.onmessage = (e) => {
			d = e.data.payload;
			let t = e?.data && typeof e.data.v == "number" ? e.data.v : void 0;
			if (f) {
				m?.end({ success: !!d }), clearTimeout(p), u.close();
				return;
			}
			i.addFields({ redirectBridgeMessageVersion: t }, c), yl = null, clearTimeout(h), u.close(), d ? o(d) : s(R(ec));
		};
	});
}
function Sl() {
	return typeof window < "u" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
function Cl() {
	let e = new A(window.location.href).getUrlComponents();
	return `${e.Protocol}//${e.HostNameAndPort}/`;
}
function wl() {
	if (br(window.location.hash) && _l()) throw R(nc);
}
function Tl(e) {
	if (_l() && !e) throw R(tc);
}
function El() {
	if (vl()) throw R(rc);
}
function Dl() {
	if (typeof window > "u") throw R(cc);
}
function Ol(e) {
	if (!e) throw R(Cc);
}
function kl(e) {
	Dl(), wl(), El(), Ol(e);
}
function Al(e, t) {
	if (kl(e), Tl(t.system.allowRedirectInIframe), t.cache.cacheLocation === V.MemoryStorage) throw J(pl);
}
function jl(e) {
	let t = document.createElement("link");
	t.rel = "preconnect", t.href = new URL(e).origin, t.crossOrigin = "anonymous", document.head.appendChild(t), window.setTimeout(() => {
		try {
			document.head.removeChild(t);
		} catch {}
	}, 1e4);
}
function Ml() {
	return Zc();
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/DatabaseStorage.mjs
var Nl = class {
	constructor() {
		this.dbName = Ms, this.version = 1, this.tableName = Ns, this.dbOpen = !1;
	}
	async open() {
		return new Promise((e, t) => {
			let n = window.indexedDB.open(this.dbName, this.version);
			n.addEventListener("upgradeneeded", (e) => {
				e.target.result.createObjectStore(this.tableName);
			}), n.addEventListener("success", (t) => {
				let n = t;
				this.db = n.target.result, this.dbOpen = !0, e();
			}), n.addEventListener("error", () => t(R(vc)));
		});
	}
	closeConnection() {
		let e = this.db;
		e && this.dbOpen && (e.close(), this.dbOpen = !1);
	}
	async validateDbIsOpen() {
		if (!this.dbOpen) return this.open();
	}
	async getItem(e) {
		return await this.validateDbIsOpen(), new Promise((t, n) => {
			if (!this.db) return n(R(lc));
			let r = this.db.transaction([this.tableName], "readonly").objectStore(this.tableName).get(e);
			r.addEventListener("success", (e) => {
				let n = e;
				this.closeConnection(), t(n.target.result);
			}), r.addEventListener("error", (e) => {
				this.closeConnection(), n(e);
			});
		});
	}
	async setItem(e, t) {
		return await this.validateDbIsOpen(), new Promise((n, r) => {
			if (!this.db) return r(R(lc));
			let i = this.db.transaction([this.tableName], "readwrite").objectStore(this.tableName).put(t, e);
			i.addEventListener("success", () => {
				this.closeConnection(), n();
			}), i.addEventListener("error", (e) => {
				this.closeConnection(), r(e);
			});
		});
	}
	async removeItem(e) {
		return await this.validateDbIsOpen(), new Promise((t, n) => {
			if (!this.db) return n(R(lc));
			let r = this.db.transaction([this.tableName], "readwrite").objectStore(this.tableName).delete(e);
			r.addEventListener("success", () => {
				this.closeConnection(), t();
			}), r.addEventListener("error", (e) => {
				this.closeConnection(), n(e);
			});
		});
	}
	async getKeys() {
		return await this.validateDbIsOpen(), new Promise((e, t) => {
			if (!this.db) return t(R(lc));
			let n = this.db.transaction([this.tableName], "readonly").objectStore(this.tableName).getAllKeys();
			n.addEventListener("success", (t) => {
				let n = t;
				this.closeConnection(), e(n.target.result);
			}), n.addEventListener("error", (e) => {
				this.closeConnection(), t(e);
			});
		});
	}
	async containsKey(e) {
		return await this.validateDbIsOpen(), new Promise((t, n) => {
			if (!this.db) return n(R(lc));
			let r = this.db.transaction([this.tableName], "readonly").objectStore(this.tableName).count(e);
			r.addEventListener("success", (e) => {
				let n = e;
				this.closeConnection(), t(n.target.result === 1);
			}), r.addEventListener("error", (e) => {
				this.closeConnection(), n(e);
			});
		});
	}
	async deleteDatabase() {
		return this.db && this.dbOpen && this.closeConnection(), new Promise((e, t) => {
			let n = window.indexedDB.deleteDatabase(Ms), r = setTimeout(() => t(!1), 200);
			n.addEventListener("success", () => (clearTimeout(r), e(!0))), n.addEventListener("blocked", () => (clearTimeout(r), e(!0))), n.addEventListener("error", () => (clearTimeout(r), t(!1)));
		});
	}
}, Pl = class {
	constructor() {
		this.cache = /* @__PURE__ */ new Map();
	}
	async initialize() {}
	getItem(e) {
		return this.cache.get(e) || null;
	}
	getUserData(e) {
		return this.getItem(e);
	}
	setItem(e, t) {
		this.cache.set(e, t);
	}
	async setUserData(e, t) {
		this.setItem(e, t);
	}
	removeItem(e) {
		this.cache.delete(e);
	}
	getKeys() {
		let e = [];
		return this.cache.forEach((t, n) => {
			e.push(n);
		}), e;
	}
	containsKey(e) {
		return this.cache.has(e);
	}
	clear() {
		this.cache.clear();
	}
	decryptData() {
		return Promise.resolve(null);
	}
}, Fl = class {
	constructor(e) {
		this.inMemoryCache = new Pl(), this.indexedDBCache = new Nl(), this.logger = e;
	}
	handleDatabaseAccessError(e, t) {
		if (e instanceof Cs && e.errorCode === "database_unavailable") this.logger.error("1wx7zz", t);
		else throw e;
	}
	async getItem(e, t) {
		let n = this.inMemoryCache.getItem(e);
		if (!n) try {
			return this.logger.verbose("0naxpl", t), await this.indexedDBCache.getItem(e);
		} catch (e) {
			this.handleDatabaseAccessError(e, t);
		}
		return n;
	}
	async setItem(e, t, n) {
		this.inMemoryCache.setItem(e, t);
		try {
			await this.indexedDBCache.setItem(e, t);
		} catch (e) {
			this.handleDatabaseAccessError(e, n);
		}
	}
	async removeItem(e, t) {
		this.inMemoryCache.removeItem(e);
		try {
			await this.indexedDBCache.removeItem(e);
		} catch (e) {
			this.handleDatabaseAccessError(e, t);
		}
	}
	async getKeys(e) {
		let t = this.inMemoryCache.getKeys();
		if (t.length === 0) try {
			return this.logger.verbose("1iqrbq", e), await this.indexedDBCache.getKeys();
		} catch (t) {
			this.handleDatabaseAccessError(t, e);
		}
		return t;
	}
	async containsKey(e, t) {
		let n = this.inMemoryCache.containsKey(e);
		if (!n) try {
			return this.logger.verbose("03zl2j", t), await this.indexedDBCache.containsKey(e);
		} catch (e) {
			this.handleDatabaseAccessError(e, t);
		}
		return n;
	}
	clearInMemory(e) {
		this.logger.verbose("03r21p", e), this.inMemoryCache.clear(), this.logger.verbose("0uksk1", e);
	}
	async clearPersistent(e) {
		try {
			this.logger.verbose("0rdqut", e);
			let t = await this.indexedDBCache.deleteDatabase();
			return t && this.logger.verbose("149ouc", e), t;
		} catch (t) {
			return this.handleDatabaseAccessError(t, e), !1;
		}
	}
}, Il = class e {
	constructor(e, t, n) {
		this.logger = e, qc(n ?? !1), this.cache = new Fl(this.logger), this.performanceClient = t;
	}
	createNewGuid() {
		return Zc();
	}
	base64Encode(e) {
		return Ls(e);
	}
	base64Decode(e) {
		return q(e);
	}
	base64UrlEncode(e) {
		return Fs(e);
	}
	encodeKid(e) {
		return this.base64UrlEncode(JSON.stringify({ kid: e }));
	}
	async getPublicKeyThumbprint(t) {
		let n = this.performanceClient?.startMeasurement(Eo, t.correlationId), r = await Qc(e.EXTRACTABLE, e.POP_KEY_USAGES), i = await $c(r.publicKey), a = Ll({
			e: i.e,
			kty: i.kty,
			n: i.n
		}), o = await this.hashString(a), s = await el(await $c(r.privateKey), !1, ["sign"]);
		return await this.cache.setItem(o, {
			privateKey: s,
			publicKey: r.publicKey,
			requestMethod: t.resourceRequestMethod,
			requestUri: t.resourceRequestUri
		}, t.correlationId), n && n.end({ success: !0 }), o;
	}
	async removeTokenBindingKey(e, t) {
		if (await this.cache.removeItem(e, t), await this.cache.containsKey(e, t)) throw T(En);
	}
	async clearKeystore(e) {
		this.cache.clearInMemory(e);
		try {
			return await this.cache.clearPersistent(e), !0;
		} catch (t) {
			return t instanceof Error ? this.logger.error("1owpn8", e) : this.logger.error("0yrmwo", e), !1;
		}
	}
	async signJwt(e, t, n, r) {
		let i = this.performanceClient?.startMeasurement(Do, r), a = await this.cache.getItem(t, r || "");
		if (!a) throw R(mc);
		let o = await $c(a.publicKey), s = Ll(o), c = Fs(JSON.stringify({ kid: t })), l = Fs(So.getShrHeaderString({
			...n?.header,
			alg: o.alg,
			kid: c
		}));
		e.cnf = { jwk: JSON.parse(s) };
		let u = `${l}.${Fs(JSON.stringify(e))}`, d = new TextEncoder().encode(u), f = await tl(a.privateKey, d), p = `${u}.${Is(new Uint8Array(f))}`;
		return i && i.end({ success: !0 }), p;
	}
	async hashString(e) {
		return ul(e);
	}
};
Il.POP_KEY_USAGES = ["sign", "verify"], Il.EXTRACTABLE = !0;
function Ll(e) {
	return JSON.stringify(e, Object.keys(e).sort());
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/telemetry/BrowserRootPerformanceEvents.mjs
var Rl = "acquireTokenSilent", zl = "acquireTokenByCode", Bl = "acquireTokenPopup", Vl = "acquireTokenPreRedirect", Hl = "acquireTokenRedirect", Ul = "ssoSilent", Wl = "initializeClientApplication", Gl = "localStorageUpdated", Kl = "ssoCapable", X = "msal", ql = "browser", Jl = `${X}.${ql}.log.level`, Yl = `${X}.${ql}.log.pii`;
`${X}${ql}`;
var Xl = `${X}.version`, Zl = "account.keys", Ql = "token.keys", $l = `${X}.${ql}.sso.capable`;
function eu(e = 3) {
	return e < 1 ? `${X}.${Zl}` : `${X}.${e}.${Zl}`;
}
function tu(e, t = 3) {
	return t < 1 ? `${X}.${Ql}.${e}` : `${X}.${t}.${Ql}.${e}`;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/CookieStorage.mjs
var nu = 1440 * 60 * 1e3, ru = {
	Lax: "Lax",
	None: "None"
}, iu = class {
	initialize() {
		return Promise.resolve();
	}
	getItem(e) {
		let t = encodeURIComponent(e), n = document.cookie.split(";");
		for (let e = 0; e < n.length; e++) {
			let r = n[e].trim(), i = r.indexOf("=");
			if ((i === -1 ? r : r.substring(0, i)) === t) {
				let e = i === -1 ? "" : r.substring(i + 1);
				try {
					return decodeURIComponent(e);
				} catch {
					return e;
				}
			}
		}
		return "";
	}
	getUserData() {
		throw T(E);
	}
	setItem(e, t, n, r = !0, i = ru.Lax) {
		let a = `${encodeURIComponent(e)}=${encodeURIComponent(t)};path=/;SameSite=${i};`;
		if (n) {
			let e = au(n);
			a += `expires=${e};`;
		}
		(r || i === ru.None) && (a += "Secure;"), document.cookie = a;
	}
	async setUserData() {
		return Promise.reject(T(E));
	}
	removeItem(e) {
		this.setItem(e, "", -1);
	}
	getKeys() {
		let e = document.cookie.split(";"), t = [];
		return e.forEach((e) => {
			let n = e.trim(), r = n.indexOf("="), i = r === -1 ? n : n.substring(0, r);
			try {
				t.push(decodeURIComponent(i));
			} catch {}
		}), t;
	}
	containsKey(e) {
		return this.getKeys().includes(e);
	}
	decryptData() {
		return Promise.resolve(null);
	}
};
function au(e) {
	return new Date((/* @__PURE__ */ new Date()).getTime() + e * nu).toUTCString();
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/CacheHelpers.mjs
function ou(e, t) {
	let n = e.getItem(eu(t));
	return n ? JSON.parse(n) : [];
}
function Z(e, t, n) {
	let r = t.getItem(tu(e, n));
	if (r) {
		let e = JSON.parse(r);
		if (e && e.hasOwnProperty("idToken") && e.hasOwnProperty("accessToken") && e.hasOwnProperty("refreshToken")) return e;
	}
	return {
		idToken: [],
		accessToken: [],
		refreshToken: []
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/EncryptedData.mjs
function su(e) {
	return e.hasOwnProperty("id") && e.hasOwnProperty("nonce") && e.hasOwnProperty("data");
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/LocalStorage.mjs
var cu = "msal.cache.encryption", lu = "msal.broadcast.cache", uu = class {
	constructor(e, t, n) {
		if (!window.localStorage) throw J(fl);
		this.memoryStorage = new Pl(), this.initialized = !1, this.clientId = e, this.logger = t, this.performanceClient = n, this.broadcast = new BroadcastChannel(lu);
	}
	async initialize(e) {
		let t = new iu(), n = t.getItem(cu), r = {
			key: "",
			id: ""
		};
		if (n) try {
			r = JSON.parse(n);
		} catch {}
		if (r.key && r.id) {
			let t = P(Mc, hs, this.logger, this.performanceClient, e)(r.key);
			this.encryptionCookie = {
				id: r.id,
				key: await F(ol, ps, this.logger, this.performanceClient, e)(t)
			};
		} else {
			let n = Zc(), r = await F(al, ms, this.logger, this.performanceClient, e)(), i = P(Is, gs, this.logger, this.performanceClient, e)(new Uint8Array(r));
			this.encryptionCookie = {
				id: n,
				key: await F(ol, ps, this.logger, this.performanceClient, e)(r)
			};
			let a = {
				id: n,
				key: i
			};
			t.setItem(cu, JSON.stringify(a), 0, !0, ru.None);
		}
		await F(this.importExistingCache.bind(this), ss, this.logger, this.performanceClient, e)(e), this.broadcast.addEventListener("message", (t) => {
			this.updateCache(t, e);
		}), this.initialized = !0;
	}
	getItem(e) {
		return window.localStorage.getItem(e);
	}
	getUserData(e) {
		if (!this.initialized) throw R(Cc);
		return this.memoryStorage.getItem(e);
	}
	async decryptData(e, t, n) {
		if (!this.initialized || !this.encryptionCookie) throw R(Cc);
		if (t.id !== this.encryptionCookie.id) return this.performanceClient.incrementFields({ encryptedCacheExpiredCount: 1 }, n), null;
		let r = await F(ll, vs, this.logger, this.performanceClient, n)(this.encryptionCookie.key, t.nonce, this.getContext(e), t.data);
		if (!r) return null;
		try {
			return {
				...JSON.parse(r),
				lastUpdatedAt: t.lastUpdatedAt
			};
		} catch {
			return this.performanceClient.incrementFields({ encryptedCacheCorruptionCount: 1 }, n), null;
		}
	}
	setItem(e, t) {
		window.localStorage.setItem(e, t);
	}
	async setUserData(e, t, n, r, i) {
		if (!this.initialized || !this.encryptionCookie) throw R(Cc);
		if (i) this.setItem(e, t);
		else {
			let { data: i, nonce: a } = await F(cl, _s, this.logger, this.performanceClient, n)(this.encryptionCookie.key, t, this.getContext(e)), o = {
				id: this.encryptionCookie.id,
				nonce: a,
				data: i,
				lastUpdatedAt: r
			};
			this.setItem(e, JSON.stringify(o));
		}
		this.memoryStorage.setItem(e, t), this.broadcast.postMessage({
			key: e,
			value: t,
			context: this.getContext(e)
		});
	}
	removeItem(e) {
		this.memoryStorage.containsKey(e) && (this.memoryStorage.removeItem(e), this.broadcast.postMessage({
			key: e,
			value: null,
			context: this.getContext(e)
		})), window.localStorage.removeItem(e);
	}
	getKeys() {
		return Object.keys(window.localStorage);
	}
	containsKey(e) {
		return window.localStorage.hasOwnProperty(e);
	}
	clear() {
		this.memoryStorage.clear(), ou(this).forEach((e) => this.removeItem(e));
		let e = Z(this.clientId, this);
		e.idToken.forEach((e) => this.removeItem(e)), e.accessToken.forEach((e) => this.removeItem(e)), e.refreshToken.forEach((e) => this.removeItem(e)), this.getKeys().forEach((e) => {
			(e.startsWith("msal") || e.indexOf(this.clientId) !== -1) && this.removeItem(e);
		});
	}
	async importExistingCache(e) {
		if (!this.encryptionCookie) return;
		let t = ou(this);
		t = await this.importArray(t, e), t.length ? this.setItem(eu(), JSON.stringify(t)) : this.removeItem(eu());
		let n = Z(this.clientId, this);
		n.idToken = await this.importArray(n.idToken, e), n.accessToken = await this.importArray(n.accessToken, e), n.refreshToken = await this.importArray(n.refreshToken, e), n.idToken.length || n.accessToken.length || n.refreshToken.length ? this.setItem(tu(this.clientId), JSON.stringify(n)) : this.removeItem(tu(this.clientId));
	}
	async getItemFromEncryptedCache(e, t) {
		if (!this.encryptionCookie) return null;
		let n = this.getItem(e);
		if (!n) return null;
		let r;
		try {
			r = JSON.parse(n);
		} catch {
			return null;
		}
		return su(r) ? r.id === this.encryptionCookie.id ? (this.performanceClient.incrementFields({ encryptedCacheCount: 1 }, t), F(ll, vs, this.logger, this.performanceClient, t)(this.encryptionCookie.key, r.nonce, this.getContext(e), r.data)) : (this.performanceClient.incrementFields({ encryptedCacheExpiredCount: 1 }, t), null) : (this.performanceClient.incrementFields({ unencryptedCacheCount: 1 }, t), n);
	}
	async importArray(e, t) {
		let n = [], r = [];
		return e.forEach((e) => {
			let i = this.getItemFromEncryptedCache(e, t).then((t) => {
				t ? (this.memoryStorage.setItem(e, t), n.push(e)) : this.removeItem(e);
			});
			r.push(i);
		}), await Promise.all(r), n;
	}
	getContext(e) {
		let t = "";
		return e.includes(this.clientId) && (t = this.clientId), t;
	}
	updateCache(e, t) {
		this.logger.trace("17cxcm", t);
		let n = this.performanceClient.startMeasurement(Gl);
		n.add({ isBackground: !0 });
		let { key: r, value: i, context: a } = e.data;
		if (!r) {
			this.logger.error("0e10qr", t), n.end({
				success: !1,
				errorCode: "noKey"
			});
			return;
		}
		if (a && a !== this.clientId) {
			this.logger.trace("04rtdy", t), n.end({
				success: !1,
				errorCode: "contextMismatch"
			});
			return;
		}
		i ? (this.memoryStorage.setItem(r, i), this.logger.verbose("1vzsgt", t)) : (this.memoryStorage.removeItem(r), this.logger.verbose("04ypih", t)), n.end({ success: !0 });
	}
}, du = class {
	constructor() {
		if (!window.sessionStorage) throw J(fl);
	}
	async initialize() {}
	getItem(e) {
		return window.sessionStorage.getItem(e);
	}
	getUserData(e) {
		return this.getItem(e);
	}
	setItem(e, t) {
		window.sessionStorage.setItem(e, t);
	}
	async setUserData(e, t) {
		this.setItem(e, t);
	}
	removeItem(e) {
		window.sessionStorage.removeItem(e);
	}
	getKeys() {
		return Object.keys(window.sessionStorage);
	}
	containsKey(e) {
		return window.sessionStorage.hasOwnProperty(e);
	}
	decryptData() {
		return Promise.resolve(null);
	}
}, Q = {
	INITIALIZE_START: "msal:initializeStart",
	INITIALIZE_END: "msal:initializeEnd",
	ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
	LOGIN_SUCCESS: "msal:loginSuccess",
	ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
	BROKERED_REQUEST_START: "msal:brokeredRequestStart",
	ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
	BROKERED_REQUEST_SUCCESS: "msal:brokeredRequestSuccess",
	ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
	BROKERED_REQUEST_FAILURE: "msal:brokeredRequestFailure",
	ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
	HANDLE_REDIRECT_START: "msal:handleRedirectStart",
	HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
	POPUP_OPENED: "msal:popupOpened",
	LOGOUT_START: "msal:logoutStart",
	LOGOUT_SUCCESS: "msal:logoutSuccess",
	LOGOUT_FAILURE: "msal:logoutFailure",
	LOGOUT_END: "msal:logoutEnd",
	RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
	BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
}, fu = "@azure/msal-browser", pu = "5.11.0";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/utils/Helpers.mjs
function mu(e, t) {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/BrowserCacheManager.mjs
var hu = class extends li {
	constructor(e, t, n, r, i, a, o) {
		super(e, n, r, i, o), this.cacheConfig = t, this.logger = r, this.internalStorage = new Pl(), this.browserStorage = gu(e, t.cacheLocation, r, i), this.temporaryCacheStorage = gu(e, V.SessionStorage, r, i), this.cookieStorage = new iu(), this.eventHandler = a;
	}
	async initialize(e) {
		this.performanceClient.addFields({
			cacheLocation: this.cacheConfig.cacheLocation,
			cacheRetentionDays: this.cacheConfig.cacheRetentionDays
		}, e), await this.browserStorage.initialize(e), await this.migrateExistingCache(e), this.trackVersionChanges(e);
	}
	async migrateExistingCache(e) {
		let t = ou(this.browserStorage), n = Z(this.clientId, this.browserStorage);
		this.performanceClient.addFields({
			preMigrateAcntCount: t.length,
			preMigrateATCount: n.accessToken.length,
			preMigrateITCount: n.idToken.length,
			preMigrateRTCount: n.refreshToken.length
		}, e);
		for (let t = 0; t < 3; t++) {
			let n = t;
			await this.removeStaleAccounts(t, n, e);
		}
		for (let t = 0; t < 3; t++) {
			let n = t;
			await this.migrateIdTokens(t, n, e);
		}
		let r = this.getKMSIValues();
		for (let t = 0; t < 3; t++) await this.migrateAccessTokens(t, r, e), await this.migrateRefreshTokens(t, r, e);
		t = ou(this.browserStorage), n = Z(this.clientId, this.browserStorage), this.performanceClient.addFields({
			postMigrateAcntCount: t.length,
			postMigrateATCount: n.accessToken.length,
			postMigrateITCount: n.idToken.length,
			postMigrateRTCount: n.refreshToken.length
		}, e);
	}
	async updateOldEntry(e, t) {
		let n = this.browserStorage.getItem(e), r = this.validateAndParseJson(n || "");
		if (!r) return this.browserStorage.removeItem(e), null;
		if (!r.lastUpdatedAt) r.lastUpdatedAt = Date.now().toString(), this.setItem(e, JSON.stringify(r), t);
		else if (Di(r.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) return this.browserStorage.removeItem(e), this.performanceClient.incrementFields({ expiredCacheRemovedCount: 1 }, t), null;
		let i = su(r) ? await this.browserStorage.decryptData(e, r, t) : r;
		return !i || !Mi(i) ? (this.performanceClient.incrementFields({ invalidCacheCount: 1 }, t), null) : (Ni(i) || Fi(i)) && i.expiresOn && Ei(i.expiresOn, 300) ? (this.browserStorage.removeItem(e), this.performanceClient.incrementFields({ expiredCacheRemovedCount: 1 }, t), null) : i;
	}
	async removeStaleAccounts(e, t, n) {
		let r = ou(this.browserStorage, e);
		if (r.length !== 0) {
			for (let e of [...r]) {
				this.performanceClient.incrementFields({ oldAcntCount: 1 }, n);
				let i = this.browserStorage.getItem(e), a = this.validateAndParseJson(i || "");
				if (!a) {
					mu(r, e);
					continue;
				}
				if (a.lastUpdatedAt) Di(a.lastUpdatedAt, this.cacheConfig.cacheRetentionDays) && (await this.removeAccountOldSchema(e, a, t, n), mu(r, e));
				else {
					a.lastUpdatedAt = Date.now().toString(), this.setItem(e, JSON.stringify(a), n);
					continue;
				}
			}
			this.setAccountKeys(r, n, e);
		}
	}
	async removeAccountOldSchema(e, t, n, r) {
		let i = (su(t) ? await this.browserStorage.decryptData(e, t, r) : t)?.homeAccountId;
		if (i) {
			let e = this.getTokenKeys(n);
			[...e.idToken].filter((e) => e.includes(i)).forEach((t) => {
				this.browserStorage.removeItem(t), mu(e.idToken, t);
			}), [...e.accessToken].filter((e) => e.includes(i)).forEach((t) => {
				this.browserStorage.removeItem(t), mu(e.accessToken, t);
			}), [...e.refreshToken].filter((e) => e.includes(i)).forEach((t) => {
				this.browserStorage.removeItem(t), mu(e.refreshToken, t);
			}), this.setTokenKeys(e, r, n);
		}
		this.performanceClient.incrementFields({ expiredAcntRemovedCount: 1 }, r), this.browserStorage.removeItem(e);
	}
	getKMSIValues() {
		let e = {}, t = this.getTokenKeys().idToken;
		for (let n of t) {
			let t = this.browserStorage.getUserData(n);
			if (t) {
				let n = JSON.parse(t), r = Lr(n.secret, q);
				r && (e[n.homeAccountId] = Rr(r));
			}
		}
		return e;
	}
	async migrateIdTokens(e, t, n) {
		let r = Z(this.clientId, this.browserStorage, e);
		if (r.idToken.length === 0) return;
		let i = Z(this.clientId, this.browserStorage, 3), a = ou(this.browserStorage), o = ou(this.browserStorage, t);
		for (let e of [...r.idToken]) {
			this.performanceClient.incrementFields({ oldITCount: 1 }, n);
			let t = await this.updateOldEntry(e, n);
			if (!t) {
				mu(r.idToken, e);
				continue;
			}
			let s = a.find((e) => e.includes(t.homeAccountId)), c = o.find((e) => e.includes(t.homeAccountId)), l = null;
			if (s) l = this.getAccount(s, n);
			else if (c) {
				let e = this.browserStorage.getItem(c), t = this.validateAndParseJson(e || "");
				l = t && su(t) ? await this.browserStorage.decryptData(c, t, n) : t;
			}
			if (!l) {
				this.performanceClient.incrementFields({ skipITMigrateCount: 1 }, n);
				continue;
			}
			let u = Lr(t.secret, q), d = this.generateCredentialKey(t), f = this.getIdTokenCredential(d, n), p = Object.keys(u).includes("signin_state"), m = f && Object.keys(Lr(f.secret, q) || {}).includes("signin_state");
			if (!f || t.lastUpdatedAt > f.lastUpdatedAt && (p || !m)) {
				let e = l.tenantProfiles || [], r = ri(u) || l.realm;
				if (r && !e.find((e) => e.tenantId === r)) {
					let t = Fr(l.homeAccountId, l.localAccountId, r, u);
					e.push(t);
				}
				l.tenantProfiles = e;
				let o = this.generateAccountKey(ii(l)), s = Rr(u);
				await this.setUserData(o, JSON.stringify(l), n, l.lastUpdatedAt, s), a.includes(o) || a.push(o), await this.setUserData(d, JSON.stringify(t), n, t.lastUpdatedAt, s), this.performanceClient.incrementFields({ migratedITCount: 1 }, n), i.idToken.includes(d) || i.idToken.push(d);
			}
		}
		this.setTokenKeys(r, n, e), this.setTokenKeys(i, n), this.setAccountKeys(a, n);
	}
	async migrateAccessTokens(e, t, n) {
		let r = Z(this.clientId, this.browserStorage, e);
		if (r.accessToken.length === 0) return;
		let i = Z(this.clientId, this.browserStorage, 3);
		for (let e of [...r.accessToken]) {
			this.performanceClient.incrementFields({ oldATCount: 1 }, n);
			let a = await this.updateOldEntry(e, n);
			if (!a) {
				mu(r.accessToken, e);
				continue;
			}
			if (!(a.homeAccountId in t)) {
				this.performanceClient.incrementFields({ skipATMigrateCount: 1 }, n);
				continue;
			}
			let o = this.generateCredentialKey(a), s = t[a.homeAccountId];
			if (!i.accessToken.includes(o)) await this.setUserData(o, JSON.stringify(a), n, a.lastUpdatedAt, s), this.performanceClient.incrementFields({ migratedATCount: 1 }, n), i.accessToken.push(o);
			else {
				let e = this.getAccessTokenCredential(o, n);
				(!e || a.lastUpdatedAt > e.lastUpdatedAt) && (await this.setUserData(o, JSON.stringify(a), n, a.lastUpdatedAt, s), this.performanceClient.incrementFields({ migratedATCount: 1 }, n));
			}
		}
		this.setTokenKeys(r, n, e), this.setTokenKeys(i, n);
	}
	async migrateRefreshTokens(e, t, n) {
		let r = Z(this.clientId, this.browserStorage, e);
		if (r.refreshToken.length === 0) return;
		let i = Z(this.clientId, this.browserStorage, 3);
		for (let e of [...r.refreshToken]) {
			this.performanceClient.incrementFields({ oldRTCount: 1 }, n);
			let a = await this.updateOldEntry(e, n);
			if (!a) {
				mu(r.refreshToken, e);
				continue;
			}
			if (!(a.homeAccountId in t)) {
				this.performanceClient.incrementFields({ skipRTMigrateCount: 1 }, n);
				continue;
			}
			let o = this.generateCredentialKey(a), s = t[a.homeAccountId];
			if (!i.refreshToken.includes(o)) await this.setUserData(o, JSON.stringify(a), n, a.lastUpdatedAt, s), this.performanceClient.incrementFields({ migratedRTCount: 1 }, n), i.refreshToken.push(o);
			else {
				let e = this.getRefreshTokenCredential(o, n);
				(!e || a.lastUpdatedAt > e.lastUpdatedAt) && (await this.setUserData(o, JSON.stringify(a), n, a.lastUpdatedAt, s), this.performanceClient.incrementFields({ migratedRTCount: 1 }, n));
			}
		}
		this.setTokenKeys(r, n, e), this.setTokenKeys(i, n);
	}
	trackVersionChanges(e) {
		let t = this.browserStorage.getItem(Xl);
		t && (this.logger.info("1wuc87", e), this.performanceClient.addFields({ previousLibraryVersion: t }, e)), t !== "5.11.0" && this.setItem(Xl, pu, e);
	}
	validateAndParseJson(e) {
		if (!e) return null;
		try {
			let t = JSON.parse(e);
			return t && typeof t == "object" ? t : null;
		} catch {
			return null;
		}
	}
	setItem(e, t, n) {
		let r = [
			,
			,
			,
			,
		].fill(0), i = [];
		for (let a = 0; a <= 20; a++) try {
			if (this.browserStorage.setItem(e, t), a > 0) for (let e = 0; e <= 3; e++) {
				let t = r.slice(0, e).reduce((e, t) => e + t, 0);
				if (t >= a) break;
				let o = a > t + r[e] ? t + r[e] : a;
				a > t && r[e] > 0 && this.removeAccessTokenKeys(i.slice(t, o), n, e);
			}
			break;
		} catch (o) {
			let s = ei(o);
			if (s.errorCode === "cache_quota_exceeded" && a < 20) {
				if (!i.length) for (let n = 0; n <= 3; n++) if (e === tu(this.clientId, n)) {
					let e = JSON.parse(t).accessToken;
					i.push(...e), r[n] = e.length;
				} else {
					let e = this.getTokenKeys(n).accessToken;
					i.push(...e), r[n] = e.length;
				}
				if (i.length <= a) throw s;
				this.removeAccessToken(i[a], n, !1);
			} else throw s;
		}
	}
	async setUserData(e, t, n, r, i) {
		let a = [
			,
			,
			,
			,
		].fill(0), o = [];
		for (let s = 0; s <= 20; s++) try {
			if (await F(this.browserStorage.setUserData.bind(this.browserStorage), ga, this.logger, this.performanceClient, n)(e, t, n, r, i), s > 0) for (let e = 0; e <= 3; e++) {
				let t = a.slice(0, e).reduce((e, t) => e + t, 0);
				if (t >= s) break;
				let r = s > t + a[e] ? t + a[e] : s;
				s > t && a[e] > 0 && this.removeAccessTokenKeys(o.slice(t, r), n, e);
			}
			break;
		} catch (e) {
			let t = ei(e);
			if (t.errorCode === "cache_quota_exceeded" && s < 20) {
				if (!o.length) for (let e = 0; e <= 3; e++) {
					let t = this.getTokenKeys(e).accessToken;
					o.push(...t), a[e] = t.length;
				}
				if (o.length <= s) throw t;
				this.removeAccessToken(o[s], n, !1);
			} else throw t;
		}
	}
	getAccount(e, t) {
		this.logger.trace("1lfvm6", t);
		let n = this.browserStorage.getUserData(e);
		if (!n) return this.removeAccountKeyFromMap(e, t), null;
		let r = this.validateAndParseJson(n);
		if (!r || !ci(r)) return null;
		let i = li.toObject({}, r);
		return this.performanceClient.addFields({ accountCachedBy: ks(i.cachedByApiId) }, t), i;
	}
	async setAccount(e, t, n, r) {
		this.logger.trace("1bz3wr", t);
		let i = this.generateAccountKey(ii(e)), a = Date.now().toString();
		e.lastUpdatedAt = a, e.cachedByApiId = r, await this.setUserData(i, JSON.stringify(e), t, a, n), this.addAccountKeyToMap(i, t), this.performanceClient.addFields({ kmsi: n }, t);
	}
	setAccountKeys(e, t, n = 3) {
		e.length === 0 ? this.removeItem(eu(n)) : this.setItem(eu(n), JSON.stringify(e), t);
	}
	getAccountKeys() {
		return ou(this.browserStorage);
	}
	addAccountKeyToMap(e, t) {
		this.logger.trace("0rb85k", t), this.logger.tracePii("1l9bdo", t);
		let n = this.getAccountKeys();
		return n.indexOf(e) === -1 ? (n.push(e), this.setItem(eu(), JSON.stringify(n), t), this.logger.verbose("0xia39", t), !0) : (this.logger.verbose("0161kk", t), !1);
	}
	removeAccountKeyFromMap(e, t) {
		this.logger.trace("1jpigu", t), this.logger.tracePii("1xzspl", t);
		let n = this.getAccountKeys(), r = n.indexOf(e);
		r > -1 ? (n.splice(r, 1), this.setAccountKeys(n, t)) : this.logger.trace("1dytu2", t);
	}
	removeAccount(e, t) {
		let n = this.getActiveAccount(t);
		n?.homeAccountId === e.homeAccountId && n?.environment === e.environment && this.setActiveAccount(null, t), super.removeAccount(e, t), this.removeAccountKeyFromMap(this.generateAccountKey(e), t), this.browserStorage.getKeys().forEach((t) => {
			t.includes(e.homeAccountId) && t.includes(e.environment) && this.browserStorage.removeItem(t);
		});
	}
	removeIdToken(e, t) {
		super.removeIdToken(e, t);
		let n = this.getTokenKeys(), r = n.idToken.indexOf(e);
		r > -1 && (this.logger.info("05udv9", t), n.idToken.splice(r, 1), this.setTokenKeys(n, t));
	}
	removeAccessToken(e, t, n = !0) {
		super.removeAccessToken(e, t), n && this.removeAccessTokenKeys([e], t);
	}
	removeAccessTokenKeys(e, t, n = 3) {
		this.logger.trace("17o18n", t);
		let r = this.getTokenKeys(n), i = 0;
		if (e.forEach((e) => {
			let t = r.accessToken.indexOf(e);
			t > -1 && (r.accessToken.splice(t, 1), i++);
		}), i > 0) {
			this.logger.info("15i5d5", t), this.setTokenKeys(r, t, n);
			return;
		}
	}
	removeRefreshToken(e, t) {
		super.removeRefreshToken(e, t);
		let n = this.getTokenKeys(), r = n.refreshToken.indexOf(e);
		r > -1 && (this.logger.info("1f4fq3", t), n.refreshToken.splice(r, 1), this.setTokenKeys(n, t));
	}
	getTokenKeys(e = 3) {
		return Z(this.clientId, this.browserStorage, e);
	}
	setTokenKeys(e, t, n = 3) {
		if (e.idToken.length === 0 && e.accessToken.length === 0 && e.refreshToken.length === 0) {
			this.removeItem(tu(this.clientId, n));
			return;
		} else this.setItem(tu(this.clientId, n), JSON.stringify(e), t);
	}
	getIdTokenCredential(e, t) {
		let n = this.browserStorage.getUserData(e);
		if (!n) return this.logger.trace("1jukz6", t), this.removeIdToken(e, t), null;
		let r = this.validateAndParseJson(n);
		return !r || !Pi(r) ? (this.logger.trace("1jukz6", t), null) : (this.logger.trace("01ju66", t), r);
	}
	async setIdTokenCredential(e, t, n) {
		this.logger.trace("13hjll", t);
		let r = this.generateCredentialKey(e), i = Date.now().toString();
		e.lastUpdatedAt = i, await this.setUserData(r, JSON.stringify(e), t, i, n);
		let a = this.getTokenKeys();
		a.idToken.indexOf(r) === -1 && (this.logger.info("07jy92", t), a.idToken.push(r), this.setTokenKeys(a, t));
	}
	getAccessTokenCredential(e, t) {
		let n = this.browserStorage.getUserData(e);
		if (!n) return this.logger.trace("0bqvx8", t), this.removeAccessTokenKeys([e], t), null;
		let r = this.validateAndParseJson(n);
		return !r || !Ni(r) ? (this.logger.trace("0bqvx8", t), null) : (this.logger.trace("1o81rl", t), r);
	}
	async setAccessTokenCredential(e, t, n) {
		this.logger.trace("1pondb", t);
		let r = this.generateCredentialKey(e), i = Date.now().toString();
		e.lastUpdatedAt = i, await this.setUserData(r, JSON.stringify(e), t, i, n);
		let a = this.getTokenKeys(), o = a.accessToken.indexOf(r);
		o !== -1 && a.accessToken.splice(o, 1), this.logger.trace("1onhey", t), a.accessToken.push(r), this.setTokenKeys(a, t);
	}
	getRefreshTokenCredential(e, t) {
		let n = this.browserStorage.getUserData(e);
		if (!n) return this.logger.trace("0jlizt", t), this.removeRefreshToken(e, t), null;
		let r = this.validateAndParseJson(n);
		return !r || !Fi(r) ? (this.logger.trace("0jlizt", t), null) : (this.logger.trace("0nokxi", t), r);
	}
	async setRefreshTokenCredential(e, t, n) {
		this.logger.trace("0tcg8d", t);
		let r = this.generateCredentialKey(e), i = Date.now().toString();
		e.lastUpdatedAt = i, await this.setUserData(r, JSON.stringify(e), t, i, n);
		let a = this.getTokenKeys();
		a.refreshToken.indexOf(r) === -1 && (this.logger.info("0eckjs", t), a.refreshToken.push(r), this.setTokenKeys(a, t));
	}
	getAppMetadata(e, t) {
		let n = this.browserStorage.getItem(e);
		if (!n) return this.logger.trace("1q101h", t), null;
		let r = this.validateAndParseJson(n);
		return !r || !zi(e, r) ? (this.logger.trace("1q101h", t), null) : (this.logger.trace("19pvg2", t), r);
	}
	setAppMetadata(e, t) {
		this.logger.trace("0cyma6", t);
		let n = Ri(e);
		this.setItem(n, JSON.stringify(e), t);
	}
	getServerTelemetry(e, t) {
		let n = this.browserStorage.getItem(e);
		if (!n) return this.logger.trace("0jk19c", t), null;
		let r = this.validateAndParseJson(n);
		return !r || !Ii(e, r) ? (this.logger.trace("0jk19c", t), null) : (this.logger.trace("12jguk", t), r);
	}
	setServerTelemetry(e, t, n) {
		this.logger.trace("1poh61", n), this.setItem(e, JSON.stringify(t), n);
	}
	getAuthorityMetadata(e, t) {
		let n = this.internalStorage.getItem(e);
		if (!n) return this.logger.trace("1r39oe", t), null;
		let r = this.validateAndParseJson(n);
		return r && Bi(e, r) ? (this.logger.trace("1ohvk3", t), r) : null;
	}
	getAuthorityMetadataKeys() {
		return this.internalStorage.getKeys().filter((e) => this.isAuthorityMetadata(e));
	}
	setWrapperMetadata(e, t) {
		this.internalStorage.setItem(Ds.WRAPPER_SKU, e), this.internalStorage.setItem(Ds.WRAPPER_VER, t);
	}
	getWrapperMetadata() {
		return [this.internalStorage.getItem(Ds.WRAPPER_SKU) || "", this.internalStorage.getItem(Ds.WRAPPER_VER) || ""];
	}
	setAuthorityMetadata(e, t, n) {
		this.logger.trace("07w8n2", n), this.internalStorage.setItem(e, JSON.stringify(t));
	}
	getActiveAccount(e) {
		let t = this.generateCacheKey(he.ACTIVE_ACCOUNT_FILTERS), n = this.browserStorage.getItem(t);
		if (!n) return this.logger.trace("08gw0e", e), null;
		let r = this.validateAndParseJson(n);
		return r ? (this.logger.trace("1t3ch7", e), this.getAccountInfoFilteredBy({
			homeAccountId: r.homeAccountId,
			localAccountId: r.localAccountId,
			tenantId: r.tenantId
		}, e)) : (this.logger.trace("0me1up", e), null);
	}
	setActiveAccount(e, t) {
		let n = this.generateCacheKey(he.ACTIVE_ACCOUNT_FILTERS);
		if (e) {
			this.logger.verbose("0rsj80", t);
			let r = {
				homeAccountId: e.homeAccountId,
				localAccountId: e.localAccountId,
				tenantId: e.tenantId
			};
			this.setItem(n, JSON.stringify(r), t);
		} else this.logger.verbose("1bp5z5", t), this.browserStorage.removeItem(n);
		this.eventHandler.emitEvent(Q.ACTIVE_ACCOUNT_CHANGED, t);
	}
	getThrottlingCache(e, t) {
		let n = this.browserStorage.getItem(e);
		if (!n) return this.logger.trace("1h4wa6", t), null;
		let r = this.validateAndParseJson(n);
		return !r || !Li(e, r) ? (this.logger.trace("1h4wa6", t), null) : (this.logger.trace("0of6n8", t), r);
	}
	setThrottlingCache(e, t, n) {
		this.logger.trace("0wfgh6", n), this.setItem(e, JSON.stringify(t), n);
	}
	getTemporaryCache(e, t, n) {
		this.logger.trace("1ordf8", t);
		let r = n ? this.generateCacheKey(e) : e;
		return this.temporaryCacheStorage.getItem(r);
	}
	setTemporaryCache(e, t, n) {
		let r = n ? this.generateCacheKey(e) : e;
		this.temporaryCacheStorage.setItem(r, t);
	}
	removeItem(e) {
		this.browserStorage.removeItem(e);
	}
	removeTemporaryItem(e) {
		this.temporaryCacheStorage.removeItem(e);
	}
	getKeys() {
		return this.browserStorage.getKeys();
	}
	clear(e) {
		this.removeAllAccounts(e), this.removeAppMetadata(e), this.temporaryCacheStorage.getKeys().forEach((e) => {
			(e.indexOf("msal") !== -1 || e.indexOf(this.clientId) !== -1) && this.removeTemporaryItem(e);
		}), this.browserStorage.getKeys().forEach((e) => {
			(e.indexOf("msal") !== -1 || e.indexOf(this.clientId) !== -1) && this.browserStorage.removeItem(e);
		}), this.internalStorage.clear();
	}
	generateCacheKey(e) {
		return w.startsWith(e, "msal") ? e : `${X}.${this.clientId}.${e}`;
	}
	generateCredentialKey(e) {
		let t = e.credentialType === y.REFRESH_TOKEN && e.familyId || e.clientId, n = e.tokenType && e.tokenType.toLowerCase() !== x.BEARER.toLowerCase() ? e.tokenType.toLowerCase() : "";
		return [
			`${X}.3`,
			e.homeAccountId,
			e.environment,
			e.credentialType,
			t,
			e.realm || "",
			e.target || "",
			n
		].join("|").toLowerCase();
	}
	generateAccountKey(e) {
		let t = e.homeAccountId.split(".")[1];
		return [
			`${X}.3`,
			e.homeAccountId,
			e.environment,
			t || e.tenantId || ""
		].join("|").toLowerCase();
	}
	resetRequestCache(e) {
		this.logger.trace("0h0ynu", e), this.removeTemporaryItem(this.generateCacheKey(H.REQUEST_PARAMS)), this.removeTemporaryItem(this.generateCacheKey(H.VERIFIER)), this.removeTemporaryItem(this.generateCacheKey(H.ORIGIN_URI)), this.removeTemporaryItem(this.generateCacheKey(H.URL_HASH)), this.removeTemporaryItem(this.generateCacheKey(H.NATIVE_REQUEST)), this.setInteractionInProgress(!1, void 0);
	}
	cacheAuthorizeRequest(e, t, n) {
		this.logger.trace("1tzef5", t);
		let r = Ls(JSON.stringify(e));
		if (this.setTemporaryCache(H.REQUEST_PARAMS, r, !0), n) {
			let e = Ls(n);
			this.setTemporaryCache(H.VERIFIER, e, !0);
		}
	}
	getCachedRequest(e) {
		this.logger.trace("0uen20", e);
		let t = this.getTemporaryCache(H.REQUEST_PARAMS, e, !0);
		if (!t) throw R(oc);
		let n = this.getTemporaryCache(H.VERIFIER, e, !0), r, i = "";
		try {
			r = JSON.parse(q(t)), n && (i = q(n));
		} catch {
			throw this.logger.errorPii("0ewsey", e), this.logger.error("0tvdic", e), R(sc);
		}
		return [r, i];
	}
	getCachedNativeRequest() {
		this.logger.trace("1yxcdm", "");
		let e = this.getTemporaryCache(H.NATIVE_REQUEST, "", !0);
		return e ? this.validateAndParseJson(e) || (this.logger.error("0rrkip", ""), null) : (this.logger.trace("0mnxd4", ""), null);
	}
	isInteractionInProgress(e) {
		let t = this.getInteractionInProgress()?.clientId;
		return e ? t === this.clientId : !!t;
	}
	getInteractionInProgress() {
		let e = `${X}.${H.INTERACTION_STATUS_KEY}`, t = this.getTemporaryCache(e, "", !1);
		try {
			return t ? JSON.parse(t) : null;
		} catch {
			return this.logger.error("0jjyys", ""), this.removeTemporaryItem(e), this.resetRequestCache(""), hl(window), null;
		}
	}
	setInteractionInProgress(e, t = Es.SIGNIN, n = !1, r = "") {
		let i = `${X}.${H.INTERACTION_STATUS_KEY}`;
		if (e) {
			if (this.getInteractionInProgress()) if (n) this.logger.warning("1pmscr", r), bl(this.logger, r), this.removeTemporaryItem(i);
			else throw R(Ys);
			this.setTemporaryCache(i, JSON.stringify({
				clientId: this.clientId,
				type: t
			}), !1);
		} else !e && this.getInteractionInProgress()?.clientId === this.clientId && this.removeTemporaryItem(i);
	}
	async hydrateCache(e, t) {
		let n = ki(e.account.homeAccountId, e.account.environment, e.idToken, this.clientId, e.tenantId), r = Ai(e.account.homeAccountId, e.account.environment, e.accessToken, this.clientId, e.tenantId, e.scopes.join(" "), e.expiresOn ? wi(e.expiresOn) : 0, e.extExpiresOn ? wi(e.extExpiresOn) : 0, q, void 0, e.tokenType, void 0, t.sshKid);
		t.resource && (r.resource = t.resource);
		let i = {
			idToken: n,
			accessToken: r
		};
		return this.saveCacheRecord(i, e.correlationId, Rr(Lr(e.idToken, q)), U.hydrateCache);
	}
	async saveCacheRecord(e, t, n, r, i) {
		try {
			await super.saveCacheRecord(e, t, n, r, i);
		} catch (e) {
			if (e instanceof $r && this.performanceClient && t) try {
				let e = this.getTokenKeys();
				this.performanceClient.addFields({
					cacheRtCount: e.refreshToken.length,
					cacheIdCount: e.idToken.length,
					cacheAtCount: e.accessToken.length
				}, t);
			} catch {}
			throw e;
		}
	}
};
function gu(e, t, n, r) {
	try {
		switch (t) {
			case V.LocalStorage: return new uu(e, n, r);
			case V.SessionStorage: return new du();
			case V.MemoryStorage:
			default: break;
		}
	} catch (e) {
		n.error(e, "");
	}
	return new Pl();
}
var _u = (e, t, n, r) => new hu(e, {
	cacheLocation: V.MemoryStorage,
	cacheRetentionDays: 5
}, Cr, t, n, r);
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/cache/AccountManager.mjs
function vu(e, t, n, r, i) {
	return e.verbose("1yd030", r), n ? t.getAllAccounts(i, r) : [];
}
function yu(e, t, n, r) {
	t.trace("0u7b90", r);
	let i = n.getAccountInfoFilteredBy(e, r);
	return i ? (t.verbose("0btgll", r), i) : (t.verbose("0ltaj5", r), null);
}
function bu(e, t, n) {
	t.setActiveAccount(e, n);
}
function xu(e, t) {
	return e.getActiveAccount(t);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/event/EventHandler.mjs
var Su = "msal.broadcast.event", Cu = class {
	constructor(e) {
		this.eventCallbacks = /* @__PURE__ */ new Map(), this.logger = e || new Ar({}), typeof BroadcastChannel < "u" && (this.broadcastChannel = new BroadcastChannel(Su)), this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
	}
	addEventCallback(e, t, n) {
		if (typeof window < "u") {
			let r = n || Ml();
			return this.eventCallbacks.has(r) ? (this.logger.error("1578i0", ""), null) : (this.eventCallbacks.set(r, [e, t || []]), this.logger.verbose("1cnec4", ""), r);
		}
		return null;
	}
	removeEventCallback(e) {
		this.eventCallbacks.delete(e), this.logger.verbose("12zotd", "");
	}
	emitEvent(e, t, n, r, i) {
		let a = {
			eventType: e,
			interactionType: n || null,
			payload: r || null,
			error: i || null,
			correlationId: t,
			timestamp: Date.now()
		};
		switch (e) {
			case Q.LOGIN_SUCCESS:
			case Q.LOGOUT_SUCCESS:
			case Q.ACTIVE_ACCOUNT_CHANGED: this.broadcastChannel?.postMessage(a);
		}
		this.invokeCallbacks(a);
	}
	invokeCallbacks(e) {
		this.eventCallbacks.forEach(([t, n], r) => {
			(n.length === 0 || n.includes(e.eventType)) && (this.logger.verbose("15jpwk", ""), t.apply(null, [e]));
		});
	}
	invokeCrossTabCallbacks(e) {
		let t = e.data;
		this.invokeCallbacks(t);
	}
	subscribeCrossTab() {
		this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
	}
	unsubscribeCrossTab() {
		this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
	}
}, wu = class {
	constructor(e, t, n, r, i, a, o, s, c) {
		this.config = e, this.browserStorage = t, this.browserCrypto = n, this.networkClient = this.config.system.networkClient, this.eventHandler = i, this.navigationClient = a, this.platformAuthProvider = c, this.correlationId = s, this.logger = r.clone(z.MSAL_SKU, pu), this.performanceClient = o;
	}
};
function Tu(e, t, n, r) {
	n.verbose("0bd1la", r);
	let i = e || t || "";
	return A.getAbsoluteUrl(i, Sl());
}
function $(e, t, n, r, i, a) {
	return i.verbose("1p12tq", n), new _o({
		clientId: t,
		correlationId: n,
		apiId: e,
		forceRefresh: a || !1,
		wrapperSKU: r.getWrapperMetadata()[0],
		wrapperVer: r.getWrapperMetadata()[1]
	}, r);
}
async function Eu(e, t, n, r, i, a, o, s, c) {
	let l = s && s.hasOwnProperty("instance_aware") ? s.instance_aware : void 0, u = {
		protocolMode: e.system.protocolMode,
		OIDCOptions: e.auth.OIDCOptions,
		knownAuthorities: e.auth.knownAuthorities,
		cloudDiscoveryMetadata: e.auth.cloudDiscoveryMetadata,
		authorityMetadata: e.auth.authorityMetadata
	}, d = a || e.auth.authority, f = l?.length ? l === "true" : e.auth.instanceAware, p = c && f ? e.auth.authority.replace(A.getDomainFromUrl(d), c.environment) : d, m = Ka.generateAuthority(p, o || e.auth.azureCloudOptions), h = await F(Xa, ts, i, n, t)(m, e.system.networkClient, r, u, i, t, n);
	if (c && !h.isAlias(c.environment)) throw C(Jt);
	return h;
}
async function Du(e, t, n, r, i) {
	if (i) try {
		e.removeAccount(i, r), n.verbose("0s4z6h", r);
	} catch {
		n.error("0mgg1d", r);
	}
	else try {
		n.verbose("0zj631", r), e.clear(r), await t.clearKeystore(r);
	} catch {
		n.error("12ih0c", r);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/request/RequestHelpers.mjs
async function Ou(e, t, n, r, i) {
	let a = e.authority || t.auth.authority, o = [...e && e.scopes || []], s = {
		...e,
		correlationId: e.correlationId,
		authority: a,
		scopes: o
	};
	if (!s.authenticationScheme) s.authenticationScheme = x.BEARER, r.verbose("1l4fwv", i);
	else {
		if (s.authenticationScheme === x.SSH) {
			if (!e.sshJwk) throw C(Wt);
			if (!e.sshKid) throw C(Gt);
		}
		r.verbose("1ecmns", i);
	}
	return s;
}
async function ku(e, t, n, r, i) {
	let a = await F(Ou, Lo, i, r, e.correlationId)(e, n, r, i, e.correlationId);
	return {
		...e,
		...a,
		account: t,
		forceRefresh: e.forceRefresh || !1
	};
}
function Au(e, t) {
	let n, r = e.httpMethod;
	if (t === M.EAR) {
		if (r && r !== fe.POST) throw C(Yt);
		n = fe.POST;
	} else n = r || fe.GET;
	return n;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_client/StandardInteractionClient.mjs
var ju = class extends wu {
	initializeLogoutRequest(e) {
		this.logger.verbose("0546u4", this.correlationId);
		let t = {
			correlationId: this.correlationId,
			...e
		};
		if (e) if (e.logoutHint) this.logger.verbose("12k4l4", this.correlationId);
		else if (e.account) {
			let n = e.account.loginHint || this.getLogoutHintFromIdTokenClaims(e.account);
			n && (this.logger.verbose("0d7s8p", this.correlationId), t.logoutHint = n);
		} else this.logger.verbose("0pdtc3", this.correlationId);
		else this.logger.verbose("07ndze", this.correlationId);
		return !e || e.postLogoutRedirectUri !== null ? e && e.postLogoutRedirectUri ? (this.logger.verbose("1vamm6", t.correlationId), t.postLogoutRedirectUri = A.getAbsoluteUrl(e.postLogoutRedirectUri, Sl())) : this.config.auth.postLogoutRedirectUri === null ? this.logger.verbose("15m5g7", t.correlationId) : this.config.auth.postLogoutRedirectUri ? (this.logger.verbose("1f4xlz", t.correlationId), t.postLogoutRedirectUri = A.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, Sl())) : (this.logger.verbose("17s5rf", t.correlationId), t.postLogoutRedirectUri = A.getAbsoluteUrl(Sl(), Sl())) : this.logger.verbose("0ljv63", t.correlationId), t;
	}
	getLogoutHintFromIdTokenClaims(e) {
		let t = e.idTokenClaims;
		if (t) {
			if (t.login_hint) return this.logger.verbose("0u5bmc", this.correlationId), t.login_hint;
			this.logger.verbose("0mvp54", this.correlationId);
		} else this.logger.verbose("1e7bdp", this.correlationId);
		return null;
	}
	async createAuthCodeClient(e) {
		return new Za(await F(this.getClientConfiguration.bind(this), Go, this.logger, this.performanceClient, this.correlationId)(e), this.performanceClient);
	}
	async getClientConfiguration(e) {
		let { serverTelemetryManager: t, requestAuthority: n, requestAzureCloudOptions: r, requestExtraQueryParameters: i, account: a } = e, o = e.authority || await F(Eu, "standardInteractionClientGetDiscoveredAuthority", this.logger, this.performanceClient, this.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, n, r, i, a), s = this.config.system.loggerOptions;
		return {
			authOptions: {
				clientId: this.config.auth.clientId,
				authority: o,
				clientCapabilities: this.config.auth.clientCapabilities,
				redirectUri: this.config.auth.redirectUri,
				isMcp: this.config.auth.isMcp
			},
			systemOptions: {
				tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
				preventCorsPreflight: !0
			},
			loggerOptions: {
				loggerCallback: s.loggerCallback,
				piiLoggingEnabled: s.piiLoggingEnabled,
				logLevel: s.logLevel,
				correlationId: this.correlationId
			},
			cryptoInterface: this.browserCrypto,
			networkInterface: this.networkClient,
			storageInterface: this.browserStorage,
			serverTelemetryManager: t,
			libraryInfo: {
				sku: z.MSAL_SKU,
				version: pu,
				cpu: "",
				os: ""
			},
			telemetry: this.config.telemetry
		};
	}
};
async function Mu(e, t, n, r, i, a, o, s) {
	let c = Tu(e.redirectUri, n.auth.redirectUri, a, s);
	new URL(c).origin !== new URL(window.location.href).origin && (a.warning("08qbvw", s), o.addFields({ isRedirectUriCrossOrigin: !0 }, s));
	let l = { interactionType: t }, u = Oa(r, e && e.state || "", l), d = {
		...await F(Ou, Lo, a, o, s)({
			...e,
			correlationId: s
		}, n, o, a, s),
		redirectUri: c,
		state: u,
		nonce: e.nonce || Zc(),
		responseMode: n.auth.OIDCOptions.responseMode
	}, f = {
		...d,
		httpMethod: Au(d, n.system.protocolMode)
	};
	if (e.loginHint || e.sid) return f;
	let p = e.account || i.getActiveAccount(s);
	return p && (a.verbose("1eqlb3", s), a.verbosePii("0tf99t", s), f.account = p), f;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/utils/BrowserProtocolUtils.mjs
function Nu(e, t) {
	if (!t) return null;
	try {
		return Aa(e.base64Decode, t).libraryState.meta;
	} catch {
		throw T(sn);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/response/ResponseHandler.mjs
function Pu(e, t, n, r) {
	let i = br(e);
	if (!i) throw yr(e) ? (n.error("13pl0s", r), n.errorPii("1097vx", r), R(Ks)) : (n.error("18h0l1", r), R(Ws));
	return i;
}
function Fu(e, t, n) {
	if (!e.state) throw R(Gs);
	let r = Nu(t, e.state);
	if (!r) throw R(qs);
	if (r.interactionType !== n) throw R(Js);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_handler/InteractionHandler.mjs
var Iu = class {
	constructor(e, t, n, r, i) {
		this.authModule = e, this.browserStorage = t, this.authCodeRequest = n, this.logger = r, this.performanceClient = i;
	}
	async handleCodeResponse(e, t, n) {
		let r;
		try {
			r = io(e, t.state);
		} catch (e) {
			throw e instanceof Da && e.subError === "user_cancelled" ? R($s) : e;
		}
		return F(this.handleCodeResponseFromServer.bind(this), ea, this.logger, this.performanceClient, t.correlationId)(r, t, n);
	}
	async handleCodeResponseFromServer(e, t, n, r = !0) {
		if (this.logger.trace("0mf2hb", t.correlationId), this.authCodeRequest.code = e.code, r && (e.nonce = t.nonce || void 0), e.state = t.state, e.client_info) this.authCodeRequest.clientInfo = e.client_info;
		else {
			let e = this.createCcsCredentials(t);
			e && (this.authCodeRequest.ccsCredential = e);
		}
		return await F(this.authModule.acquireToken.bind(this.authModule), $o, this.logger, this.performanceClient, t.correlationId)(this.authCodeRequest, n, e);
	}
	createCcsCredentials(e) {
		return e.account ? {
			credential: e.account.homeAccountId,
			type: L.HOME_ACCOUNT_ID
		} : e.loginHint ? {
			credential: e.loginHint,
			type: L.UPN
		} : null;
	}
}, Lu = "ContentError", Ru = "PageException", zu = "user_switch", Bu = "USER_INTERACTION_REQUIRED", Vu = "USER_CANCEL", Hu = "NO_NETWORK", Uu = "ACCOUNT_UNAVAILABLE", Wu = "UX_NOT_ALLOWED", Gu = -2147186943, Ku = class e extends S {
	constructor(t, n, r) {
		super(t, n || Ss(t)), Object.setPrototypeOf(this, e.prototype), this.name = "NativeAuthError", this.ext = r;
	}
};
function qu(e) {
	if (e.ext && e.ext.status && e.ext.status === "DISABLED" || e.ext && e.ext.error && e.ext.error === Gu) return !0;
	switch (e.errorCode) {
		case Lu:
		case Ru: return !0;
		default: return !1;
	}
}
function Ju(e, t, n) {
	if (n && n.status) switch (n.status) {
		case Uu: return Ea(ba, Ss(e));
		case Bu: return new I(e, t);
		case Vu: return R($s);
		case Hu: return R(uc);
		case Wu: return Ea(Sa);
	}
	return new Ku(e, t, n);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_client/SilentCacheClient.mjs
var Yu = class extends ju {
	async acquireToken(e) {
		let t = $(U.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger), n = new eo(await F(this.getClientConfiguration.bind(this), Go, this.logger, this.performanceClient, this.correlationId)({
			serverTelemetryManager: t,
			requestAuthority: e.authority,
			requestAzureCloudOptions: e.azureCloudOptions,
			account: e.account
		}), this.performanceClient);
		this.logger.verbose("0wa871", this.correlationId);
		try {
			let t = (await F(n.acquireCachedToken.bind(n), qo, this.logger, this.performanceClient, e.correlationId)(e))[0];
			return this.performanceClient.addFields({ fromCache: !0 }, e.correlationId), t;
		} catch (e) {
			throw e instanceof Cs && e.errorCode === "crypto_key_not_found" && this.logger.verbose("06wena", this.correlationId), e;
		}
	}
	logout(e) {
		this.logger.verbose("1rkurh", this.correlationId);
		let t = this.initializeLogoutRequest(e);
		return Du(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, t.account);
	}
}, Xu = class extends wu {
	constructor(e, t, n, r, i, a, o, s, c, l, u, d) {
		super(e, t, n, r, i, a, s, d, c), this.apiId = o, this.accountId = l, this.platformAuthProvider = c, this.nativeStorageManager = u, this.silentCacheClient = new Yu(e, this.nativeStorageManager, n, r, i, a, s, d, c);
		let f = this.platformAuthProvider.getExtensionName();
		this.skus = _o.makeExtraSkuString({
			libraryName: z.MSAL_SKU,
			libraryVersion: pu,
			extensionName: f,
			extensionVersion: this.platformAuthProvider.getExtensionVersion()
		});
	}
	addRequestSKUs(e) {
		e.extraParameters = {
			...e.extraParameters,
			[bt]: this.skus
		};
	}
	async acquireToken(e, t) {
		this.logger.trace("03qeos", this.correlationId);
		let n = this.performanceClient.startMeasurement(No, this.correlationId), r = N(), i = $(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger);
		try {
			let a = await this.initializePlatformRequest(e);
			try {
				let e = await this.acquireTokensFromCache(this.accountId, a);
				return n.end({
					success: !0,
					isNativeBroker: !1,
					fromCache: !0
				}), e;
			} catch (e) {
				if (t === K.AccessToken) throw this.logger.info("0eitbc", this.correlationId), n.end({
					success: !1,
					brokerErrorCode: "cache_request_failed"
				}), e;
				this.logger.info("0957j1", this.correlationId);
			}
			let o = await this.platformAuthProvider.sendMessage(a);
			return await this.handleNativeResponse(o, a, r).then((e) => (n.end({
				success: !0,
				isNativeBroker: !0,
				requestId: e.requestId
			}), i.clearNativeBrokerErrorCode(), e)).catch((e) => {
				throw n.end({
					success: !1,
					errorCode: e.errorCode,
					subErrorCode: e.subError
				}), e;
			});
		} catch (e) {
			throw e instanceof Ku && i.setNativeBrokerErrorCode(e.errorCode), n.end({ success: !1 }), e;
		}
	}
	createSilentCacheRequest(e, t) {
		return {
			authority: e.authority,
			correlationId: this.correlationId,
			scopes: D.fromString(e.scope).asArray(),
			account: t,
			forceRefresh: !1
		};
	}
	async acquireTokensFromCache(e, t) {
		if (!e) throw this.logger.warning("1ndf3e", this.correlationId), T(xn);
		let n = this.browserStorage.getBaseAccountInfo({ nativeAccountId: e }, this.correlationId);
		if (!n) throw T(xn);
		try {
			let e = this.createSilentCacheRequest(t, n), r = await this.silentCacheClient.acquireToken(e), i = this.browserStorage.getIdToken(n, this.correlationId, this.browserStorage.getTokenKeys(), n.tenantId), a = Lr(i?.secret || "", q), o = Ir(n, void 0, a, i?.secret);
			return {
				...r,
				idToken: i?.secret || "",
				idTokenClaims: a,
				account: o
			};
		} catch (e) {
			throw e;
		}
	}
	async acquireTokenRedirect(e, t, n) {
		this.logger.trace("0luikq", this.correlationId);
		let r = await this.initializePlatformRequest(e), i = n?.navigateToLoginRequestUrl ?? !0;
		try {
			await this.platformAuthProvider.sendMessage(r);
		} catch (e) {
			if (e instanceof Ku && ($(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger).setNativeBrokerErrorCode(e.errorCode), qu(e))) throw e;
		}
		this.browserStorage.setTemporaryCache(H.NATIVE_REQUEST, JSON.stringify(r), !0);
		let a = {
			apiId: U.acquireTokenRedirect,
			timeout: this.config.system.redirectNavigationTimeout,
			noHistory: !1
		}, o = i ? window.location.href : Tu(e.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
		t.end({ success: !0 }), await this.navigationClient.navigateExternal(o, a);
	}
	async handleRedirectPromise() {
		if (this.logger.trace("1c5lhw", this.correlationId), !this.browserStorage.isInteractionInProgress(!0)) return this.logger.info("0le6uv", this.correlationId), null;
		let e = this.browserStorage.getCachedNativeRequest();
		if (!e) return this.logger.verbose("0a6zjb", this.correlationId), this.performanceClient?.addFields({ errorCode: "no_cached_request" }, this.correlationId), null;
		let { prompt: t, ...n } = e;
		t && this.logger.verbose("0ac34v", this.correlationId), this.browserStorage.removeItem(this.browserStorage.generateCacheKey(H.NATIVE_REQUEST));
		let r = N();
		try {
			this.logger.verbose("003x5a", this.correlationId);
			let e = await this.platformAuthProvider.sendMessage(n), t = await this.handleNativeResponse(e, n, r);
			return $(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger).clearNativeBrokerErrorCode(), this.performanceClient?.addFields({ isNativeBroker: !0 }, this.correlationId), t;
		} catch (e) {
			throw e;
		}
	}
	logout() {
		return this.logger.trace("0u2sjm", this.correlationId), Promise.reject("Logout not implemented yet");
	}
	async handleNativeResponse(e, t, n) {
		this.logger.trace("1bojln", this.correlationId);
		let r = Lr(e.id_token, q), i = this.createHomeAccountIdentifier(e, r), a = this.browserStorage.getAccountInfoFilteredBy({ nativeAccountId: t.accountId }, this.correlationId)?.homeAccountId;
		if (t.extraParameters?.child_client_id && e.account.id !== t.accountId) this.logger.info("1ub1in", this.correlationId);
		else if (i !== a && e.account.id !== t.accountId) throw Ju(zu);
		let o = await Eu(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, t.authority), s = Ma(this.browserStorage, o, i, q, this.correlationId, r, e.client_info, o.getPreferredCache(), r.tid, void 0, e.account.id, this.logger, this.performanceClient);
		e.expires_in = Number(e.expires_in);
		let c = await this.generateAuthenticationResult(e, t, r, s, o.canonicalAuthority, n);
		return await this.cacheAccount(s, Rr(r)), await this.cacheNativeTokens(e, t, i, r, c.tenantId, n, o.getPreferredCache()), c;
	}
	createHomeAccountIdentifier(e, t) {
		return si(e.client_info || "", j.Default, this.logger, this.browserCrypto, this.correlationId, t);
	}
	generateScopes(e, t) {
		return t ? D.fromString(t) : D.fromString(e);
	}
	async generatePopAccessToken(e, t) {
		if (t.tokenType === x.POP && t.signPopToken) {
			if (e.shr) return this.logger.trace("0coqhu", this.correlationId), e.shr;
			let n = new va(this.browserCrypto, this.performanceClient), r = {
				resourceRequestMethod: t.resourceRequestMethod,
				resourceRequestUri: t.resourceRequestUri,
				shrClaims: t.shrClaims,
				shrNonce: t.shrNonce,
				correlationId: this.correlationId
			};
			if (!t.keyId) throw T(On);
			return n.signPopToken(e.access_token, t.keyId, r);
		} else return e.access_token;
	}
	async generateAuthenticationResult(e, t, n, r, i, a) {
		let o = this.addTelemetryFromNativeResponse(e.properties.MATS), s = this.generateScopes(t.scope, e.scope), c = e.account.properties || {}, l = c.UID || n.oid || n.sub || "", u = c.TenantId || n.tid || "", d = Ir(ii(r), void 0, n, e.id_token);
		d.nativeAccountId !== e.account.id && (d.nativeAccountId = e.account.id);
		let f = await this.generatePopAccessToken(e, t), p = t.tokenType === x.POP ? x.POP : x.BEARER;
		return {
			authority: i,
			uniqueId: l,
			tenantId: u,
			scopes: s.asArray(),
			account: d,
			idToken: e.id_token,
			idTokenClaims: n,
			accessToken: f,
			fromCache: o ? this.isResponseFromCache(o) : !1,
			expiresOn: Ti(a + e.expires_in),
			tokenType: p,
			correlationId: this.correlationId,
			state: e.state,
			fromPlatformBroker: !0,
			...t.resource && { resource: t.resource }
		};
	}
	async cacheAccount(e, t) {
		await this.browserStorage.setAccount(e, this.correlationId, t, this.apiId), this.browserStorage.removeAccountContext(ii(e), this.correlationId);
	}
	async cacheNativeTokens(e, t, n, r, i, a, o) {
		let s = ki(n, o, e.id_token || "", t.clientId, r.tid || ""), c = a + (t.tokenType === x.POP ? 240 : (typeof e.expires_in == "string" ? parseInt(e.expires_in, 10) : e.expires_in) || 0), l = this.generateScopes(e.scope, t.scope), u = Ai(n, o, e.access_token, t.clientId, r.tid || i, l.printScopes(), c, 0, q, void 0, t.tokenType, void 0, t.keyId);
		s && t.storeInCache?.idToken !== !1 && await this.browserStorage.setIdTokenCredential(s, this.correlationId, Rr(r));
		let d = { accessToken: u };
		return this.nativeStorageManager.saveCacheRecord(d, this.correlationId, Rr(r), this.apiId, t.storeInCache);
	}
	getExpiresInValue(e, t) {
		return e === x.POP ? 240 : (typeof t == "string" ? parseInt(t, 10) : t) || 0;
	}
	addTelemetryFromNativeResponse(e) {
		let t = this.getMATSFromResponse(e);
		return t ? (this.performanceClient.addFields({
			extensionId: this.platformAuthProvider.getExtensionId(),
			extensionVersion: this.platformAuthProvider.getExtensionVersion(),
			matsBrokerVersion: t.broker_version,
			matsAccountJoinOnStart: t.account_join_on_start,
			matsAccountJoinOnEnd: t.account_join_on_end,
			matsDeviceJoin: t.device_join,
			matsPromptBehavior: t.prompt_behavior,
			matsApiErrorCode: t.api_error_code,
			matsUiVisible: t.ui_visible,
			matsSilentCode: t.silent_code,
			matsSilentBiSubCode: t.silent_bi_sub_code,
			matsSilentMessage: t.silent_message,
			matsSilentStatus: t.silent_status,
			matsHttpStatus: t.http_status,
			matsHttpEventCount: t.http_event_count
		}, this.correlationId), t) : null;
	}
	getMATSFromResponse(e) {
		if (e) try {
			return JSON.parse(e);
		} catch {
			this.logger.error("0b3l57", this.correlationId);
		}
		return null;
	}
	isResponseFromCache(e) {
		return e.is_cached === void 0 ? (this.logger.verbose("1okqev", this.correlationId), !1) : !!e.is_cached;
	}
	async initializePlatformRequest(e) {
		this.logger.trace("1xdm2a", this.correlationId);
		let t = await this.getCanonicalAuthority(e), n = e.skipBrokerClaims && e.embeddedClientId ? void 0 : this.config.auth.clientCapabilities, { scopes: r, claims: i, ...a } = e, o = new D(r || []);
		o.appendScopes(pe);
		let s = n && n.length ? lr(i, n) : i, c = {
			...a,
			claims: s,
			accountId: this.accountId,
			clientId: this.config.auth.clientId,
			authority: t.urlString,
			scope: o.printScopes(),
			redirectUri: Tu(e.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId),
			prompt: this.getPrompt(e.prompt),
			correlationId: this.correlationId,
			tokenType: e.authenticationScheme,
			windowTitleSubstring: document.title,
			extraParameters: { ...e.extraParameters },
			extendedExpiryToken: !1,
			keyId: e.popKid
		};
		if (c.signPopToken && e.popKid) throw R(Ec);
		if (this.handleExtraBrokerParams(c), c.extraParameters = c.extraParameters || {}, c.extraParameters.telemetry = B.MATS_TELEMETRY, e.authenticationScheme === x.POP) {
			let t = {
				resourceRequestUri: e.resourceRequestUri,
				resourceRequestMethod: e.resourceRequestMethod,
				shrClaims: e.shrClaims,
				shrNonce: e.shrNonce,
				correlationId: this.correlationId
			}, n = new va(this.browserCrypto, this.performanceClient), r;
			if (c.keyId) r = this.browserCrypto.base64UrlEncode(JSON.stringify({ kid: c.keyId })), c.signPopToken = !1;
			else {
				let e = await F(n.generateCnf.bind(n), ia, this.logger, this.performanceClient, this.correlationId)(t, this.logger);
				r = e.reqCnfString, c.keyId = e.kid, c.signPopToken = !0;
			}
			c.reqCnf = r;
		}
		return this.addRequestSKUs(c), c;
	}
	async getCanonicalAuthority(e) {
		let t = e.authority || this.config.auth.authority, { azureCloudOptions: n, account: r } = e;
		r && await Eu(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, t, n, void 0, r);
		let i = new A(t);
		return i.validateAsUri(), i;
	}
	getPrompt(e) {
		switch (this.apiId) {
			case U.ssoSilent:
			case U.acquireTokenSilent_silentFlow: return this.logger.trace("12n1y2", this.correlationId), v.NONE;
		}
		if (!e) {
			this.logger.trace("0uid1p", this.correlationId);
			return;
		}
		switch (e) {
			case v.NONE:
			case v.CONSENT:
			case v.LOGIN: return this.logger.trace("0i0hco", this.correlationId), e;
			default: throw this.logger.trace("0w3tpw", this.correlationId), R(wc);
		}
	}
	handleExtraBrokerParams(e) {
		let t = e.extraParameters && e.extraParameters.hasOwnProperty("brk_client_id") && e.extraParameters.hasOwnProperty("brk_redirect_uri") && e.extraParameters.hasOwnProperty("client_id");
		if (!e.embeddedClientId && !t) return;
		let n = "", r = e.redirectUri;
		e.embeddedClientId ? (e.redirectUri = this.config.auth.redirectUri, n = e.embeddedClientId) : e.extraParameters && (e.redirectUri = e.extraParameters[St], n = e.extraParameters[Le]), e.extraParameters = {
			child_client_id: n,
			child_redirect_uri: r
		}, this.performanceClient?.addFields({
			embeddedClientId: n,
			embeddedRedirectUri: r
		}, this.correlationId);
	}
}, Zu = /* @__PURE__ */ new Map([["e", "AAD"], ["m", "MSA"]]);
function Qu(e) {
	if (!e) return null;
	try {
		let t = (/%(?:[0-9A-Fa-f]{2})/.test(e) ? decodeURIComponent(e) : e).split("|");
		return t.length < 5 ? null : {
			accountType: Zu.get(t[0]?.trim() || "") || "",
			error: t[1]?.trim() || "",
			subError: t[2]?.trim() || "",
			cloudInstance: t[3]?.trim() || "",
			callerDataBoundary: t[4]?.trim() || ""
		};
	} catch {
		return null;
	}
}
function $u(e, t, n) {
	let r = Qu(e.clientdata);
	r?.accountType && n.addFields({ accountType: r.accountType }, t), r?.error && n.addFields({ serverErrorNo: r.error }, t), r?.subError && n.addFields({ serverSubErrorNo: r.subError }, t);
}
async function ed(e, t, n, r, i) {
	let a = no({
		...e.auth,
		authority: t
	}, n, r, i);
	if (qn(a, {
		sku: z.MSAL_SKU,
		version: pu,
		os: "",
		cpu: ""
	}), e.system.protocolMode !== M.OIDC && Jn(a, e.telemetry.application), n.platformBroker && (Pn(a), i.addFields({ isPlatformAuthorizeRequest: !0 }, n.correlationId), n.authenticationScheme === x.POP)) {
		let e = new Il(r, i), t = new va(e, i), o;
		o = n.popKid ? e.encodeKid(n.popKid) : (await F(t.generateCnf.bind(t), ia, r, i, n.correlationId)(n, r)).reqCnfString, ur(a, o);
	}
	return jn(a, n.correlationId, i), a;
}
async function td(e, t, n, r, i) {
	if (!n.codeChallenge) throw C(Bt);
	let a = await F(ed, Jo, r, i, n.correlationId)(e, t, n, r, i);
	return Mn(a, ve.CODE), Qn(a, n.codeChallenge, ae), O(a, {
		...n.extraQueryParameters,
		...n.extraParameters
	}), ro(t, a);
}
async function nd(e, t, n, r, i, a) {
	if (!r.earJwk) throw R(Bs);
	let o = await ed(t, n, r, i, a);
	Mn(o, ve.IDTOKEN_TOKEN_REFRESHTOKEN), gr(o, r.earJwk), Qn(o, r.codeChallenge, ae), O(o, { ...r.extraParameters });
	let s = /* @__PURE__ */ new Map();
	return O(s, r.extraQueryParameters || {}), Kn(s, r.correlationId), id(e, ro(n, s), o);
}
async function rd(e, t, n, r, i, a) {
	let o = await ed(t, n, r, i, a);
	Mn(o, ve.CODE), Qn(o, r.codeChallenge, r.codeChallengeMethod || "S256"), O(o, { ...r.extraParameters });
	let s = /* @__PURE__ */ new Map();
	return O(s, r.extraQueryParameters || {}), Kn(s, r.correlationId), id(e, ro(n, s), o);
}
function id(e, t, n) {
	let r = e.createElement("form");
	return r.method = "post", r.action = t, n.forEach((t, n) => {
		let i = e.createElement("input");
		i.hidden = !0, i.name = n, i.value = t, r.appendChild(i);
	}), e.body.appendChild(r), r;
}
async function ad(e, t, n, r, i, a, o, s, c, l) {
	if (s.verbose("11qcow", e.correlationId), !l) throw R(Sc);
	let u = new Il(s, c), d = new Xu(r, i, u, s, o, r.system.navigationClient, n, c, l, t, a, e.correlationId), { userRequestState: f } = Aa(u.base64Decode, e.state);
	return F(d.acquireToken.bind(d), No, s, c, e.correlationId)({
		...e,
		state: f,
		prompt: void 0
	});
}
async function od(e, t, n, r, i, a, o, s, c, l, u, d) {
	if (Fa.removeThrottle(o, i.auth.clientId, e), $u(t, e.correlationId, u), t.accountId) return F(ad, Zo, l, u, e.correlationId)(e, t.accountId, r, i, o, s, c, l, u, d);
	let f = new Iu(a, o, {
		...e,
		code: t.code || "",
		codeVerifier: n
	}, l, u);
	return await F(f.handleCodeResponse.bind(f), Yo, l, u, e.correlationId)(t, e, r);
}
async function sd(e, t, n, r, i, a, o, s, c, l, u) {
	if (Fa.removeThrottle(a, r.auth.clientId, e), $u(t, e.correlationId, l), ao(t, e.state), !t.ear_jwe) throw R(Vs);
	if (!e.earJwk) throw R(Bs);
	let d = JSON.parse(await F(il, bs, c, l, e.correlationId)(e.earJwk, t.ear_jwe));
	if (d.accountId) return F(ad, Zo, c, l, e.correlationId)(e, d.accountId, n, r, a, o, s, c, l, u);
	let f = new ja(r.auth.clientId, a, new Il(c, l), c, l, null, null);
	f.validateTokenResponse(d, e.correlationId);
	let p = {
		code: "",
		state: e.state,
		nonce: e.nonce,
		client_info: d.client_info,
		cloud_graph_host_name: d.cloud_graph_host_name,
		cloud_instance_host_name: d.cloud_instance_host_name,
		cloud_instance_name: d.cloud_instance_name,
		msgraph_host: d.msgraph_host
	};
	return await F(f.handleServerTokenResponse.bind(f), aa, c, l, e.correlationId)(d, i, N(), e, n, p, void 0, void 0, void 0, void 0);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/crypto/PkceGenerator.mjs
var cd = 32;
async function ld(e, t, n) {
	let r = P(ud, ls, t, e, n)(e, t, n);
	return {
		verifier: r,
		challenge: await F(dd, us, t, e, n)(r, e, t, n)
	};
}
function ud(e, t, n) {
	try {
		let r = new Uint8Array(cd);
		return P(Yc, fs, t, e, n)(r), Is(r);
	} catch {
		throw R(zs);
	}
}
async function dd(e, t, n, r) {
	try {
		let i = await F(Jc, ds, n, t, r)(e);
		return Is(new Uint8Array(i));
	} catch {
		throw R(zs);
	}
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/navigation/NavigationClient.mjs
var fd = class e {
	navigateInternal(t, n) {
		return e.defaultNavigateWindow(t, n);
	}
	navigateExternal(t, n) {
		return e.defaultNavigateWindow(t, n);
	}
	static defaultNavigateWindow(e, t) {
		return t.noHistory ? window.location.replace(e) : window.location.assign(e), new Promise((e, n) => {
			setTimeout(() => {
				n(R(Ac, "failed_to_redirect"));
			}, t.timeout);
		});
	}
}, pd = class {
	async sendGetRequestAsync(e, t) {
		let n, r = {}, i = 0, a = md(t);
		try {
			n = await fetch(e, {
				method: Ts.GET,
				headers: a
			});
		} catch (e) {
			throw La(R(window.navigator.onLine ? fc : uc), void 0, void 0, e);
		}
		r = hd(n.headers);
		try {
			return i = n.status, {
				headers: r,
				body: await n.json(),
				status: i
			};
		} catch (e) {
			throw La(R(pc), i, r, e);
		}
	}
	async sendPostRequestAsync(e, t) {
		let n = t && t.body || "", r = md(t), i, a = 0, o = {};
		try {
			i = await fetch(e, {
				method: Ts.POST,
				headers: r,
				body: n
			});
		} catch (e) {
			throw La(R(window.navigator.onLine ? dc : uc), void 0, void 0, e);
		}
		o = hd(i.headers);
		try {
			return a = i.status, {
				headers: o,
				body: await i.json(),
				status: a
			};
		} catch (e) {
			throw La(R(pc), a, o, e);
		}
	}
};
function md(e) {
	try {
		let t = new Headers();
		if (!(e && e.headers)) return t;
		let n = e.headers;
		return Object.entries(n).forEach(([e, n]) => {
			t.append(e, n);
		}), t;
	} catch (e) {
		throw La(R(Dc), void 0, void 0, e);
	}
}
function hd(e) {
	try {
		let t = {};
		return e.forEach((e, n) => {
			t[n] = e;
		}), t;
	} catch {
		throw R(Oc);
	}
}
var gd = 3e4;
function _d({ auth: e, cache: t, system: n, experimental: r, telemetry: i }, a) {
	let o = {
		clientId: "",
		authority: `${u}`,
		knownAuthorities: [],
		cloudDiscoveryMetadata: "",
		authorityMetadata: "",
		redirectUri: typeof window < "u" && window.location ? window.location.href.split("?")[0].split("#")[0] : "",
		postLogoutRedirectUri: "",
		clientCapabilities: [],
		OIDCOptions: {
			responseMode: ye.FRAGMENT,
			defaultScopes: [
				te,
				ne,
				re
			]
		},
		azureCloudOptions: {
			azureCloudInstance: Nr.None,
			tenant: ""
		},
		instanceAware: !1,
		isMcp: !1,
		verifySSO: !1
	}, s = {
		cacheLocation: V.SessionStorage,
		cacheRetentionDays: 5
	}, c = {
		loggerCallback: () => {},
		logLevel: k.Info,
		piiLoggingEnabled: !1
	}, l = {
		...pi,
		loggerOptions: c,
		networkClient: a ? new pd() : to,
		navigationClient: new fd(),
		popupBridgeTimeout: n?.popupBridgeTimeout || 6e4,
		iframeBridgeTimeout: n?.iframeBridgeTimeout || 1e4,
		redirectNavigationTimeout: gd,
		allowRedirectInIframe: !1,
		navigatePopups: !0,
		allowPlatformBroker: !1,
		nativeBrokerHandshakeTimeout: n?.nativeBrokerHandshakeTimeout || 2e3,
		protocolMode: M.AAD,
		...n,
		loggerOptions: n?.loggerOptions || c
	}, d = {
		application: {
			appName: "",
			appVersion: ""
		},
		client: new fi()
	}, f = {
		iframeTimeoutTelemetry: !1,
		allowPlatformBrokerWithDOM: !1
	};
	if (n?.protocolMode !== M.OIDC && e?.OIDCOptions && new Ar(l.loggerOptions).warning(JSON.stringify(C(Kt)), ""), n?.protocolMode && n.protocolMode === M.OIDC && l?.allowPlatformBroker) throw C(qt);
	return {
		auth: {
			...o,
			...e,
			OIDCOptions: {
				...o.OIDCOptions,
				...e?.OIDCOptions
			}
		},
		cache: {
			...s,
			...t
		},
		system: l,
		experimental: {
			...f,
			...r
		},
		telemetry: {
			...d,
			...i
		}
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/broker/nativeBroker/PlatformAuthExtensionHandler.mjs
var vd = class e {
	constructor(e, t, n, r) {
		this.logger = e, this.handshakeTimeoutMs = t, this.extensionId = r, this.resolvers = /* @__PURE__ */ new Map(), this.handshakeResolvers = /* @__PURE__ */ new Map(), this.messageChannel = new MessageChannel(), this.windowListener = this.onWindowMessage.bind(this), this.performanceClient = n, this.handshakeEvent = this.performanceClient.startMeasurement(as), this.platformAuthType = B.PLATFORM_EXTENSION_PROVIDER;
	}
	async sendMessage(e) {
		this.logger.trace("0on4p2", e.correlationId);
		let t = {
			method: ws.GetToken,
			request: e
		}, n = {
			channel: B.CHANNEL_ID,
			extensionId: this.extensionId,
			responseId: Zc(),
			body: t
		};
		this.logger.trace("1qadfi", e.correlationId), this.logger.tracePii("1xm533", e.correlationId), this.messageChannel.port1.postMessage(n);
		let r = await new Promise((e, t) => {
			this.resolvers.set(n.responseId, {
				resolve: e,
				reject: t
			});
		});
		return this.validatePlatformBrokerResponse(r);
	}
	static async createProvider(t, n, r, i) {
		t.trace("15zfnw", i);
		try {
			let a = new e(t, n, r, B.PREFERRED_EXTENSION_ID);
			return await a.sendHandshakeRequest(i), a;
		} catch {
			let a = new e(t, n, r);
			return await a.sendHandshakeRequest(i), a;
		}
	}
	async sendHandshakeRequest(e) {
		this.logger.trace("1dpg9o", e), window.addEventListener("message", this.windowListener, !1);
		let t = {
			channel: B.CHANNEL_ID,
			extensionId: this.extensionId,
			responseId: Zc(),
			body: { method: ws.HandshakeRequest }
		};
		return this.handshakeEvent.add({
			extensionId: this.extensionId,
			extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
		}), this.messageChannel.port1.onmessage = (e) => {
			this.onChannelMessage(e);
		}, window.postMessage(t, window.origin, [this.messageChannel.port2]), new Promise((e, n) => {
			this.handshakeResolvers.set(t.responseId, {
				resolve: e,
				reject: n
			}), this.timeoutId = window.setTimeout(() => {
				window.removeEventListener("message", this.windowListener, !1), this.messageChannel.port1.close(), this.messageChannel.port2.close(), this.handshakeEvent.end({
					extensionHandshakeTimedOut: !0,
					success: !1
				}), n(R(bc)), this.handshakeResolvers.delete(t.responseId);
			}, this.handshakeTimeoutMs);
		});
	}
	onWindowMessage(e) {
		let t = Ml();
		if (this.logger.trace("0jpn5u", t), e.source !== window) return;
		let n = e.data;
		if (!(!n.channel || n.channel !== B.CHANNEL_ID) && !(n.extensionId && n.extensionId !== this.extensionId) && n.body.method === ws.HandshakeRequest) {
			let e = this.handshakeResolvers.get(n.responseId);
			if (!e) {
				this.logger.trace("07buhm", t);
				return;
			}
			this.logger.verbose(n.extensionId ? "0xrkug" : "No extension installed", t), clearTimeout(this.timeoutId), this.messageChannel.port1.close(), this.messageChannel.port2.close(), window.removeEventListener("message", this.windowListener, !1), this.handshakeEvent.end({
				success: !1,
				extensionInstalled: !1
			}), e.reject(R(xc));
		}
	}
	onChannelMessage(e) {
		let t = Ml();
		this.logger.trace("1py8yf", t);
		let n = e.data, r = this.resolvers.get(n.responseId), i = this.handshakeResolvers.get(n.responseId);
		try {
			let e = n.body.method;
			if (e === ws.Response) {
				if (!r) return;
				let e = n.body.response;
				if (this.logger.trace("19hpgm", t), this.logger.tracePii("179a24", t), e.status !== "Success") r.reject(Ju(e.code, e.description, e.ext));
				else if (e.result) e.result.code && e.result.description ? r.reject(Ju(e.result.code, e.result.description, e.result.ext)) : r.resolve(e.result);
				else throw kt(fo, "Event does not contain result.");
				this.resolvers.delete(n.responseId);
			} else if (e === ws.HandshakeResponse) {
				if (!i) {
					this.logger.trace("082qnt", t);
					return;
				}
				clearTimeout(this.timeoutId), window.removeEventListener("message", this.windowListener, !1), this.extensionId = n.extensionId, this.extensionVersion = n.body.version, this.logger.verbose("0yf5ib", t), this.handshakeEvent.end({
					extensionInstalled: !0,
					success: !0
				}), i.resolve(), this.handshakeResolvers.delete(n.responseId);
			}
		} catch (e) {
			this.logger.error("0xf978", t), this.logger.errorPii("04i99o", t), this.logger.errorPii("0xdvsy", t), r ? r.reject(e) : i && i.reject(e);
		}
	}
	validatePlatformBrokerResponse(e) {
		if (e.hasOwnProperty("access_token") && e.hasOwnProperty("id_token") && e.hasOwnProperty("client_info") && e.hasOwnProperty("account") && e.hasOwnProperty("scope") && e.hasOwnProperty("expires_in")) return e;
		throw kt(fo, "Response missing expected properties.");
	}
	getExtensionId() {
		return this.extensionId;
	}
	getExtensionVersion() {
		return this.extensionVersion;
	}
	getExtensionName() {
		return this.getExtensionId() === B.PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : void 0;
	}
}, yd = class e {
	constructor(e, t, n) {
		this.logger = e, this.performanceClient = t, this.correlationId = n, this.platformAuthType = B.PLATFORM_DOM_PROVIDER;
	}
	static async createProvider(t, n, r) {
		if (t.trace("12mj4a", r), window.navigator?.platformAuthentication && (await window.navigator.platformAuthentication.getSupportedContracts(B.MICROSOFT_ENTRA_BROKERID))?.includes(B.PLATFORM_DOM_APIS)) return t.trace("1h5q1r", r), new e(t, n, r);
	}
	getExtensionId() {
		return B.MICROSOFT_ENTRA_BROKERID;
	}
	getExtensionVersion() {
		return "";
	}
	getExtensionName() {
		return B.DOM_API_NAME;
	}
	async sendMessage(e) {
		this.logger.trace("02bcil", e.correlationId);
		try {
			let t = this.initializePlatformDOMRequest(e), n = await window.navigator.platformAuthentication.executeGetToken(t);
			return this.validatePlatformBrokerResponse(n, e.correlationId);
		} catch (t) {
			throw this.logger.error("11im7g", e.correlationId), t;
		}
	}
	initializePlatformDOMRequest(e) {
		this.logger.trace("15d6yv", e.correlationId);
		let { accountId: t, clientId: n, authority: r, scope: i, redirectUri: a, correlationId: o, state: s, storeInCache: c, embeddedClientId: l, extraParameters: u, ...d } = e, f = this.getDOMExtraParams(d, o);
		return {
			accountId: t,
			brokerId: this.getExtensionId(),
			authority: r,
			clientId: n,
			correlationId: o || this.correlationId,
			extraParameters: {
				...u,
				...f
			},
			isSecurityTokenService: !1,
			redirectUri: a,
			scope: i,
			state: s,
			storeInCache: c,
			embeddedClientId: l
		};
	}
	validatePlatformBrokerResponse(e, t) {
		if (e.hasOwnProperty("isSuccess")) {
			if (e.hasOwnProperty("accessToken") && e.hasOwnProperty("idToken") && e.hasOwnProperty("clientInfo") && e.hasOwnProperty("account") && e.hasOwnProperty("scopes") && e.hasOwnProperty("expiresIn")) return this.logger.trace("0h4vei", t), this.convertToPlatformBrokerResponse(e, t);
			if (e.hasOwnProperty("error")) {
				let n = e;
				if (n.isSuccess === !1 && n.error && n.error.code) throw this.logger.trace("0g92vm", t), Ju(n.error.code, n.error.description, {
					error: parseInt(n.error.errorCode),
					protocol_error: n.error.protocolError,
					status: n.error.status,
					properties: n.error.properties
				});
			}
		}
		throw kt(fo, "Response missing expected properties.");
	}
	convertToPlatformBrokerResponse(e, t) {
		return this.logger.trace("14913t", t), {
			access_token: e.accessToken,
			id_token: e.idToken,
			client_info: e.clientInfo,
			account: e.account,
			expires_in: e.expiresIn,
			scope: e.scopes,
			state: e.state || "",
			properties: e.properties || {},
			extendedLifetimeToken: e.extendedLifetimeToken ?? !1,
			shr: e.proofOfPossessionPayload
		};
	}
	getDOMExtraParams(e, t) {
		try {
			let t = {};
			for (let [n, r] of Object.entries(e)) r && (typeof r == "object" ? t[n] = JSON.stringify(r) : t[n] = String(r));
			return t;
		} catch {
			return this.logger.error("0eu9o3", t), this.logger.errorPii("17rpl5", t), {};
		}
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/broker/nativeBroker/PlatformAuthProvider.mjs
async function bd(e, t, n, r, i) {
	e.trace("134j0v", n), e.trace("04c81g", n);
	let a;
	try {
		i && (a = await yd.createProvider(e, t, n)), a ||= (e.trace("0l3na8", n), await vd.createProvider(e, r || 2e3, t, n));
	} catch (t) {
		e.trace("0icbd7", t);
	}
	return a;
}
function xd(e, t, n, r, i) {
	if (t.trace("0uko3r", n), !e.system.allowPlatformBroker && e.experimental.allowPlatformBrokerWithDOM) throw C(Xt);
	if (!e.system.allowPlatformBroker) return t.trace("04hozs", n), !1;
	if (!r) return t.trace("0kvv1r", n), !1;
	if (i) switch (i) {
		case x.BEARER:
		case x.POP: return t.trace("18tev1", n), !0;
		default: return t.trace("1dd2nh", n), !1;
	}
	return !0;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_client/PopupClient.mjs
var Sd = class extends ju {
	constructor(e, t, n, r, i, a, o, s, c, l) {
		super(e, t, n, r, i, a, o, c, l), this.nativeStorage = s, this.eventHandler = i;
	}
	acquireToken(e, t) {
		let n;
		try {
			if (n = {
				popupName: this.generatePopupName(e.scopes || pe, e.authority || this.config.auth.authority),
				popupWindowAttributes: e.popupWindowAttributes || {},
				popupWindowParent: e.popupWindowParent ?? window
			}, this.performanceClient.addFields({ isAsyncPopup: !this.config.system.navigatePopups }, this.correlationId), this.config.system.navigatePopups) {
				let r = {
					...e,
					httpMethod: Au(e, this.config.system.protocolMode)
				};
				return this.logger.verbose("1f9ok3", this.correlationId), n.popup = this.openSizedPopup("about:blank", n), this.acquireTokenPopupAsync(r, n, t);
			} else return this.logger.verbose("162h4u", this.correlationId), this.acquireTokenPopupAsync(e, n, t);
		} catch (e) {
			return Promise.reject(e);
		}
	}
	logout(e) {
		try {
			this.logger.verbose("068rup", this.correlationId);
			let t = this.initializeLogoutRequest(e), n = {
				popupName: this.generateLogoutPopupName(t),
				popupWindowAttributes: e?.popupWindowAttributes || {},
				popupWindowParent: e?.popupWindowParent ?? window
			}, r = e && e.authority, i = e && e.mainWindowRedirectUri;
			return this.config.system.navigatePopups ? (this.logger.verbose("1a28da", this.correlationId), n.popup = this.openSizedPopup("about:blank", n), this.logoutPopupAsync(t, n, r, i)) : (this.logger.verbose("1phd8u", this.correlationId), this.logoutPopupAsync(t, n, r, i));
		} catch (e) {
			return Promise.reject(e);
		}
	}
	async acquireTokenPopupAsync(e, t, n) {
		this.logger.verbose("1g77pg", this.correlationId);
		let r = await F(Mu, Ko, this.logger, this.performanceClient, this.correlationId)(e, W.Popup, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
		return t.popup && jl(r.authority), r.platformBroker = xd(this.config, this.logger, this.correlationId, this.platformAuthProvider, e.authenticationScheme), this.config.system.protocolMode === M.EAR ? this.executeEarFlow(r, t, n) : this.executeCodeFlow(r, t, n);
	}
	async executeCodeFlow(e, t, n) {
		let r = e.correlationId, i = $(U.acquireTokenPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger), a = n || await F(ld, "generatePkceCodes", this.logger, this.performanceClient, r)(this.performanceClient, this.logger, r), o = {
			...e,
			codeChallenge: a.challenge
		};
		try {
			let n = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, r)({
				serverTelemetryManager: i,
				requestAuthority: o.authority,
				requestAzureCloudOptions: o.azureCloudOptions,
				requestExtraQueryParameters: o.extraQueryParameters,
				account: o.account
			});
			if (o.httpMethod === fe.POST) return await this.executeCodeFlowWithPost(o, t, n, a.verifier);
			{
				let i = await F(td, $i, this.logger, this.performanceClient, r)(this.config, n.authority, o, this.logger, this.performanceClient), s = this.initiateAuthRequest(i, t);
				this.eventHandler.emitEvent(Q.POPUP_OPENED, r, W.Popup, { popupWindow: s }, null);
				let c = await xl(this.config.system.popupBridgeTimeout, this.logger, this.browserCrypto, e, this.performanceClient), l = P(Pu, es, this.logger, this.performanceClient, this.correlationId)(c, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
				return await F(od, Qo, this.logger, this.performanceClient, r)(e, l, a.verifier, U.acquireTokenPopup, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
			}
		} catch (e) {
			throw t.popup?.close(), e instanceof S && (e.setCorrelationId(this.correlationId), i.cacheFailedRequest(e)), e;
		}
	}
	async executeEarFlow(e, t, n) {
		let { correlationId: r, authority: i, azureCloudOptions: a, extraQueryParameters: o, account: s } = e, c = await F(Eu, Mo, this.logger, this.performanceClient, r)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, i, a, o, s), l = await F(nl, ys, this.logger, this.performanceClient, r)(), u = n || await F(ld, "generatePkceCodes", this.logger, this.performanceClient, r)(this.performanceClient, this.logger, r), d = {
			...e,
			earJwk: l,
			codeChallenge: u.challenge
		};
		(await nd((t.popup || this.openPopup("about:blank", t)).document, this.config, c, d, this.logger, this.performanceClient)).submit();
		let f = await F(xl, Ho, this.logger, this.performanceClient, r)(this.config.system.popupBridgeTimeout, this.logger, this.browserCrypto, d, this.performanceClient), p = P(Pu, es, this.logger, this.performanceClient, this.correlationId)(f, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
		if (!p.ear_jwe && p.code) {
			let t = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, r)({
				serverTelemetryManager: $(U.acquireTokenPopup, this.config.auth.clientId, r, this.browserStorage, this.logger),
				requestAuthority: e.authority,
				requestAzureCloudOptions: e.azureCloudOptions,
				requestExtraQueryParameters: e.extraQueryParameters,
				account: e.account,
				authority: c
			});
			return F(od, Qo, this.logger, this.performanceClient, r)(d, p, u.verifier, U.acquireTokenPopup, this.config, t, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
		} else return F(sd, Xo, this.logger, this.performanceClient, r)(d, p, U.acquireTokenPopup, this.config, c, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
	}
	async executeCodeFlowWithPost(e, t, n, r) {
		let i = e.correlationId, a = await F(Eu, Mo, this.logger, this.performanceClient, i)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
		(await rd((t.popup || this.openPopup("about:blank", t)).document, this.config, a, e, this.logger, this.performanceClient)).submit();
		let o = await F(xl, Ho, this.logger, this.performanceClient, i)(this.config.system.popupBridgeTimeout, this.logger, this.browserCrypto, e, this.performanceClient), s = P(Pu, es, this.logger, this.performanceClient, this.correlationId)(o, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
		return F(od, Qo, this.logger, this.performanceClient, i)(e, s, r, U.acquireTokenPopup, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
	}
	async logoutPopupAsync(e, t, n, r) {
		this.logger.verbose("0b7yrk", this.correlationId), this.eventHandler.emitEvent(Q.LOGOUT_START, this.correlationId, W.Popup, e);
		let i = $(U.logoutPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger);
		try {
			await Du(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, e.account);
			let a = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, this.correlationId)({
				serverTelemetryManager: i,
				requestAuthority: n,
				account: e.account || void 0
			});
			try {
				a.authority.endSessionEndpoint;
			} catch {
				if (e.account?.homeAccountId && e.postLogoutRedirectUri && a.authority.protocolMode === M.OIDC) {
					if (this.eventHandler.emitEvent(Q.LOGOUT_SUCCESS, e.correlationId, W.Popup, e), r) {
						let e = {
							apiId: U.logoutPopup,
							timeout: this.config.system.redirectNavigationTimeout,
							noHistory: !1
						}, t = A.getAbsoluteUrl(r, Sl());
						await this.navigationClient.navigateInternal(t, e);
					}
					t.popup?.close();
					return;
				}
			}
			e.state = Oa(this.browserCrypto, e.state || "", { interactionType: W.Popup });
			let o = a.getLogoutUri(e);
			this.eventHandler.emitEvent(Q.LOGOUT_SUCCESS, e.correlationId, W.Popup, e);
			let s = this.openPopup(o, t);
			if (this.eventHandler.emitEvent(Q.POPUP_OPENED, e.correlationId, W.Popup, { popupWindow: s }, null), await xl(this.config.system.popupBridgeTimeout, this.logger, this.browserCrypto, e, this.performanceClient).catch(() => {}), r) {
				let e = {
					apiId: U.logoutPopup,
					timeout: this.config.system.redirectNavigationTimeout,
					noHistory: !1
				}, t = A.getAbsoluteUrl(r, Sl());
				this.logger.verbose("0qcur2", this.correlationId), this.logger.verbosePii("0oj7lk", this.correlationId), await this.navigationClient.navigateInternal(t, e);
			} else this.logger.verbose("03zgcf", this.correlationId);
		} catch (e) {
			throw t.popup?.close(), e instanceof S && (e.setCorrelationId(this.correlationId), i.cacheFailedRequest(e)), this.eventHandler.emitEvent(Q.LOGOUT_FAILURE, this.correlationId, W.Popup, null, e), this.eventHandler.emitEvent(Q.LOGOUT_END, this.correlationId, W.Popup), e;
		}
		this.eventHandler.emitEvent(Q.LOGOUT_END, this.correlationId, W.Popup);
	}
	initiateAuthRequest(e, t) {
		if (e) return this.logger.infoPii("1kcr9k", this.correlationId), this.openPopup(e, t);
		throw this.logger.error("1l7hyp", this.correlationId), R(Us);
	}
	openPopup(e, t) {
		try {
			let n;
			if (t.popup ? (n = t.popup, this.logger.verbosePii("0cgeo7", this.correlationId), n.location.assign(e)) : t.popup === void 0 && (this.logger.verbosePii("0c2awd", this.correlationId), n = this.openSizedPopup(e, t)), !n) throw R(Qs);
			return n.focus && n.focus(), this.currentWindow = n, n;
		} catch {
			throw this.logger.error("0dxfb9", this.correlationId), R(Zs);
		}
	}
	openSizedPopup(e, { popupName: t, popupWindowAttributes: n, popupWindowParent: r }) {
		let i = r.screenLeft ? r.screenLeft : r.screenX, a = r.screenTop ? r.screenTop : r.screenY, o = r.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, s = r.innerHeight || document.documentElement.clientHeight || document.body.clientHeight, c = n.popupSize?.width, l = n.popupSize?.height, u = n.popupPosition?.top, d = n.popupPosition?.left;
		return (!c || c < 0 || c > o) && (this.logger.verbose("08vfmo", this.correlationId), c = z.POPUP_WIDTH), (!l || l < 0 || l > s) && (this.logger.verbose("09cxa0", this.correlationId), l = z.POPUP_HEIGHT), (!u || u < 0 || u > s) && (this.logger.verbose("1qh4wo", this.correlationId), u = Math.max(0, s / 2 - z.POPUP_HEIGHT / 2 + a)), (!d || d < 0 || d > o) && (this.logger.verbose("1sz3en", this.correlationId), d = Math.max(0, o / 2 - z.POPUP_WIDTH / 2 + i)), r.open(e, t, `width=${c}, height=${l}, top=${u}, left=${d}, scrollbars=yes`);
	}
	generatePopupName(e, t) {
		return `${z.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${e.join("-")}.${t}.${this.correlationId}`;
	}
	generateLogoutPopupName(e) {
		let t = e.account && e.account.homeAccountId;
		return `${z.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${t}.${this.correlationId}`;
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_client/RedirectClient.mjs
function Cd() {
	if (typeof window > "u" || window.performance === void 0 || typeof window.performance.getEntriesByType != "function") return;
	let e = window.performance.getEntriesByType("navigation");
	return (e.length ? e[0] : void 0)?.type;
}
var wd = class extends ju {
	constructor(e, t, n, r, i, a, o, s, c, l) {
		super(e, t, n, r, i, a, o, c, l), this.nativeStorage = s;
	}
	async acquireToken(e) {
		let t = await F(Mu, Ko, this.logger, this.performanceClient, this.correlationId)(e, W.Redirect, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
		t.platformBroker = xd(this.config, this.logger, this.correlationId, this.platformAuthProvider, e.authenticationScheme);
		let n = (e) => {
			e.persisted && (this.logger.verbose("0udvtt", this.correlationId), this.browserStorage.resetRequestCache(this.correlationId), this.eventHandler.emitEvent(Q.RESTORE_FROM_BFCACHE, this.correlationId, W.Redirect));
		}, r = this.getRedirectStartPage(e.redirectStartPage);
		this.logger.verbosePii("0zao0a", this.correlationId), this.browserStorage.setTemporaryCache(H.ORIGIN_URI, r, !0), window.addEventListener("pageshow", n);
		try {
			this.config.system.protocolMode === M.EAR ? await this.executeEarFlow(t) : await this.executeCodeFlow(t);
		} catch (e) {
			throw e instanceof S && e.setCorrelationId(this.correlationId), window.removeEventListener("pageshow", n), e;
		}
	}
	async executeCodeFlow(e) {
		let t = e.correlationId, n = $(U.acquireTokenRedirect, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger), r = await F(ld, cs, this.logger, this.performanceClient, t)(this.performanceClient, this.logger, t), i = {
			...e,
			codeChallenge: r.challenge
		};
		this.browserStorage.cacheAuthorizeRequest(i, this.correlationId, r.verifier);
		try {
			if (i.httpMethod === fe.POST) return await this.executeCodeFlowWithPost(i);
			{
				let t = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, this.correlationId)({
					serverTelemetryManager: n,
					requestAuthority: i.authority,
					requestAzureCloudOptions: i.azureCloudOptions,
					requestExtraQueryParameters: i.extraQueryParameters,
					account: i.account
				}), r = await F(td, $i, this.logger, this.performanceClient, e.correlationId)(this.config, t.authority, i, this.logger, this.performanceClient);
				return await this.initiateAuthRequest(r);
			}
		} catch (e) {
			throw e instanceof S && (e.setCorrelationId(this.correlationId), n.cacheFailedRequest(e)), e;
		}
	}
	async executeEarFlow(e) {
		let { correlationId: t, authority: n, azureCloudOptions: r, extraQueryParameters: i, account: a } = e, o = await F(Eu, Mo, this.logger, this.performanceClient, t)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, n, r, i, a), s = await F(nl, ys, this.logger, this.performanceClient, t)(), c = await F(ld, cs, this.logger, this.performanceClient, t)(this.performanceClient, this.logger, t), l = {
			...e,
			earJwk: s,
			codeChallenge: c.challenge
		};
		return this.browserStorage.cacheAuthorizeRequest(l, this.correlationId, c.verifier), (await nd(document, this.config, o, l, this.logger, this.performanceClient)).submit(), new Promise((e, t) => {
			setTimeout(() => {
				t(R(Ac, "failed_to_redirect"));
			}, this.config.system.redirectNavigationTimeout);
		});
	}
	async executeCodeFlowWithPost(e) {
		let t = e.correlationId, n = await F(Eu, Mo, this.logger, this.performanceClient, t)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
		return this.browserStorage.cacheAuthorizeRequest(e, this.correlationId), (await rd(document, this.config, n, e, this.logger, this.performanceClient)).submit(), new Promise((e, t) => {
			setTimeout(() => {
				t(R(Ac, "failed_to_redirect"));
			}, this.config.system.redirectNavigationTimeout);
		});
	}
	async handleRedirectPromise(e, t, n, r) {
		let i = $(U.handleRedirectPromise, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger), a = r?.navigateToLoginRequestUrl ?? !0;
		try {
			let [o, s] = this.getRedirectResponse(r?.hash || "");
			if (!o) return this.logger.info("1qmv0q", this.correlationId), this.browserStorage.resetRequestCache(this.correlationId), Cd() === "back_forward" ? this.logger.verbose("1eqegq", this.correlationId) : n.event.errorCode = "no_server_response", null;
			let c = this.browserStorage.getTemporaryCache(H.ORIGIN_URI, this.correlationId, !0) || "";
			if (Sr(c) === Sr(window.location.href) && a) return this.logger.verbose("11yred", this.correlationId), c.indexOf("#") > -1 && gl(c), await this.handleResponse(o, e, t, i);
			if (!a) return this.logger.verbose("0v4sdv", this.correlationId), await this.handleResponse(o, e, t, i);
			if (!_l() || this.config.system.allowRedirectInIframe) {
				this.browserStorage.setTemporaryCache(H.URL_HASH, s, !0);
				let n = {
					apiId: U.handleRedirectPromise,
					timeout: this.config.system.redirectNavigationTimeout,
					noHistory: !0
				}, r = !0;
				if (!c || c === "null") {
					let e = Cl();
					this.browserStorage.setTemporaryCache(H.ORIGIN_URI, e, !0), this.logger.warning("1dutq1", this.correlationId), r = await this.navigationClient.navigateInternal(e, n);
				} else this.logger.verbose("08jpy1", this.correlationId), r = await this.navigationClient.navigateInternal(c, n);
				if (!r) return await this.handleResponse(o, e, t, i);
			}
			return null;
		} catch (e) {
			throw e instanceof S && (e.setCorrelationId(this.correlationId), i.cacheFailedRequest(e)), e;
		}
	}
	getRedirectResponse(e) {
		this.logger.verbose("1c5i8m", this.correlationId);
		let t = e;
		t ||= this.config.auth.OIDCOptions.responseMode === ye.QUERY ? window.location.search : window.location.hash;
		let n = br(t);
		if (n) {
			try {
				Fu(n, this.browserCrypto, W.Redirect);
			} catch (e) {
				return e instanceof S && this.logger.error("0bkq6p", this.correlationId), [null, ""];
			}
			return hl(window), this.logger.verbose("00uvho", this.correlationId), [n, t];
		}
		let r = this.browserStorage.getTemporaryCache(H.URL_HASH, this.correlationId, !0);
		return this.browserStorage.removeItem(this.browserStorage.generateCacheKey(H.URL_HASH)), r && (n = br(r), n) ? (this.logger.verbose("001671", this.correlationId), [n, r]) : [null, ""];
	}
	async handleResponse(e, t, n, r) {
		if (!e.state) throw R(Gs);
		let { authority: i, azureCloudOptions: a, extraQueryParameters: o, account: s } = t;
		if (e.ear_jwe) {
			let n = await F(Eu, Mo, this.logger, this.performanceClient, t.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, i, a, o, s);
			return F(sd, Xo, this.logger, this.performanceClient, t.correlationId)(t, e, U.acquireTokenRedirect, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
		}
		let c = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, this.correlationId)({
			serverTelemetryManager: r,
			requestAuthority: t.authority
		});
		return F(od, Qo, this.logger, this.performanceClient, t.correlationId)(t, e, n, U.acquireTokenRedirect, this.config, c, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
	}
	async initiateAuthRequest(e) {
		if (this.logger.verbose("0yaw2e", this.correlationId), e) {
			this.logger.infoPii("1luf83", this.correlationId);
			let t = {
				apiId: U.acquireTokenRedirect,
				timeout: this.config.system.redirectNavigationTimeout,
				noHistory: !1
			}, n = this.config.auth.onRedirectNavigate;
			if (typeof n == "function") if (this.logger.verbose("1nehvl", this.correlationId), n(e) !== !1) {
				this.logger.verbose("1a0jxh", this.correlationId), await this.navigationClient.navigateExternal(e, t);
				return;
			} else {
				this.logger.verbose("09k5h5", this.correlationId);
				return;
			}
			else {
				this.logger.verbose("0klwf7", this.correlationId), await this.navigationClient.navigateExternal(e, t);
				return;
			}
		} else throw this.logger.info("0rlh4e", this.correlationId), R(Us);
	}
	async logout(e) {
		this.logger.verbose("1rkurh", this.correlationId);
		let t = this.initializeLogoutRequest(e), n = $(U.logout, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger);
		try {
			this.eventHandler.emitEvent(Q.LOGOUT_START, this.correlationId, W.Redirect, e), await Du(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, t.account);
			let r = {
				apiId: U.logout,
				timeout: this.config.system.redirectNavigationTimeout,
				noHistory: !1
			}, i = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, this.correlationId)({
				serverTelemetryManager: n,
				requestAuthority: e && e.authority,
				requestExtraQueryParameters: e?.extraQueryParameters,
				account: e && e.account || void 0
			});
			if (i.authority.protocolMode === M.OIDC) try {
				i.authority.endSessionEndpoint;
			} catch {
				if (t.account?.homeAccountId) {
					this.eventHandler.emitEvent(Q.LOGOUT_SUCCESS, this.correlationId, W.Redirect, t);
					return;
				}
			}
			t.state = Oa(this.browserCrypto, t.state || "", { interactionType: W.Redirect });
			let a = i.getLogoutUri(t);
			t.account?.homeAccountId && this.eventHandler.emitEvent(Q.LOGOUT_SUCCESS, this.correlationId, W.Redirect, t);
			let o = this.config.auth.onRedirectNavigate;
			if (typeof o == "function") if (o(a) !== !1) {
				this.logger.verbose("06v57e", this.correlationId), this.browserStorage.getInteractionInProgress() || this.browserStorage.setInteractionInProgress(!0, Es.SIGNOUT), await this.navigationClient.navigateExternal(a, r);
				return;
			} else this.browserStorage.setInteractionInProgress(!1), this.logger.verbose("0xqes1", this.correlationId);
			else {
				this.browserStorage.getInteractionInProgress() || this.browserStorage.setInteractionInProgress(!0, Es.SIGNOUT), await this.navigationClient.navigateExternal(a, r);
				return;
			}
		} catch (e) {
			throw e instanceof S && (e.setCorrelationId(this.correlationId), n.cacheFailedRequest(e)), this.eventHandler.emitEvent(Q.LOGOUT_FAILURE, this.correlationId, W.Redirect, null, e), this.eventHandler.emitEvent(Q.LOGOUT_END, this.correlationId, W.Redirect), e;
		}
		this.eventHandler.emitEvent(Q.LOGOUT_END, this.correlationId, W.Redirect);
	}
	getRedirectStartPage(e) {
		let t = e || window.location.href;
		return A.getAbsoluteUrl(t, Sl());
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_handler/SilentHandler.mjs
async function Td(e, t, n, r) {
	if (!e) throw n.info("1l7hyp", r), R(Us);
	return P(Od, Uo, n, t, r)(e);
}
async function Ed(e, t, n, r, i) {
	let a = kd();
	if (!a.contentDocument) throw "No document associated with iframe!";
	return (await rd(a.contentDocument, e, t, n, r, i)).submit(), a;
}
async function Dd(e, t, n, r, i) {
	let a = kd();
	if (!a.contentDocument) throw "No document associated with iframe!";
	return (await nd(a.contentDocument, e, t, n, r, i)).submit(), a;
}
function Od(e) {
	let t = kd();
	return t.src = e, t;
}
function kd() {
	let e = document.createElement("iframe");
	return e.className = "msalSilentIframe", e.style.visibility = "hidden", e.style.position = "absolute", e.style.width = e.style.height = "0", e.style.border = "0", e.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms"), e.setAttribute("allow", "local-network-access *"), document.body.appendChild(e), e;
}
function Ad(e) {
	document.body === e.parentNode && document.body.removeChild(e);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/interaction_client/SilentIframeClient.mjs
var jd = class extends ju {
	constructor(e, t, n, r, i, a, o, s, c, l, u) {
		super(e, t, n, r, i, a, s, l, u), this.apiId = o, this.nativeStorage = c;
	}
	async acquireToken(e) {
		!e.loginHint && !e.sid && (!e.account || !e.account.username) && this.logger.warning("1kl318", this.correlationId);
		let t = { ...e };
		t.prompt ? t.prompt !== v.NONE && t.prompt !== v.NO_SESSION && (this.logger.warning("0bmctg", this.correlationId), t.prompt = v.NONE) : t.prompt = v.NONE;
		let n = await F(Mu, Ko, this.logger, this.performanceClient, this.correlationId)(t, W.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
		return n.platformBroker = xd(this.config, this.logger, this.correlationId, this.platformAuthProvider, n.authenticationScheme), jl(n.authority), this.config.system.protocolMode === M.EAR ? this.executeEarFlow(n) : this.executeCodeFlow(n);
	}
	async executeCodeFlow(e) {
		let t, n = $(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger);
		try {
			return t = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, e.correlationId)({
				serverTelemetryManager: n,
				requestAuthority: e.authority,
				requestAzureCloudOptions: e.azureCloudOptions,
				requestExtraQueryParameters: e.extraQueryParameters,
				account: e.account
			}), await F(this.silentTokenHelper.bind(this), Bo, this.logger, this.performanceClient, e.correlationId)(t, e);
		} catch (r) {
			if (r instanceof S && (r.setCorrelationId(this.correlationId), n.cacheFailedRequest(r)), !t || !(r instanceof S) || r.errorCode !== z.INVALID_GRANT_ERROR) throw r;
			return this.performanceClient.addFields({ retryError: r.errorCode }, this.correlationId), await F(this.silentTokenHelper.bind(this), Bo, this.logger, this.performanceClient, this.correlationId)(t, e);
		}
	}
	async executeEarFlow(e) {
		let { correlationId: t, authority: n, azureCloudOptions: r, extraQueryParameters: i, account: a } = e, o = await F(Eu, Mo, this.logger, this.performanceClient, t)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, n, r, i, a), s = await F(nl, ys, this.logger, this.performanceClient, t)(), c = await F(ld, cs, this.logger, this.performanceClient, t)(this.performanceClient, this.logger, t), l = {
			...e,
			earJwk: s,
			codeChallenge: c.challenge
		}, u = await F(Dd, Vo, this.logger, this.performanceClient, t)(this.config, o, l, this.logger, this.performanceClient), d = this.config.auth.OIDCOptions.responseMode, f;
		try {
			f = await F(xl, Ho, this.logger, this.performanceClient, t)(this.config.system.iframeBridgeTimeout, this.logger, this.browserCrypto, e, this.performanceClient, this.config.experimental);
		} finally {
			P(Ad, os, this.logger, this.performanceClient, t)(u);
		}
		let p = P(Pu, es, this.logger, this.performanceClient, t)(f, d, this.logger, this.correlationId);
		if (!p.ear_jwe && p.code) {
			let n = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, t)({
				serverTelemetryManager: $(this.apiId, this.config.auth.clientId, t, this.browserStorage, this.logger),
				requestAuthority: e.authority,
				requestAzureCloudOptions: e.azureCloudOptions,
				requestExtraQueryParameters: e.extraQueryParameters,
				account: e.account,
				authority: o
			});
			return F(od, Qo, this.logger, this.performanceClient, t)(l, p, c.verifier, this.apiId, this.config, n, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
		} else return F(sd, Xo, this.logger, this.performanceClient, t)(l, p, this.apiId, this.config, o, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
	}
	async verifySso(e) {
		let t = { ...e };
		t.prompt ||= v.NONE;
		let n = await F(Mu, Ko, this.logger, this.performanceClient, this.correlationId)(t, W.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId), r = await F(this.createAuthCodeClient.bind(this), Wo, this.logger, this.performanceClient, this.correlationId)({
			serverTelemetryManager: $(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger),
			requestAuthority: n.authority,
			requestAzureCloudOptions: n.azureCloudOptions,
			requestExtraQueryParameters: n.extraQueryParameters,
			account: n.account
		}), { serverParams: i } = await this.silentAuthorizeHelper(r, n), a = n.correlationId;
		return ao(i, n.state), i.code ? (this.logger.verbose("0kkkcj", a), !0) : (this.logger.warning("0y34ti", a), !1);
	}
	logout() {
		return Promise.reject(R(ic));
	}
	async silentTokenHelper(e, t) {
		let { serverParams: n, pkceCodes: r } = await this.silentAuthorizeHelper(e, t);
		return F(od, Qo, this.logger, this.performanceClient, t.correlationId)(t, n, r.verifier, this.apiId, this.config, e, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
	}
	async silentAuthorizeHelper(e, t) {
		let n = t.correlationId, r = await F(ld, cs, this.logger, this.performanceClient, n)(this.performanceClient, this.logger, n), i = {
			...t,
			codeChallenge: r.challenge
		}, a;
		if (t.httpMethod === fe.POST) a = await F(Ed, Vo, this.logger, this.performanceClient, n)(this.config, e.authority, i, this.logger, this.performanceClient);
		else {
			let t = await F(td, $i, this.logger, this.performanceClient, n)(this.config, e.authority, i, this.logger, this.performanceClient);
			a = await F(Td, Vo, this.logger, this.performanceClient, n)(t, this.performanceClient, this.logger, n);
		}
		let o = this.config.auth.OIDCOptions.responseMode, s;
		try {
			s = await F(xl, Ho, this.logger, this.performanceClient, n)(this.config.system.iframeBridgeTimeout, this.logger, this.browserCrypto, t, this.performanceClient, this.config.experimental);
		} finally {
			P(Ad, os, this.logger, this.performanceClient, n)(a);
		}
		return {
			serverParams: P(Pu, es, this.logger, this.performanceClient, n)(s, o, this.logger, this.correlationId),
			pkceCodes: r,
			silentRequest: i
		};
	}
}, Md = class extends ju {
	async acquireToken(e) {
		let t = await F(Ou, Lo, this.logger, this.performanceClient, e.correlationId)(e, this.config, this.performanceClient, this.logger, this.correlationId), n = {
			...e,
			...t
		};
		e.redirectUri && (n.redirectUri = Tu(e.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId));
		let r = $(U.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger), i = await this.createRefreshTokenClient({
			serverTelemetryManager: r,
			authorityUrl: n.authority,
			azureCloudOptions: n.azureCloudOptions,
			account: n.account
		});
		return F(i.acquireTokenByRefreshToken.bind(i), Fo, this.logger, this.performanceClient, e.correlationId)(n, U.acquireTokenSilent_silentFlow).catch((e) => {
			throw e.setCorrelationId(this.correlationId), r.cacheFailedRequest(e), e;
		});
	}
	logout() {
		return Promise.reject(R(ic));
	}
	async createRefreshTokenClient(e) {
		return new $a(await F(this.getClientConfiguration.bind(this), Go, this.logger, this.performanceClient, this.correlationId)({
			serverTelemetryManager: e.serverTelemetryManager,
			requestAuthority: e.authorityUrl,
			requestAzureCloudOptions: e.azureCloudOptions,
			requestExtraQueryParameters: e.extraQueryParameters,
			account: e.account
		}), this.performanceClient);
	}
}, Nd = class extends Za {
	constructor(e, t) {
		super(e, t), this.includeRedirectUri = !1;
	}
}, Pd = class extends ju {
	constructor(e, t, n, r, i, a, o, s, c, l) {
		super(e, t, n, r, i, a, s, c, l), this.apiId = o;
	}
	async acquireToken(e) {
		if (!e.code) throw R(hc);
		let t = await F(Mu, Ko, this.logger, this.performanceClient, this.correlationId)(e, W.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId), n = $(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger);
		try {
			let r = {
				...t,
				code: e.code
			}, i = new Nd(await F(this.getClientConfiguration.bind(this), Go, this.logger, this.performanceClient, this.correlationId)({
				serverTelemetryManager: n,
				requestAuthority: t.authority,
				requestAzureCloudOptions: t.azureCloudOptions,
				requestExtraQueryParameters: t.extraQueryParameters,
				account: t.account
			}), this.performanceClient);
			this.logger.verbose("1uic5e", this.correlationId);
			let a = new Iu(i, this.browserStorage, r, this.logger, this.performanceClient);
			return await F(a.handleCodeResponseFromServer.bind(a), ea, this.logger, this.performanceClient, this.correlationId)({
				code: e.code,
				msgraph_host: e.msGraphHost,
				cloud_graph_host_name: e.cloudGraphHostName,
				cloud_instance_host_name: e.cloudInstanceHostName
			}, t, this.apiId, !1);
		} catch (e) {
			throw e instanceof S && (e.setCorrelationId(this.correlationId), n.cacheFailedRequest(e)), e;
		}
	}
	logout() {
		return Promise.reject(R(ic));
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/utils/MsalFrameStatsUtils.mjs
function Fd(e, t, n, r) {
	let i = window.msal?.clientIds || [], a = i.length, o = i.filter((t) => t === e).length;
	o > 1 && n.warning("1e88vg", r), t.add({
		msalInstanceCount: a,
		sameClientIdInstanceCount: o
	});
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/controllers/StandardController.mjs
function Id(e, t, n, r) {
	try {
		kl(e), lo(n.auth.isMcp, r);
	} catch (e) {
		throw t.end({ success: !1 }, e, r.account), e;
	}
}
var Ld = class e {
	constructor(e) {
		this.operatingContext = e, this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment(), this.config = e.getConfig(), this.initialized = !1, this.logger = this.operatingContext.getLogger(), this.networkClient = this.config.system.networkClient, this.navigationClient = this.config.system.navigationClient, this.redirectResponse = /* @__PURE__ */ new Map(), this.hybridAuthCodeResponses = /* @__PURE__ */ new Map(), this.performanceClient = this.config.telemetry.client, this.browserCrypto = this.isBrowserEnvironment ? new Il(this.logger, this.performanceClient) : Cr, this.eventHandler = new Cu(this.logger), this.browserStorage = this.isBrowserEnvironment ? new hu(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, Ya(this.config.auth)) : _u(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
		let t = {
			cacheLocation: V.MemoryStorage,
			cacheRetentionDays: 5
		};
		this.nativeInternalStorage = new hu(this.config.auth.clientId, t, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler), this.activeSilentTokenRequests = /* @__PURE__ */ new Map(), this.trackStateChange = this.trackStateChange.bind(this), this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
	}
	static async createController(t, n) {
		let r = new e(t);
		return await r.initialize(n), r;
	}
	trackStateChange(e, t) {
		e && (t.type === "visibilitychange" ? (this.logger.info("16v6hv", e), this.performanceClient.incrementFields({ visibilityChangeCount: 1 }, e)) : t.type === "online" ? (this.logger.info("0zirfd", e), this.performanceClient.incrementFields({ onlineStatusChangeCount: 1 }, e)) : t.type === "offline" && (this.logger.info("1xk9ef", e), this.performanceClient.incrementFields({ onlineStatusChangeCount: 1 }, e)));
	}
	async initialize(e) {
		let t = this.getRequestCorrelationId(e);
		if (this.logger.trace("1f7joy", t), this.initialized) {
			this.logger.info("061m5x", t);
			return;
		}
		if (!this.isBrowserEnvironment) {
			this.logger.info("19fvpi", t), this.initialized = !0, this.eventHandler.emitEvent(Q.INITIALIZE_END, t);
			return;
		}
		let n = this.config.system.allowPlatformBroker, r = this.performanceClient.startMeasurement(Wl, t);
		if (this.eventHandler.emitEvent(Q.INITIALIZE_START, t), this.logMultipleInstances(r, t), r.add({ isMcp: this.config.auth.isMcp }), await F(this.browserStorage.initialize.bind(this.browserStorage), zo, this.logger, this.performanceClient, t)(t), n) try {
			this.platformAuthProvider = await bd(this.logger, this.performanceClient, t, this.config.system.nativeBrokerHandshakeTimeout, this.config.experimental.allowPlatformBrokerWithDOM);
		} catch (e) {
			this.logger.verbose(e, t);
		}
		this.config.cache.cacheLocation === V.LocalStorage && this.eventHandler.subscribeCrossTab(), !this.config.system.navigatePopups && await this.preGeneratePkceCodes(t), this.initialized = !0, this.eventHandler.emitEvent(Q.INITIALIZE_END, t), r.end({
			allowPlatformBroker: n,
			success: !0
		});
	}
	async handleRedirectPromise(e) {
		if (this.logger.verbose("02l8bm", ""), Ol(this.initialized), this.isBrowserEnvironment) {
			let t = e?.hash || "", n = this.redirectResponse.get(t);
			return n === void 0 ? (n = this.handleRedirectPromiseInternal(e), this.redirectResponse.set(t, n), this.logger.verbose("1wn9kp", "")) : this.logger.verbose("0w0gm3", ""), n;
		}
		return this.logger.verbose("12xi63", ""), null;
	}
	async handleRedirectPromiseInternal(e) {
		if (!this.browserStorage.isInteractionInProgress(!0)) return this.logger.info("0le6uv", ""), null;
		if (this.browserStorage.getInteractionInProgress()?.type === Es.SIGNOUT) return this.logger.verbose("1ywcv2", ""), this.browserStorage.setInteractionInProgress(!1), Promise.resolve(null);
		let t = this.getAllAccounts(), n = this.browserStorage.getCachedNativeRequest(), r = n && !e?.hash, i, a, o;
		try {
			if (r && this.platformAuthProvider) {
				let e = n?.correlationId || "";
				this.eventHandler.emitEvent(Q.HANDLE_REDIRECT_START, e, W.Redirect), i = this.performanceClient.startMeasurement(Hl, e), this.logger.trace("12v7is", e), i.add({ isPlatformBrokerRequest: !0 });
				let t = new Xu(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, U.handleRedirectPromise, this.performanceClient, this.platformAuthProvider, n.accountId, this.nativeInternalStorage, n.correlationId);
				a = F(t.handleRedirectPromise.bind(t), is, this.logger, this.performanceClient, i.event.correlationId)();
			} else {
				let [t, n] = this.browserStorage.getCachedRequest("");
				o = t;
				let r = t.correlationId;
				this.eventHandler.emitEvent(Q.HANDLE_REDIRECT_START, r, W.Redirect), i = this.performanceClient.startMeasurement(Hl, r), this.logger.trace("0znzs5", r);
				let s = this.createRedirectClient(r);
				a = F(s.handleRedirectPromise.bind(s), rs, this.logger, this.performanceClient, i.event.correlationId)(t, n, i, e);
			}
		} catch (e) {
			throw this.browserStorage.resetRequestCache(""), e;
		}
		return a.then((e) => (e ? (this.browserStorage.resetRequestCache(e.correlationId), this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_SUCCESS, e.correlationId, W.Redirect, e), this.logger.verbose("0ui8f5", e.correlationId), t.length < this.getAllAccounts().length && (this.eventHandler.emitEvent(Q.LOGIN_SUCCESS, e.correlationId, W.Redirect, e.account), this.logger.verbose("16im3l", e.correlationId)), i.end({ success: !0 }, void 0, e.account), this.verifySsoCapability(o, W.Redirect)) : i.event.errorCode ? i.end({ success: !1 }, void 0) : i.discard(), this.eventHandler.emitEvent(Q.HANDLE_REDIRECT_END, i.event.correlationId, W.Redirect), e)).catch((e) => {
			this.browserStorage.resetRequestCache(i.event.correlationId);
			let t = e;
			throw this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, i.event.correlationId, W.Redirect, null, t), this.eventHandler.emitEvent(Q.HANDLE_REDIRECT_END, i.event.correlationId, W.Redirect), i.end({ success: !1 }, t), e;
		});
	}
	async acquireTokenRedirect(e) {
		let t = this.getRequestCorrelationId(e);
		this.logger.verbose("0os66p", t);
		let n = this.performanceClient.startMeasurement(Vl, t);
		n.add({ scenarioId: e.scenarioId });
		let r = this.config.auth.onRedirectNavigate;
		this.config.auth.onRedirectNavigate = (t) => {
			let i = typeof r == "function" ? r(t) : void 0;
			return n.add({ navigateCallbackResult: i !== !1 }), n.event = n.end({ success: !0 }, void 0, e.account) || n.event, i;
		};
		try {
			Al(this.initialized, this.config), lo(this.config.auth.isMcp, e), this.browserStorage.setInteractionInProgress(!0, Es.SIGNIN), this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_START, t, W.Redirect, e);
			let r;
			if (this.platformAuthProvider && this.canUsePlatformBroker(e)) {
				let i = new Xu(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, U.acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(e), this.nativeInternalStorage, t);
				r = F(i.acquireTokenRedirect.bind(i), Po, this.logger, this.performanceClient, t)(e, n).catch((r) => {
					if (n.add({
						brokerErrorName: r.name,
						brokerErrorCode: r.errorCode
					}), r instanceof Ku && qu(r)) return this.platformAuthProvider = void 0, this.createRedirectClient(t).acquireToken(e);
					if (r instanceof I) return this.logger.verbose("1ipyz4", t), this.createRedirectClient(t).acquireToken(e);
					throw r;
				});
			} else r = this.createRedirectClient(t).acquireToken(e);
			return await r;
		} catch (r) {
			throw this.browserStorage.resetRequestCache(t), n.event.status === 2 ? this.performanceClient.startMeasurement(Hl, t).end({ success: !1 }, r, e.account) : n.end({ success: !1 }, r, e.account), this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, t, W.Redirect, null, r), r;
		}
	}
	acquireTokenPopup(e) {
		let t = this.getRequestCorrelationId(e), n = this.performanceClient.startMeasurement(Bl, t);
		n.add({ scenarioId: e.scenarioId });
		try {
			this.logger.verbose("0ch87b", t), Id(this.initialized, n, this.config, e), this.browserStorage.setInteractionInProgress(!0, Es.SIGNIN, e.overrideInteractionInProgress, t);
		} catch (e) {
			return Promise.reject(e);
		}
		let r = this.getAllAccounts();
		this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_START, t, W.Popup, e);
		let i, a = this.getPreGeneratedPkceCodes(t);
		return this.canUsePlatformBroker(e) ? (n.add({ isPlatformBrokerRequest: !0 }), i = this.acquireTokenNative({
			...e,
			correlationId: t
		}, U.acquireTokenPopup).then((e) => (n.end({
			success: !0,
			isNativeBroker: !0
		}, void 0, e.account), e)).catch((r) => {
			if (n.add({
				brokerErrorName: r.name,
				brokerErrorCode: r.errorCode
			}), r instanceof Ku && qu(r)) return this.platformAuthProvider = void 0, this.createPopupClient(t).acquireToken(e, a);
			if (r instanceof I) return this.logger.verbose("0yy5fw", t), this.createPopupClient(t).acquireToken(e, a);
			throw r;
		})) : i = this.createPopupClient(t).acquireToken(e, a), i.then((i) => {
			let a = r.length < this.getAllAccounts().length;
			return this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_SUCCESS, t, W.Popup, i), a && this.eventHandler.emitEvent(Q.LOGIN_SUCCESS, t, W.Popup, i.account), n.end({
				success: !0,
				accessTokenSize: i.accessToken.length,
				idTokenSize: i.idToken.length
			}, void 0, i.account), this.verifySsoCapability(e, W.Popup), i;
		}).catch((r) => (this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, t, W.Popup, null, r), n.end({ success: !1 }, r, e.account), Promise.reject(r))).finally(async () => {
			this.browserStorage.setInteractionInProgress(!1), this.config.system.navigatePopups || await this.preGeneratePkceCodes(t);
		});
	}
	trackStateChangeWithMeasurement(e) {
		let t = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
		t && (e.type === "visibilitychange" ? (this.logger.info("0yzimq", t.event.correlationId), t.increment({ visibilityChangeCount: 1 })) : e.type === "online" ? (this.logger.info("1caf53", t.event.correlationId), t.increment({ onlineStatusChangeCount: 1 })) : e.type === "offline" && (this.logger.info("0fdyk7", t.event.correlationId), t.increment({ onlineStatusChangeCount: 1 })));
	}
	addStateChangeListeners(e) {
		document.addEventListener("visibilitychange", e), window.addEventListener("online", e), window.addEventListener("offline", e);
	}
	removeStateChangeListeners(e) {
		document.removeEventListener("visibilitychange", e), window.removeEventListener("online", e), window.removeEventListener("offline", e);
	}
	getCachedSsoCapable() {
		try {
			let e = window.localStorage.getItem($l);
			if (e) {
				let t = JSON.parse(e);
				if (t && typeof t.ssoCapable == "boolean" && t.expiresOn && Date.now() < t.expiresOn) return t.ssoCapable;
			}
		} catch {}
	}
	verifySsoCapability(e, t) {
		if (!this.config.auth.verifySSO) return;
		let n = $l;
		if (this.getCachedSsoCapable() !== void 0) {
			this.logger.verbose("13poou", "");
			return;
		}
		let r = Zc(), i = this.performanceClient.startMeasurement(Kl, r);
		i.add({ "ext.interactionType": t }), this.logger.verbose("0pbr0i", r), setTimeout(() => {
			let t = {
				...e,
				correlationId: r
			};
			this.createSilentIframeClient(r).verifySso(t).then((e) => {
				this.logger.verbose("1gd1iv", r);
				try {
					let t = JSON.stringify({
						ssoCapable: e,
						expiresOn: Date.now() + 864e5
					});
					window.localStorage.setItem(n, t);
				} catch {
					this.logger.warning("18lmoj", r);
				}
				i.end({
					fromCache: !1,
					success: e
				}, void 0);
			}).catch((e) => {
				this.logger.warning("05g83w", r);
				try {
					window.localStorage.removeItem(n);
				} catch {
					this.logger.warning("0nlf9q", r);
				}
				i.end({
					fromCache: !1,
					success: !1
				}, e);
			});
		}, 0);
	}
	async ssoSilent(e) {
		let t = this.getRequestCorrelationId(e), n = {
			...e,
			correlationId: t
		};
		this.ssoSilentMeasurement = this.performanceClient.startMeasurement(Ul, t), this.ssoSilentMeasurement?.add({
			scenarioId: e.scenarioId,
			ssoCapable: this.getCachedSsoCapable()
		}), Id(this.initialized, this.ssoSilentMeasurement, this.config, n), this.ssoSilentMeasurement?.increment({
			visibilityChangeCount: 0,
			onlineStatusChangeCount: 0
		}), this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
		let r = this.getAllAccounts();
		this.logger.verbose("0w1b45", t), this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_START, t, W.Silent, n);
		let i;
		return this.canUsePlatformBroker(n) ? (this.ssoSilentMeasurement?.add({ isPlatformBrokerRequest: !0 }), i = this.acquireTokenNative(n, U.ssoSilent).catch((e) => {
			if (this.ssoSilentMeasurement?.add({
				brokerErrorName: e.name,
				brokerErrorCode: e.errorCode
			}), e instanceof Ku && qu(e)) return this.platformAuthProvider = void 0, this.createSilentIframeClient(n.correlationId).acquireToken(n);
			throw e;
		})) : i = this.createSilentIframeClient(n.correlationId).acquireToken(n), i.then((e) => {
			let n = r.length < this.getAllAccounts().length;
			return this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_SUCCESS, t, W.Silent, e), n && this.eventHandler.emitEvent(Q.LOGIN_SUCCESS, t, W.Silent, e.account), this.ssoSilentMeasurement?.end({
				success: !0,
				isNativeBroker: e.fromPlatformBroker,
				accessTokenSize: e.accessToken.length,
				idTokenSize: e.idToken.length
			}, void 0, e.account), e;
		}).catch((n) => {
			throw this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, t, W.Silent, null, n), this.ssoSilentMeasurement?.end({ success: !1 }, n, e.account), n;
		}).finally(() => {
			this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
		});
	}
	async acquireTokenByCode(e) {
		let t = this.getRequestCorrelationId(e);
		this.logger.trace("0ch6ga", t);
		let n = this.performanceClient.startMeasurement(zl, t);
		Id(this.initialized, n, this.config, e), this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_START, t, W.Silent, e), n.add({ scenarioId: e.scenarioId });
		try {
			if (e.code && e.nativeAccountId) throw R(_c);
			if (e.code) {
				let r = e.code, i = this.hybridAuthCodeResponses.get(r);
				return i ? (this.logger.verbose("0qgp28", t), n.discard()) : (this.logger.verbose("06eh73", t), i = this.acquireTokenByCodeAsync({
					...e,
					correlationId: t
				}).then((e) => (this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_SUCCESS, t, W.Silent, e), this.hybridAuthCodeResponses.delete(r), n.end({
					success: !0,
					accessTokenSize: e.accessToken.length,
					idTokenSize: e.idToken.length
				}, void 0, e.account), e)).catch((e) => {
					throw this.hybridAuthCodeResponses.delete(r), this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, t, W.Silent, null, e), n.end({ success: !1 }, e), e;
				}), this.hybridAuthCodeResponses.set(r, i)), await i;
			} else if (e.nativeAccountId) if (this.canUsePlatformBroker(e, e.nativeAccountId)) {
				n.add({ isPlatformBrokerRequest: !0 });
				let r = await this.acquireTokenNative({
					...e,
					correlationId: t
				}, U.acquireTokenByCode, e.nativeAccountId).catch((e) => {
					throw n.add({
						brokerErrorName: e.name,
						brokerErrorCode: e.errorCode
					}), e instanceof Ku && qu(e) && (this.platformAuthProvider = void 0), e;
				});
				return n.end({ success: !0 }, void 0, r.account), r;
			} else throw R(yc);
			else throw R(gc);
		} catch (e) {
			throw this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, t, W.Silent, null, e), n.end({ success: !1 }, e), e;
		}
	}
	async acquireTokenByCodeAsync(e) {
		let t = this.getRequestCorrelationId(e);
		return this.logger.trace("10d9hy", t), this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement(ns, t), this.acquireTokenByCodeAsyncMeasurement?.increment({
			visibilityChangeCount: 0,
			onlineStatusChangeCount: 0
		}), this.addStateChangeListeners(this.trackStateChangeWithMeasurement), await this.createSilentAuthCodeClient(t).acquireToken(e).then((e) => (this.acquireTokenByCodeAsyncMeasurement?.end({
			success: !0,
			fromCache: e.fromCache
		}), e)).catch((e) => {
			throw this.acquireTokenByCodeAsyncMeasurement?.end({ success: !1 }, e), e;
		}).finally(() => {
			this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
		});
	}
	async acquireTokenFromCache(e, t) {
		switch (t) {
			case K.Default:
			case K.AccessToken:
			case K.AccessTokenAndRefreshToken:
				let t = this.createSilentCacheClient(e.correlationId);
				return F(t.acquireToken.bind(t), Oo, this.logger, this.performanceClient, e.correlationId)(e);
			default: throw T(Cn);
		}
	}
	async acquireTokenByRefreshToken(e, t) {
		switch (t) {
			case K.Default:
			case K.AccessTokenAndRefreshToken:
			case K.RefreshToken:
			case K.RefreshTokenAndNetwork:
				let t = this.createSilentRefreshClient(e.correlationId);
				return F(t.acquireToken.bind(t), jo, this.logger, this.performanceClient, e.correlationId)(e);
			default: throw T(Cn);
		}
	}
	async acquireTokenBySilentIframe(e) {
		let t = this.createSilentIframeClient(e.correlationId);
		return F(t.acquireToken.bind(t), ko, this.logger, this.performanceClient, e.correlationId)(e);
	}
	async logoutRedirect(e) {
		let t = this.getRequestCorrelationId(e);
		return Al(this.initialized, this.config), this.browserStorage.setInteractionInProgress(!0, Es.SIGNOUT), this.createRedirectClient(t).logout(e);
	}
	logoutPopup(e) {
		try {
			let t = this.getRequestCorrelationId(e);
			return kl(this.initialized), this.browserStorage.setInteractionInProgress(!0, Es.SIGNOUT), this.createPopupClient(t).logout(e).finally(() => {
				this.browserStorage.setInteractionInProgress(!1);
			});
		} catch (e) {
			return Promise.reject(e);
		}
	}
	async clearCache(e) {
		if (!this.isBrowserEnvironment) return;
		let t = this.getRequestCorrelationId(e);
		return this.createSilentCacheClient(t).logout(e);
	}
	getAllAccounts(e) {
		return vu(this.logger, this.browserStorage, this.isBrowserEnvironment, this.getRequestCorrelationId(), e);
	}
	getAccount(e) {
		return yu(e, this.logger, this.browserStorage, this.getRequestCorrelationId());
	}
	setActiveAccount(e) {
		bu(e, this.browserStorage, this.getRequestCorrelationId());
	}
	getActiveAccount() {
		return xu(this.browserStorage, this.getRequestCorrelationId());
	}
	async hydrateCache(e, t) {
		this.logger.verbose("16jycr", e.correlationId);
		let n = oi(e.account, e.cloudGraphHostName, e.msGraphHost);
		if (await this.browserStorage.setAccount(n, e.correlationId, Rr(e.idTokenClaims), U.hydrateCache), e.fromPlatformBroker) {
			this.logger.verbose("1i5atf", e.correlationId);
			let n = ki(e.account.homeAccountId, e.account.environment, e.idToken, this.config.auth.clientId, e.tenantId), r = Ai(e.account.homeAccountId, e.account.environment, e.accessToken, this.config.auth.clientId, e.tenantId, e.scopes.join(" "), e.expiresOn ? wi(e.expiresOn) : 0, e.extExpiresOn ? wi(e.extExpiresOn) : 0, q, void 0, e.tokenType, void 0, t.sshKid);
			t.resource && (r.resource = t.resource);
			let i = Rr(e.idTokenClaims);
			await this.browserStorage.setIdTokenCredential(n, e.correlationId, i), await this.nativeInternalStorage.setAccessTokenCredential(r, e.correlationId, i);
		} else return this.browserStorage.hydrateCache(e, t);
	}
	async acquireTokenNative(e, t, n, r) {
		let i = this.getRequestCorrelationId(e);
		if (this.logger.trace("0b9y3p", i), !this.platformAuthProvider) throw R(Sc);
		let a = new Xu(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, t, this.performanceClient, this.platformAuthProvider, n || this.getNativeAccountId(e), this.nativeInternalStorage, i);
		return F(a.acquireToken.bind(a), No, this.logger, this.performanceClient, i)(e, r);
	}
	canUsePlatformBroker(e, t) {
		let n = this.getRequestCorrelationId(e);
		if (this.logger.trace("1n9lbl", n), !this.platformAuthProvider) return this.logger.trace("0vnu11", n), !1;
		if (!xd(this.config, this.logger, n, this.platformAuthProvider, e.authenticationScheme)) return this.logger.trace("0yoy1g", n), !1;
		if (e.prompt) switch (e.prompt) {
			case v.NONE:
			case v.CONSENT:
			case v.LOGIN:
				this.logger.trace("0vdv8e", n);
				break;
			default: return this.logger.trace("0pdzw6", n), !1;
		}
		return !t && !this.getNativeAccountId(e) ? (this.logger.trace("16lbtk", n), !1) : !0;
	}
	getNativeAccountId(e) {
		let t = e.account || this.getAccount({
			loginHint: e.loginHint,
			sid: e.sid
		}) || (!e.loginHint && !e.sid ? this.getActiveAccount() : null);
		return t && t.nativeAccountId || "";
	}
	createPopupClient(e) {
		return new Sd(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, e, this.platformAuthProvider);
	}
	createRedirectClient(e) {
		return new wd(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, e, this.platformAuthProvider);
	}
	createSilentIframeClient(e) {
		return new jd(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, U.ssoSilent, this.performanceClient, this.nativeInternalStorage, e, this.platformAuthProvider);
	}
	createSilentCacheClient(e) {
		return new Yu(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, e, this.platformAuthProvider);
	}
	createSilentRefreshClient(e) {
		return new Md(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, e, this.platformAuthProvider);
	}
	createSilentAuthCodeClient(e) {
		return new Pd(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, U.acquireTokenByCode, this.performanceClient, e, this.platformAuthProvider);
	}
	addEventCallback(e, t) {
		return this.eventHandler.addEventCallback(e, t);
	}
	removeEventCallback(e) {
		this.eventHandler.removeEventCallback(e);
	}
	addPerformanceCallback(e) {
		return Dl(), this.performanceClient.addPerformanceCallback(e);
	}
	removePerformanceCallback(e) {
		return this.performanceClient.removePerformanceCallback(e);
	}
	getLogger() {
		return this.logger;
	}
	setLogger(e) {
		this.logger = e;
	}
	initializeWrapperLibrary(e, t) {
		this.browserStorage.setWrapperMetadata(e, t);
	}
	setNavigationClient(e) {
		this.navigationClient = e;
	}
	getConfiguration() {
		return this.config;
	}
	getPerformanceClient() {
		return this.performanceClient;
	}
	isBrowserEnv() {
		return this.isBrowserEnvironment;
	}
	getRequestCorrelationId(e) {
		return e?.correlationId ? e.correlationId : this.isBrowserEnvironment ? Zc() : "";
	}
	async loginRedirect(e) {
		let t = this.getRequestCorrelationId(e);
		return this.logger.verbose("0lz9hf", t), this.acquireTokenRedirect({
			correlationId: t,
			...e || As
		});
	}
	loginPopup(e) {
		let t = this.getRequestCorrelationId(e);
		return this.logger.verbose("0qw7v5", t), this.acquireTokenPopup({
			correlationId: t,
			...e || As
		});
	}
	async acquireTokenSilent(e) {
		let t = this.getRequestCorrelationId(e), n = this.performanceClient.startMeasurement(Rl, t);
		n.add({
			cacheLookupPolicy: e.cacheLookupPolicy,
			scenarioId: e.scenarioId,
			ssoCapable: this.getCachedSsoCapable()
		}), Id(this.initialized, n, this.config, e), this.logger.verbose("0x1c4s", t);
		let r = e.account || this.getActiveAccount();
		if (!r) throw R(ac);
		return this.acquireTokenSilentDeduped(e, r, t).then((r) => (n.end({
			success: !0,
			fromCache: r.fromCache,
			accessTokenSize: r.accessToken.length,
			idTokenSize: r.idToken.length
		}, void 0, r.account), {
			...r,
			state: e.state,
			correlationId: t
		})).catch((e) => {
			throw e instanceof S && e.setCorrelationId(t), n.end({ success: !1 }, e, r), e;
		});
	}
	async acquireTokenSilentDeduped(e, t, n) {
		let r = Pa(this.config.auth.clientId, {
			...e,
			authority: e.authority || this.config.auth.authority,
			correlationId: n
		}, t.homeAccountId), i = JSON.stringify(r), a = this.activeSilentTokenRequests.get(i);
		if (a === void 0) {
			this.logger.verbose("0fcjbk", n), this.performanceClient.addFields({ deduped: !1 }, n);
			let r = F(this.acquireTokenSilentAsync.bind(this), To, this.logger, this.performanceClient, n)({
				...e,
				correlationId: n
			}, t);
			return this.activeSilentTokenRequests.set(i, r), r.finally(() => {
				this.activeSilentTokenRequests.delete(i);
			});
		} else return this.logger.verbose("1yq7nb", n), this.performanceClient.addFields({ deduped: !0 }, n), a;
	}
	async acquireTokenSilentAsync(e, t) {
		let n = (t) => this.trackStateChange(e.correlationId, t);
		this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_START, e.correlationId, W.Silent, e), e.correlationId && this.performanceClient.incrementFields({
			visibilityChangeCount: 0,
			onlineStatusChangeCount: 0
		}, e.correlationId), this.addStateChangeListeners(n);
		let r = await F(ku, Ro, this.logger, this.performanceClient, e.correlationId)(e, t, this.config, this.performanceClient, this.logger), i = e.cacheLookupPolicy || K.Default;
		return this.acquireTokenSilentNoIframe(r, i).catch(async (t) => {
			if (Rd(t, i)) {
				let n = `${t.errorCode}${t.subError ? `|${t.subError}` : ""}`;
				if (this.performanceClient.addFields({ silentRefreshReason: n }, e.correlationId), !this.activeIframeRequest) {
					let e;
					return this.activeIframeRequest = [new Promise((t) => {
						e = t;
					}), r.correlationId], this.logger.verbose("0rh08z", r.correlationId), F(this.acquireTokenBySilentIframe.bind(this), Io, this.logger, this.performanceClient, r.correlationId)(r).then((t) => (e(!0), t)).catch((t) => {
						throw e(!1), t;
					}).finally(() => {
						this.activeIframeRequest = void 0;
					});
				} else if (i !== K.Skip) {
					let [e, n] = this.activeIframeRequest;
					this.logger.verbose("1w8fso", r.correlationId);
					let a = this.performanceClient.startMeasurement(Ao, r.correlationId);
					a.add({ awaitIframeCorrelationId: n });
					let o = await e;
					if (a.end({ success: o }), o) return this.logger.verbose("0ywzzi", r.correlationId), this.acquireTokenSilentNoIframe(r, i);
					throw this.logger.info("17y14q", r.correlationId), t;
				} else return this.logger.warning("1bd4p8", r.correlationId), F(this.acquireTokenBySilentIframe.bind(this), Io, this.logger, this.performanceClient, r.correlationId)(r);
			} else throw t;
		}).then((t) => (this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_SUCCESS, e.correlationId, W.Silent, t), e.correlationId && this.performanceClient.addFields({
			fromCache: t.fromCache,
			isNativeBroker: t.fromPlatformBroker
		}, e.correlationId), t)).catch((t) => {
			throw this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_FAILURE, e.correlationId, W.Silent, null, t), t;
		}).finally(() => {
			this.removeStateChangeListeners(n);
		});
	}
	async acquireTokenSilentNoIframe(e, t) {
		return xd(this.config, this.logger, e.correlationId, this.platformAuthProvider, e.authenticationScheme) && e.account.nativeAccountId ? (this.logger.verbose("0sczo4", e.correlationId), this.performanceClient.addFields({ isPlatformBrokerRequest: !0 }, e.correlationId), this.acquireTokenNative(e, U.acquireTokenSilent_silentFlow, e.account.nativeAccountId, t).catch(async (t) => {
			throw this.performanceClient.addFields({
				brokerErrorName: t.name,
				brokerErrorCode: t.errorCode
			}, e.correlationId), t instanceof Ku && qu(t) ? (this.logger.verbose("07rkmb", e.correlationId), this.platformAuthProvider = void 0, T(Cn)) : t;
		})) : (this.logger.verbose("0ox81t", e.correlationId), t === K.AccessToken && this.logger.verbose("0fvwxe", e.correlationId), F(this.acquireTokenFromCache.bind(this), Co, this.logger, this.performanceClient, e.correlationId)(e, t).catch((n) => {
			if (t === K.AccessToken) throw n;
			return this.eventHandler.emitEvent(Q.ACQUIRE_TOKEN_NETWORK_START, e.correlationId, W.Silent, e), F(this.acquireTokenByRefreshToken.bind(this), wo, this.logger, this.performanceClient, e.correlationId)(e, t);
		}));
	}
	async preGeneratePkceCodes(e) {
		return this.logger.verbose("1x6uj6", e), this.pkceCode = await F(ld, cs, this.logger, this.performanceClient, e)(this.performanceClient, this.logger, e), Promise.resolve();
	}
	getPreGeneratedPkceCodes(e) {
		let t = this.pkceCode ? { ...this.pkceCode } : void 0;
		return this.pkceCode = void 0, t ? this.logger.verbose("12js1o", e) : this.logger.verbose("1oe9ci", e), this.performanceClient.addFields({ usePreGeneratedPkce: !!t }, e), t;
	}
	logMultipleInstances(e, t) {
		let n = this.config.auth.clientId;
		window && (window.msal = window.msal || {}, window.msal.clientIds = window.msal.clientIds || [], window.msal.clientIds.length > 0 && this.logger.verbose("1qtz3l", t), window.msal.clientIds.push(n), Fd(n, e, this.logger, t));
	}
};
function Rd(e, t) {
	let n = !(e instanceof I && e.subError !== "bad_token"), r = e.errorCode === z.INVALID_GRANT_ERROR || e.errorCode === "token_refresh_required", i = n && r || e.errorCode === "no_tokens_found" || e.errorCode === "refresh_token_expired", a = Ps.includes(t);
	return i && a;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/operatingcontext/BaseOperatingContext.mjs
var zd = class e {
	static loggerCallback(e, t) {
		switch (e) {
			case k.Error:
				console.error(t);
				return;
			case k.Info:
				console.info(t);
				return;
			case k.Verbose:
				console.debug(t);
				return;
			case k.Warning:
				console.warn(t);
				return;
			default:
				console.log(t);
				return;
		}
	}
	constructor(t) {
		this.browserEnvironment = typeof window < "u", this.config = _d(t, this.browserEnvironment);
		let n;
		try {
			n = window[V.SessionStorage];
		} catch {}
		let r = n?.getItem(Jl), i = n?.getItem(Yl)?.toLowerCase(), a = i === "true" || i !== "false" && void 0, o = { ...this.config.system.loggerOptions }, s = r && Object.keys(k).includes(r) ? k[r] : void 0;
		s && (o.loggerCallback = e.loggerCallback, o.logLevel = s), a !== void 0 && (o.piiLoggingEnabled = a), this.logger = new Ar(o, fu, pu), this.available = !1;
	}
	getConfig() {
		return this.config;
	}
	getLogger() {
		return this.logger;
	}
	isAvailable() {
		return this.available;
	}
	isBrowserEnvironment() {
		return this.browserEnvironment;
	}
}, Bd = class e extends zd {
	getModuleName() {
		return e.MODULE_NAME;
	}
	getId() {
		return e.ID;
	}
	async initialize(e) {
		return this.available = typeof window < "u", this.available;
	}
};
Bd.MODULE_NAME = "", Bd.ID = "StandardOperatingContext";
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-browser@5.11.0/node_modules/@azure/msal-browser/dist/app/PublicClientApplication.mjs
var Vd = class {
	constructor(e, t) {
		this.controller = t || new Ld(new Bd(e));
	}
	async initialize(e) {
		return this.controller.initialize(e);
	}
	async acquireTokenPopup(e) {
		return this.controller.acquireTokenPopup(e);
	}
	acquireTokenRedirect(e) {
		return this.controller.acquireTokenRedirect(e);
	}
	acquireTokenSilent(e) {
		return this.controller.acquireTokenSilent(e);
	}
	acquireTokenByCode(e) {
		return this.controller.acquireTokenByCode(e);
	}
	addEventCallback(e, t) {
		return this.controller.addEventCallback(e, t);
	}
	removeEventCallback(e) {
		return this.controller.removeEventCallback(e);
	}
	addPerformanceCallback(e) {
		return this.controller.addPerformanceCallback(e);
	}
	removePerformanceCallback(e) {
		return this.controller.removePerformanceCallback(e);
	}
	getAccount(e) {
		return this.controller.getAccount(e);
	}
	getAllAccounts(e) {
		return this.controller.getAllAccounts(e);
	}
	handleRedirectPromise(e) {
		return this.controller.handleRedirectPromise(e);
	}
	loginPopup(e) {
		return this.controller.loginPopup(e);
	}
	loginRedirect(e) {
		return this.controller.loginRedirect(e);
	}
	logoutRedirect(e) {
		return this.controller.logoutRedirect(e);
	}
	logoutPopup(e) {
		return this.controller.logoutPopup(e);
	}
	ssoSilent(e) {
		return this.controller.ssoSilent(e);
	}
	getLogger() {
		return this.controller.getLogger();
	}
	setLogger(e) {
		this.controller.setLogger(e);
	}
	setActiveAccount(e) {
		this.controller.setActiveAccount(e);
	}
	getActiveAccount() {
		return this.controller.getActiveAccount();
	}
	initializeWrapperLibrary(e, t) {
		return this.controller.initializeWrapperLibrary(e, t);
	}
	setNavigationClient(e) {
		this.controller.setNavigationClient(e);
	}
	getConfiguration() {
		return this.controller.getConfiguration();
	}
	async hydrateCache(e, t) {
		return this.controller.hydrateCache(e, t);
	}
	clearCache(e) {
		return this.controller.clearCache(e);
	}
}, Hd = {
	initialize: () => Promise.reject(J(Y)),
	acquireTokenPopup: () => Promise.reject(J(Y)),
	acquireTokenRedirect: () => Promise.reject(J(Y)),
	acquireTokenSilent: () => Promise.reject(J(Y)),
	acquireTokenByCode: () => Promise.reject(J(Y)),
	getAllAccounts: () => [],
	getAccount: () => null,
	handleRedirectPromise: () => Promise.reject(J(Y)),
	loginPopup: () => Promise.reject(J(Y)),
	loginRedirect: () => Promise.reject(J(Y)),
	logoutRedirect: () => Promise.reject(J(Y)),
	logoutPopup: () => Promise.reject(J(Y)),
	ssoSilent: () => Promise.reject(J(Y)),
	addEventCallback: () => null,
	removeEventCallback: () => {},
	addPerformanceCallback: () => "",
	removePerformanceCallback: () => !1,
	getLogger: () => {
		throw J(Y);
	},
	setLogger: () => {},
	setActiveAccount: () => {},
	getActiveAccount: () => null,
	initializeWrapperLibrary: () => {},
	setNavigationClient: () => {},
	getConfiguration: () => {
		throw J(Y);
	},
	hydrateCache: () => Promise.reject(J(Y)),
	clearCache: () => Promise.reject(J(Y))
}, Ud = class {
	static getInteractionStatusFromEvent(e, t) {
		switch (e.eventType) {
			case Q.ACQUIRE_TOKEN_START:
				if (e.interactionType === W.Redirect || e.interactionType === W.Popup) return G.AcquireToken;
				break;
			case Q.HANDLE_REDIRECT_START: return G.HandleRedirect;
			case Q.LOGOUT_START: return G.Logout;
			case Q.LOGOUT_END:
				if (t && t !== G.Logout) break;
				return G.None;
			case Q.HANDLE_REDIRECT_END:
				if (t && t !== G.HandleRedirect) break;
				return G.None;
			case Q.ACQUIRE_TOKEN_SUCCESS:
			case Q.ACQUIRE_TOKEN_FAILURE:
			case Q.RESTORE_FROM_BFCACHE:
				if (e.interactionType === W.Redirect || e.interactionType === W.Popup) {
					if (t && t !== G.AcquireToken) break;
					return G.None;
				}
				break;
		}
		return null;
	}
}, Wd = pe, Gd = {
	instance: Hd,
	inProgress: G.None,
	accounts: [],
	logger: new Ar({})
}, Kd = e.createContext(Gd);
Kd.Consumer;
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/utils/utilities.js
function qd(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Jd(e, t) {
	if (e.length !== t.length) return !1;
	let n = [...t];
	return e.every((e) => {
		let t = n.shift();
		return !e || !t ? !1 : e.homeAccountId === t.homeAccountId && e.localAccountId === t.localAccountId && e.username === t.username;
	});
}
function Yd(e, t) {
	return e.length > 0 && (t.homeAccountId || t.localAccountId || t.username) && e.filter((e) => !(t.username && t.username.toLowerCase() !== e.username.toLowerCase() || t.homeAccountId && t.homeAccountId.toLowerCase() !== e.homeAccountId.toLowerCase() || t.localAccountId && t.localAccountId.toLowerCase() !== e.localAccountId.toLowerCase()))[0] || null;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/packageMetadata.js
var Xd = "@azure/msal-react", Zd = "5.4.2", Qd = {
	UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
	EVENT: "EVENT"
}, $d = (e, t) => {
	let { type: n, payload: r } = t, i = e.inProgress;
	switch (n) {
		case Qd.UNBLOCK_INPROGRESS:
			e.inProgress === G.Startup && (i = G.None, r.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'", ""));
			break;
		case Qd.EVENT:
			let t = r.message, a = Ud.getInteractionStatusFromEvent(t, e.inProgress);
			a && (r.logger.info(`MsalProvider - '${t.eventType}' results in setting inProgress from '${e.inProgress}' to '${a}'`, ""), i = a);
			break;
		default: throw Error(`Unknown action type: ${n}`);
	}
	if (i === G.Startup) return e;
	let a = r.instance.getAllAccounts();
	return i !== e.inProgress && !Jd(a, e.accounts) ? {
		...e,
		inProgress: i,
		accounts: a
	} : i === e.inProgress ? Jd(a, e.accounts) ? e : {
		...e,
		accounts: a
	} : {
		...e,
		inProgress: i
	};
};
function ef({ instance: e, children: n }) {
	i(() => {
		e.initializeWrapperLibrary(js.React, Zd);
	}, [e]);
	let r = a(() => e.getLogger().clone(Xd, Zd), [e]), [s, c] = o($d, void 0, () => ({
		inProgress: G.Startup,
		accounts: []
	}));
	i(() => {
		let t = e.addEventCallback((t) => {
			c({
				payload: {
					instance: e,
					logger: r,
					message: t
				},
				type: Qd.EVENT
			});
		});
		return r.verbose(`MsalProvider - Registered event callback with id: '${t}'`, ""), e.initialize().then(() => {
			e.handleRedirectPromise().catch(() => {}).finally(() => {
				c({
					payload: {
						instance: e,
						logger: r
					},
					type: Qd.UNBLOCK_INPROGRESS
				});
			});
		}).catch(() => {}), () => {
			t && (r.verbose(`MsalProvider - Removing event callback '${t}'`, ""), e.removeEventCallback(t));
		};
	}, [e, r]);
	let l = {
		instance: e,
		inProgress: s.inProgress,
		accounts: s.accounts,
		logger: r
	};
	return t.createElement(Kd.Provider, { value: l }, n);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/hooks/useMsal.js
var tf = () => r(Kd);
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/hooks/useIsAuthenticated.js
function nf(e, t) {
	return t && (t.username || t.homeAccountId || t.localAccountId) ? !!Yd(e, t) : e.length > 0;
}
function rf(e) {
	let { accounts: t, inProgress: n } = tf();
	return a(() => n !== G.Startup && nf(t, e), [
		t,
		n,
		e
	]);
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/hooks/useAccount.js
function af(e, t) {
	return !t || !t.homeAccountId && !t.localAccountId && !t.username ? e.getActiveAccount() : Yd(e.getAllAccounts(), t);
}
function of(e, t) {
	if (!e || !t) return !1;
	let n = e.idTokenClaims || {}, r = t.idTokenClaims || {}, i = n.iat === r.iat && n.nonce === r.nonce;
	return e.homeAccountId === t.homeAccountId && e.localAccountId === t.localAccountId && e.username === t.username && e.tenantId === t.tenantId && e.environment === t.environment && e.nativeAccountId === t.nativeAccountId && i;
}
function sf(e) {
	let { instance: t, inProgress: r, logger: a } = tf(), [o, s] = c(() => r === G.Startup ? null : af(t, e)), l = n(() => {
		let n = af(t, e);
		s((e) => of(e, n) ? e : (a.info("useAccount - Updating account", ""), n));
	}, [
		e,
		t,
		a
	]);
	return i(() => {
		r !== G.Startup && l();
		let e = t.addEventCallback((e) => {
			(e.eventType === Q.ACTIVE_ACCOUNT_CHANGED || e.eventType === Q.LOGIN_SUCCESS && e.interactionType === W.Silent) && l();
		});
		return () => {
			e && t.removeEventCallback(e);
		};
	}, [
		l,
		r,
		t
	]), o;
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/error/ReactAuthError.js
var cf = {
	invalidInteractionType: {
		code: "invalid_interaction_type",
		desc: "The provided interaction type is invalid."
	},
	unableToFallbackToInteraction: {
		code: "unable_to_fallback_to_interaction",
		desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
	}
}, lf = class e extends S {
	constructor(t, n) {
		super(t, n), Object.setPrototypeOf(this, e.prototype), this.name = "ReactAuthError";
	}
	static createInvalidInteractionTypeError() {
		return new e(cf.invalidInteractionType.code, cf.invalidInteractionType.desc);
	}
	static createUnableToFallbackToInteractionError() {
		return new e(cf.unableToFallbackToInteraction.code, cf.unableToFallbackToInteraction.desc);
	}
};
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/hooks/useMsalAuthentication.js
function uf(e, t, r) {
	let { instance: a, inProgress: o, logger: l } = tf(), u = rf(r), d = sf(r), [[f, p], m] = c([null, null]), h = s(!0);
	i(() => (h.current = !0, () => {
		h.current = !1;
	}), []);
	let ee = s(o !== G.None);
	i(() => {
		ee.current = o !== G.None;
	}, [o]);
	let g = s(!0);
	i(() => {
		if (p) {
			g.current = !1;
			return;
		}
		if (f) {
			g.current = !1;
			return;
		}
	}, [p, f]);
	let te = n(async (n, r) => {
		let i = n || e, o = r || t;
		return (async () => {
			switch (l.verbose("useMsalAuthentication - Calling getToken", r?.correlationId || ""), i) {
				case W.Popup: return l.verbose("useMsalAuthentication - Calling loginPopup", r?.correlationId || ""), a.loginPopup(o);
				case W.Redirect: return l.verbose("useMsalAuthentication - Calling loginRedirect", r?.correlationId || ""), await a.handleRedirectPromise(), a.loginRedirect(o).then(() => null);
				case W.Silent: return l.verbose("useMsalAuthentication - Calling ssoSilent", r?.correlationId || ""), a.ssoSilent(o || {});
				default:
					let e = lf.createInvalidInteractionTypeError();
					throw h.current && m([null, e]), e;
			}
		})().then((e) => (e && h.current && m([e, null]), e)).catch((e) => {
			throw h.current && m([null, e]), e;
		});
	}, [
		a,
		e,
		t,
		l
	]), ne = n(async (n, r) => {
		let i = n || e, o;
		r ? (l.trace("useMsalAuthentication - acquireToken - Using request provided in the callback", r.correlationId || ""), o = { ...r }) : t ? (l.trace("useMsalAuthentication - acquireToken - Using request provided in the hook", t.correlationId || ""), o = {
			...t,
			scopes: t.scopes || Wd
		}) : (l.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.", ""), o = { scopes: Wd });
		let s = o.correlationId || Ml();
		return o.correlationId = s, !o.account && d && (l.trace("useMsalAuthentication - acquireToken - Attaching account to request", s), o.account = d), a.acquireTokenSilent(o).then((e) => (h.current && m([e, null]), e)).catch(async (e) => {
			if (e instanceof I) if (ee.current) {
				let e = lf.createUnableToFallbackToInteractionError();
				throw l.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.", s), h.current && m([null, e]), e;
			} else return l.error("useMsalAuthentication - Interaction required, falling back to interaction", s), te(i, o);
			throw h.current && m([null, e]), e;
		});
	}, [
		a,
		e,
		t,
		l,
		d,
		te
	]);
	return i(() => {
		g.current && o === G.None ? u ? d && (g.current = !1, l.info("useMsalAuthentication - User is authenticated, attempting to acquire token", ""), ne().catch(() => {})) : (g.current = !1, l.info("useMsalAuthentication - No user is authenticated, attempting to login", ""), te().catch(() => {})) : !d && f && m([null, null]);
	}, [
		u,
		d,
		o,
		te,
		ne,
		l
	]), {
		login: te,
		acquireToken: ne,
		result: f,
		error: p
	};
}
//#endregion
//#region ../../common/temp/node_modules/.pnpm/@azure+msal-react@5.4.2_@azure+msal-browser@5.11.0_react@19.2.7/node_modules/@azure/msal-react/dist/components/MsalAuthenticationTemplate.js
function df({ interactionType: e, username: n, homeAccountId: r, localAccountId: i, authenticationRequest: o, loadingComponent: s, errorComponent: c, children: l }) {
	let u = a(() => ({
		username: n,
		homeAccountId: r,
		localAccountId: i
	}), [
		n,
		r,
		i
	]), d = tf(), f = uf(e, o, u), p = rf(u);
	if (f.error && d.inProgress === G.None) {
		if (c) return t.createElement(c, { ...f });
		throw f.error;
	}
	return p ? t.createElement(t.Fragment, null, qd(l, f)) : s && d.inProgress !== G.None ? t.createElement(s, { ...d }) : null;
}
//#endregion
//#region src/hooks.ts
var ff = (e, n, r, i) => {
	let a = [
		"localhost",
		"127.0.0.1",
		"0.0.0.0"
	].includes(window.location.hostname);
	return t.useMemo(() => {
		let t = window.location.href.split("?")[0].split("#")[0], o = a ? t : `${window.location.origin}/auth`, s = new Vd({
			auth: {
				clientId: e,
				authority: `https://login.microsoftonline.com/${n}`,
				redirectUri: o
			},
			...i ? { cache: { cacheLocation: i } } : {}
		});
		return s.addEventCallback((e) => {
			if (e.eventType === Q.INITIALIZE_END || e.eventType === Q.ACQUIRE_TOKEN_SUCCESS) {
				let e = s.getAllAccounts()[0], t = {
					id: e?.localAccountId,
					email: e?.username,
					name: e?.name,
					roles: e?.idTokenClaims?.roles
				};
				r?.user?.id !== t?.id && r?.setUser(t), t.id && (window.DD_RUM.setUser(t), window.DD_LOGS.setUser(t), window.DD_LOGS.logger.info("User Detected"));
			}
		}), s;
	}, [
		a,
		i,
		e,
		n,
		r
	]);
};
//#endregion
export { Q as a, Cs as c, ef as i, I as l, df as n, V as o, tf as r, W as s, ff as t };

//# sourceMappingURL=hooks-J8lBBNgK.js.map